export const locale = {
general_menu_settings: 'Ճաշացանկի ընդհանուր կարգավորումներ',
  settings: {
  business_type_title: 'Ընտրեք ճաշացանկի բիզնեսի տեսակը',
  currency_label: 'Արժույթ',
  show_filter: 'Ցուցադրել ապրանքների ֆիլտրը',
  show_categories: 'Ցուցադրել ապրանքների կատեգորիաները',
  
  business_types: {
    cafe: 'Սրճարան',
    restaurant: 'Ռեստորան',
    fastfood: 'Արագ սնունդ',
    icecream: 'Հյութ և պաղպաղակ',
    sweets: 'Քաղցրավենիք և աղանդեր',
    bakery: 'Հացաբուլկեղեն'
  },
  
  custom_labels: {
    ph_menu_cafe: 'Սրճարանի մենյու',
    ph_menu_restaurant: 'Ճաշացանկ',
    ph_menu_fastfood: 'Արագ սննդի մենյու',
    ph_menu_icecream: 'Հյութեր և պաղպաղակ',
    ph_menu_sweets: 'Տորթեր և քաղցրավենիք',
    ph_menu_bakery: 'Հաց և հացամթերք',
    ph_product_list: 'Ապրանքներ',
    ph_add_order: 'Ավելացնել',
    ph_add_cart: 'Գնել',

    title: 'Անհատականացնել պիտակները (Ընտրովի)',
    subtitle: 'Փոխարինեք համակարգի լռելյայն տերմինները ձեր նախընտրած բառերով:',
    products_title: 'Ապրանքների բաժնի վերնագիր',
    ph_food_menu: 'օր.՝ Ճաշացանկ',
    ph_product_list: 'օր.՝ Ապրանքների ցանկ',
    cart_btn: 'Վճարման կոճակի տեքստ',
    ph_add_order: 'օր.՝ Ավելացնել պատվերին',
    ph_add_cart: 'օր.՝ Ավելացնել զամբյուղին'
  },

  currencies: {
    toman: 'Թոման',
    rial: 'Ռիալ'
  }
},
check_account_balance_and_try_again: 'Խնդրում ենք ստուգել ձեր հաշվի մնացորդը և կրկին փորձել',
problem_with_qr_renewal_request: 'QR կոդի երկարաձգման հարցման ընթացքում խնդիր է առաջացել',

  ERRORS: {
    PhoneIsNotValid: "Մուտքագրված հեռախոսահամարը վավեր չէ. օրինակ՝ 09101234567",
    InvalidNumber: "Մուտքագրված քանակը վավեր չէ:",
    NoSelectedLineNumber: "Խնդրում ենք ընտրել ուղարկողի գիծը:",
    EmptyText: "Խնդրում ենք մուտքագրել տեքստը:",
    UnknownError: "Անհայտ սխալ",
    TryAgain: "Խնդրում ենք մի փոքր ուշ կրկին փորձել:",
    NoAccountCharge: "Անբավարար մնացորդ",
    NoAccess: "Մուտքի իրավունք չունեք:",
    PleasebyeAPlane: "Խնդրում ենք գնել փաթեթ:",
    PleaseChargeYourAccount: "Խնդրում ենք լիցքավորել ձեր հաշիվը:",
    AccessDenied: "Մուտքը մերժված է:",
    AccessDeniedDescription:
      "Լրացուցիչ տեղեկությունների համար կապվեք աջակցության կենտրոնի հետ:",
    Error: "Սխալ",
    InvalidText: "Անվավեր տեքստ",
    InvalidTextContainsLink:
      "Միայն սպասարկման գծերը կարող են հղումներ պարունակել:",
    NoPhoneToSend: "Ուղարկելու համար համարներ չկան:",
  },
  FORMS: {
    SuccsessFullySended: "Հասկացա",
    DestinationPhone: "Ստացողի հեռախոսահամարը",
    TestDestinationPhone: "Թեստային հեռախոսահամար",
    SourceNumber: "Ուղարկողի համարը",
    Text: "Տեքստ",
    CharCount: "Նիշերի քանակը",
    FarsiCharCount: "Պարսկերեն նիշերի քանակը",
    EnglishCharCount: "Անգլերեն նիշերի քանակը",
    Send: "Ուղարկել",
    SendTime: "Ուղարկման ժամանակը",
    SendTest: "Թեստային ուղարկում",
    SendToTestNumber: "Ուղարկել թեստային համարին",
    SmsCount: "SMS-ների քանակը",
    SmsLang: "SMS-ի լեզուն",
    Add: "Ավելացնել",
    FromFile: "Ավելացնել ֆայլից",
    TestNumber: "Թեստային համար",
    Test: "Թեստ",
    ServiceRelated: "Սպասարկման",
    Price: "Սպիտակ ցուցակի ուղարկման արժեքը",
    TotalPrice: "Ընդհանուր արժեքը",
    NumbersCount: "Համարների ընդհանուր քանակը",
    BlacklistPrice: "Սև ցուցակի ուղարկման արժեքը",
    BlacklistNumbersCount: "Սև ցուցակի քանակը",
    WhitelistNumbersCount: "Սպիտակ ցուցակի քանակը",
    IrancellNumbersBlacklistCount: "Irancell-ի սև ցուցակի քանակը",
    HamrahavalNumbersBlacklistCount: "Hamrah Aval-ի սև ցուցակի քանակը",
    IrancellNumbersWhitelistCount: "Irancell-ի սպիտակ ցուցակի քանակը",
    HamrahavalNumbersWhitelistCount: "Hamrah Aval-ի սպիտակ ցուցակի քանակը",
    NumbersCountToSend: "Վավեր համարների քանակը",
    Search: "Որոնել",
    Title: "Վերնագիր",
    RequestTime: "Հարցման ժամանակը",
    RequestInformation: "Հարցման տվյալներ",
    CreateNewPhoneBook: "Ստեղծել նոր հեռախոսագիրք",
    AddPhone: "Ավելացնել համարներ",
    Remove: "Հեռացնել",
  },
  unexpected_error: "Տեղի ունեցավ անսպասելի սխալ։ Խնդրում ենք կրկին փորձել։",
  luck_wheel_name: "Հաջողության անիվի QR անունը",
  update_video: "Ավելացնել տեսանյութերի պատկերասրահ",
  edit: "Խմբագրել",
  to_top: "Վերևից",
  to_bottom: "Ներքևից",
  to_left: "Աջից ձախ",
  to_right: "Ձախից աջ",
  to_top_right: "Ներքևից աջ",
  to_top_left: "Ներքևից ձախ",
  to_bottom_right: "Վերևից աջ",
  to_bottom_left: "Վերևից ձախ",
  select_color_gradient: "Ընտրել գրադիենտ գույն",
  select_color_solid: "Ընտրել միատեսակ գույն",
  gradient_direction: "Գրադիենտի ուղղություն",
  gradient_background: "Գրադիենտ ֆոն",
  qr_downloaded_successfully: "QR-ը հաջողությամբ ներբեռնվել է:",
  logo: "Լոգո",
  qr_design_size: "QR-ի դիզայն և չափ",
  qr_eye_design: "QR-ի աչքի դիզայն",
  qr_markout: "Ելքային եզր",
  frame: "Շրջանակ",
  ready_card_samples: "Պատրաստի այցեքարտերի օրինակներ",
  ready_card_sample: "Պատրաստի այցեքարտի օրինակ",
  remove_default_info: "Հեռացնել լռելյայն տեղեկությունները",
  select_ready_card: "Ընտրել պատրաստի այցեքարտ",
  connection_code: "Կապի կոդ",
  enter_visit_card_info: "Մուտքագրեք այցեքարտի տվյալները",
  info: "Տեղեկություններ",
  select_template_design: "Ընտրել ձևանմուշի դիզայն",
  qr_address: "QR հասցե",
  visit_card_name: "Ձեր այցեքարտի անունը",
  visit_card_name_pro: "Ձեր այցեքարտի անունը",
  download_qr: "Ներբեռնել QR",
  fast_design: "Արագ դիզայն",
  professional_design: "Պրոֆեսիոնալ դիզայն",
  ai_design: "ԱԲ դիզայն",
  update_qr: "Թարմացնել QR",
  fast_design_message:
    "Դուք անցել եք արագ կոդի դիզայնին: Նախորդ դիզայնը կատարվել է այս բաժնում:",
  professional_design_message:
    "Դուք անցել եք պրոֆեսիոնալ կոդի դիզայնին: Նախորդ դիզայնը կատարվել է այս բաժնում:",
  scan_me: "Սկանավորիր ինձ",
  visit_card_edited_successfully: "Ձեր այցեքարտը հաջողությամբ խմբագրվել է:",
  customer_club_membership: "Հաճախորդների ակումբի անդամակցություն",
  qrland: "QR Land",
  dynamic: "Դինամիկ",
  about_us_text:
    "Դինամիկ QR կոդի առանձնահատկությունները:\n✔️ Անսահմանափակ խմբագրում\n✔️ Հեշտ սկանավորում\n✔️ Սկանավորման սահմանափակում\n✔️ Գաղտնաբառ ավելացնելու հնարավորություն\n✔️ Այցելուների վիճակագրության դիտում և վերլուծություն\n✔️ QR-ի գույնի և տեսքի փոփոխություն\n✔️ Տեղեկությունների և անվտանգության պահպանում\n✔️ QR-ին նկար և լոգո ավելացնելու հնարավորություն\n✔️ Բիզնեսի կարիքներին համապատասխան մասնագիտացված QR\n✔️ Սկանավորողին հղումներով և կայք տեղափոխել\n✔️ QR և կարճ հղում միասին տրամադրել\n✔️ Օգտագործելի բոլոր սոցիալական ցանցերում (օֆլայն և օնլայն)\n✔️ Ցանկացած ձևաչափով ներբեռնել\n✔️ Տպագրվել ցանկացած մակերեսի կամ չափի վրա",
  video_gallery: "Տեսագալերեա",
  address_text: "Երևան, Թումանյան 35, շենք 6",
  visit_card: "Այցեքարտ",
  qrland_system: "QR Land համակարգ",
  qrland_first_system: "Առաջին դինամիկ QR կոդ ստեղծող համակարգը",
  address: "Հասցե",
  enter_site_link: "Մուտքագրեք ցանկալի կայքի հղումը",
  instagram: "Ինստագրամ",
  enter_instagram_username: "Մուտքագրեք Ձեր օգտանունը",
  whatsapp: "WhatsApp",
  invalid_qr_address: "Մուտքագրված հասցեն ճիշտ չէ:",
  visit_card_created_successfully: "Ձեր այցեքարտը հաջողությամբ ստեղծվել է:",
  qr_creation_failed: "QR-ի ստեղծումը ձախողվել է:",
  manage_password: "Գաղտնաբառի կառավարում",
  hour_limit: "Ժամային սահման",
  scan_click_limit: "Սկան/կտտոցների սահման",
  redirect_scanner: "Սկանավորողին վերահղել",
  edit_settings_error: "Կարգավորումները խմբագրելիս սխալ է տեղի ունեցել:",
  next: "Հաջորդ",
  add: "Ավելացնել",
  header_color_settings: "Վերնագրի գույնի և տեքստի կարգավորումներ",
  select_image: "Ընտրել նկար",
  enter_qr_address: "Մուտքագրեք Ձեր QR հասցեն",
  qr_idea_title: "QR ստեղծման գաղափար",
  qr_idea: "QR գաղափար",
  qr_idea_subject: "QR ստեղծման թեմա",
  confirm_qr_idea: "Հաստատել իմ QR գաղափարը",
  scannable: "Սկանավորվում է",
  ai_sample: "Արհեստական բանականության օրինակ...",
  scan_warning:
    "Հնարավոր է բոլոր սարքերում չսկանավորվի: Եթե չի աշխատում, կրկին փորձեք:",
  ai_description:
    "Մուտքագրեք ցանկալի QR-ի նկարագրությունը, արհեստական բանականությունը կստեղծի այն:",
  attach: "Կցել",
  remaining: "Մնացած",
  qr_creation: "QR ստեղծում",
  free: "Անվճար",
  select_language_for_request: "Ընտրել լեզու հարցման տեքստի համար",
  request_text: "Հարցման տեքստ",
  request_text_placeholder: "Նկարագրեք ցանկալի QR հղումը...",
  strengthen_text: "Ուժեղացնել առկա տեքստը",
  prompt_idea: "Prompt գաղափար",
  try_again: "Կրկին փորձել",
  create_qr: "Ստեղծել QR",
  smart_qr_code: "Խելացի QR կոդ",
  regenerate_image: "Վերաստեղծել պատկերը",
  updating_qr: "QR-ը թարմացվում է...",
  copied: "Պատճենվել է",
  copy: "Պատճենել",
  print_qr: "Տպել QR",
  print_visit_card: "Տպել այցեքարտ",
  send_link: "Ուղարկել հղում",
  customer_list: "Հաճախորդների ցուցակ",
  order_list: "Պատվերների ցուցակ",
  reserved_appointments: "Ամրագրված հանդիպումներ",
  feedback: "Հետադարձ կապ",
  request_form: "Հարցման ձև",
  transfer_ownership: "Սեփականության փոխանցում",
  select_nfc_card: "Ընտրել NFC քարտ",
  created_at: "Ստեղծվել է",
  last_edit: "Վերջին խմբագրում",
  qr_card: "QR քարտ",
  viewed: "Դիտվել է",
  see_more: "Տեսնել ավելին",
  download: "Ներբեռնել",
  activate: "Ակտիվացնել",
  design: "Դիզայն",
  qr_settings: "QR կարգավորումներ",
  deactivate: "Ապաակտիվացնել",
  qr_color_size: "QR գույն և չափ",
  dots_design_color: "Կետերի դիզայն և գույն",
  eye_design_color: "Աչքի դիզայն և գույն",
  border_design_color: "Եզրագծի դիզայն և գույն",
  logo_settings: "Լոգոյի կարգավորումներ",
  download_qr_comment: "Ներբեռնել QR",
  connection_established: "Կապը հաստատվել է:",
  show_qr: "Ցուցադրել QR",
  preview: "Նախադիտում",
  user_info: "Օգտատիրոջ տվյալներ",
  sms_club_membership: "SMS ակումբի անդամակցություն",
  smart_settings: "Խելացի կարգավորումներ",
  add_audio_file: "Ավելացնել աուդիո ֆայլ",
  back: "Հետ",
  after_click_location:
    "Տեղադրության վրա սեղմելուց հետո ընտրեք Ձեր քարտեզի ծրագիրը:",
  phone_number: "Հեռախոսահամար",
  auto_display: "Ավտոմատ ցուցադրում",
  customer_club: "Հաճախորդների ակումբ",
  auto_download: "Ավտոմատ ներբեռնում",
  save: "Պահպանել",
  about_us: "Մեր մասին",
  view_more: "Տեսնել ավելին",
  view_less: "Տեսնել պակաս",
  audio_file: "Աուդիո ֆայլ",
  add_video: "Ավելացնել վիդեո",
  add_image: "Ավելացնել նկար",
  select_color: "Ընտրել գույն",
  header_color: "Վերնագրի տեքստ",
  add_social_networks: "Ավելացնել սոցիալական ցանցեր",
  format: "Ձևաչափ",
  output_size: "Ելքային չափ",
  file_type: "Ֆայլի տեսակ",
  default: "Լռելյայն",
  qr_download_error: "QR-ի ներբեռնումը ձախողվել է: Կրկին փորձեք",
  header_color_text_settings: "Վերնագրի գույնի և տեքստի կարգավորումներ",
  upload_catalog_images: "Վերբեռնել կատալոգի / բրոշյուրի նկարներ",
  delete: "Ջնջել",
  personal_domain: "Անձնական դոմեյն",
  no_domain_found: "Դոմեյն չի գտնվել:",
  enter_domain_address: "Խնդրում ենք մուտքագրել Ձեր դոմեյնի հասցեն",
  dns_setup_note: "Հիշեք, որ նախ պետք է կարգավորեք սերվերի DNS-ները:",
  attention: "Ուշադրություն: ",
  dns_setup_instruction:
    "Անձնական դոմեյն գրանցելու համար նախ կարգավորեք DNS-ները",
  and: "և",
  setup_on_domain: "Ձեր դոմեյնի վրա:",
  dns_change_time: "(DNS փոփոխությունը կարող է տևել մինչև 24 ժամ)",
  add_domain: "Ավելացնել դոմեյն",
  add_personal_domain: "Ավելացնել անձնական դոմեյն",
  min_characters: "Նվազագույն մուտքագրվող նշաններ",
  domain_format:
    "Կայքի դոմեյնը պետք է լինի https://terminalads.com կամ terminalads.com ձևաչափով:",
  invalid_domain: "Մուտքագրված դոմեյնը ճիշտ չէ:",
  domain_added_successfully: "Ձեր դոմեյնը հաջողությամբ ավելացվել է",
  invalid_dns_settings: "DNS կարգավորումները ճիշտ չեն:",
  deleted_successfully: "Հաջողությամբ ջնջվել է",
  location: "Տեղադրություն",
  save_contact: "Պահպանել կոնտակտը",
  search: "Որոնել",
  data_fetch_error: "Տվյալների ստացման սխալ:",
  error: "Սխալ",
  view_qr: "Դիտել QR",
  qr_design: "QR դիզայն",
  register: "Գրանցվել",
  terminal_ads: "Տերմինալ Գովազդ",
  manage_40_advertising_methods:
    "40 գովազդային մեթոդների միաժամանակյա կառավարում:",
  ms_khansari: "Տիկին Խանսարի",
  support: "Աջակցություն",
  comprehensive_advertising_system:
    "Առցանց գովազդի ամբողջական վերլուծության և կառավարման միակ համակարգը",
  terminal_ads_description:
    "Տերմինալ Գովազդ համակարգը հպարտանում է իր հաճախորդների և օգտատերերի հետ շարունակական և արդյունավետ կապով՝ նրանց կարիքները հասկանալու և լավագույն լուծումներ տրամադրելու համար: Մեր ամենամեծ կապիտալը մեր հավատարիմ հաճախորդներն են և օգտատերերը, իսկ հետո՝ մեր մասնագետների թիմը, որը նոր գաղափարներով և ժամանակակից տեխնոլոգիաներով օգնում է ընկերությանը:",
  please_enter_qr_address_correctly: "Խնդրում ենք ճիշտ մուտքագրել QR հասցեն:",
  server_error: "Սերվերի սխալ:",
  please_enter_your_address: "Խնդրում ենք մուտքագրել Ձեր հասցեն",
  please_enter_instagram_address: "Խնդրում ենք մուտքագրել Ձեր Instagram հասցեն",
  please_enter_whatsapp_address: "Խնդրում ենք մուտքագրել Ձեր WhatsApp հասցեն",
  enter_information: "Մուտքագրել տեղեկություններ",
  dynamic_qr: "Դինամիկ QR լինի",
  coming_soon: "Շուտով",
  qr_name: "QR անուն",
  for_default_address_leave_empty: "!Լռելյայն հասցեի համար թողեք դատարկ",
  default_address: "Լռելյայն հասցե",
  sms: "SMS",
  enter_number_without_zero: "Մուտքագրեք համարը առանց 0-ի:",
  number: "Համար",
  country_code: "Երկրի կոդ՝",
  sms_text: "SMS տեքստ",
  complete_sms_fields_correctly: "Խնդրում ենք ճիշտ լրացնել SMS դաշտերը!",
  qr_code_created_successfully: "Ձեր QR կոդը հաջողությամբ ստեղծվել է:",
  chat: "Չատ",
  call: "Զանգ",
  please_enter_username: "Խնդրում ենք մուտքագրել օգտանունը:",
  username: "Օգտանուն",
  sample_menu: "Օրինակելի մենյու",
  online_menu_name: "Ձեր առցանց մենյուի անունը",
  online_menu_name_short: "Առցանց մենյու",
  enter_menu_information: "Մուտքագրեք մենյուի տեղեկատվությունը",
  select_sample_menu: "Ընտրեք օրինակելի մենյու",
  select_ready_menu: "Ընտրեք պատրաստի մենյու",
  online_sales: "Առցանց վաճառք",
  sales_settings: "Վաճառքի կարգավորումներ",
  photo_gallery: "Լուսանկարների պատկերասրահ",
  fast_food1: "Արագ սնունդ 1",
  fast_food2: "Արագ սնունդ 2",
  products: "Ապրանքներ",
  pizzas: "Պիցցաներ",
  pizza_rust_beef: "Պիցցա տավարի խորովածով",
  italian_pizza_with_beef: "🤩 Իտալական պիցցա տավարի մսով",
  italian_pizza_dough_30cm: "Իտալական պիցցայի խմոր 30 սմ",
  "100g_shredded_beef": "100 գ տավարի մանրացված միս",
  mushroom_bell_pepper: "Սունկ, բուլղարական պղպեղ",
  black_olives: "Սև ձիթապտուղ",
  pizza_chicken_mushroom: "Պիցցա հավ և սունկ",
  classic_40cm: "🍕 Քլասիկ 40 սմ",
  fresh_tomato_sauce:
    "Թարմ լոլիկի սոուս, պանիր, հավի ֆիլե, սունկ, լեռնային ուրց",
  pizza_meat_mushroom: "Պիցցա միս և սունկ",
  meat_pizza_with_mushroom: "🥰 Պիցցա աղացած մսով և սնկով",
  pizza_vegetables: "Բուսական պիցցա",
  american_vegetable_pizza: "🍕 Ամերիկյան բուսական պիցցա",
  american_pizza_dough:
    "Ամերիկյան պիցցայի խմոր, եգիպտացորեն, սունկ, ձիթապտուղ, լոլիկ, սոխ, պղպեղ, պանիր",
  special_pizza: "Հատուկ պիցցա",
  american_special_pizza: "Ամերիկյան հատուկ պիցցա",
  pizza_bolognese: "Պիցցա Բոլոնեզե",
  one_person_23cm: "(1 անձ) Պիցցայի խմոր 23 սմ 🤌",
  pepperoni_pizza: "Պեպերոնի պիցցա",
  one_person_23cm_dough: "(1 անձ) Պիցցայի խմոր 23 սմ",
  bacon_pizza: "Բեկոն պիցցա",
  one_person_23cm_explosion: "(1 անձ) Պիցցայի խմոր 23 սմ 💥",
  mixed_pizza: "Խառը պիցցա",
  one_person_23cm_mixed: "(1 անձ) Պիցցայի խմոր 23 սմ 🤭",
  american_steak_pizza: "Ամերիկյան սթեյք պիցցա",
  one_person_23cm_steak: "(1 անձ) 23 սմ 💥",
  burgers: "Համբուրգերներ",
  cheese_burger: "Պանրով համբուրգեր",
  with_french_fries: "🤩 ֆրիով",
  "2_beef_burgers_150g": "2 տավարի համբուրգեր 150 գ յուրաքանչյուրը",
  special_sauce_gouda_cheese: "Հատուկ սոուս, Գաուդա պանիր",
  pickles_lettuce_tomato: "Թթու վարունգ, հազար, լոլիկ",
  special_sauce: "Հատուկ սոուս",
  burger: "Համբուրգեր",
  pure_meat_with_special_sauce: "😍 Մաքուր միս հատուկ սոուսով",
  chicken_burger: "Հավի համբուրգեր",
  grilled_chicken_burger_with_cheese: "Խորոված հավի համբուրգեր պանրով",
  spicy_burger: "Կծու համբուրգեր",
  beef_with_spicy_sauce: "Տավարի միս կծու սոուսով",
  double_burger: "Կրկնակի համբուրգեր",
  "150g_beef": "Տավարի միս 150 գ",
  royal_burger: "Թագավորական համբուրգեր",
  "150g_beef_emoji": "150 գ տավարի միս 🍔",
  mushroom_burger: "Սնկով համբուրգեր",
  "150g_beef_mushroom": "Տավարի միս 150 գ",
  mushroom_burger_grilled: "Սնկով համբուրգեր",
  "100_percent_grilled_beef": "100 % խորոված տավարի միս 🤩",
  fried_burger: "Տապակած համբուրգեր",
  "100_percent_grilled_fried": "100 % խորոված և տապակած տավարի միս 👌",
  fried: "Տապակած",
  fried_chicken: "Տապակած հավ",
  "3_piece_fried_chicken": "😍 3 կտոր տապակած հավ",
  "3_fried_chicken_pieces": "3 կտոր տապակած հավ",
  "120_150g_french_fries": "120-150 գ ֆրի",
  enter_product_information: "Մուտքագրեք ապրանքի տեղեկատվությունը",
  product_name: "Ձեր ապրանքի անունը",
  product_name_short: "Ապրանքի անուն",
  complete_features_from_image: "Լրացրեք հատկությունները ապրանքի պատկերից",
  skip_step: "Բաց թողնել քայլը",
  product_and_information: "Ապրանք և տեղեկատվություն",
  product_introduction: "Ապրանքի ներկայացում",
  shiva_waves: "Շիվա ալիքներ",
  think_best: "Մտածիր լավագույնը...",
  iran_zanjan_abhar:
    "Իրան, Զանջան, Աբհար, Շարիֆ արդյունաբերական գոտի, 63/20 կՎ ենթակայանի կողքին",
  video_gallery_description: "Դիտեք մեր տեսանյութերը:",
  gallery: "Պատկերասրահ",
  welcome: "Բարի գալուստ",
  invalid_address: "Մուտքագրված հասցեն անվավեր է!",
  product_created_successfully: "Ձեր ապրանքը հաջողությամբ ստեղծվել է:",
  qr_visit_card_edited_successfully:
    "Ձեր այցելության քարտը հաջողությամբ խմբագրվել է:",
  change_header_color: "Փոխել վերնագրի գույնը",
  change_body_color: "Փոխել մարմնի գույնը",
  change_button_colors: "Փոխել կոճակների գույները",
  change_text_colors: "Փոխել տեքստի գույները",
  gradient_colors: "Գրադիենտ գույներ",
  color_direction: "Գույնի ուղղություն",
  first_color: "Առաջին գույն",
  second_color: "Երկրորդ գույն",
  color: "Գույն",
  text_color: "Տեքստի գույն",
  from_top: "Վերևից",
  from_bottom: "Ներքևից",
  from_left_to_right: "Ձախից աջ",
  from_right_to_left: "Աջից ձախ",
  from_top_to_left: "Վերևից ձախ",
  from_top_to_right: "Վերևից աջ",
  from_bottom_to_left: "Ներքևից ձախ",
  from_bottom_to_right: "Ներքևից աջ",
  sharing: "Համօգտագործում",
  business_shop: "Բիզնես / խանութ",
  corporate_organizational: "Ընկերություն / կազմակերպչական",
  customer_contact: "Հաճախորդի կապ",
  information: "Տեղեկատվություն",
  miscellaneous: "Խառը",
  link: "Հղում",
  margin: "Եզր",
  width: "Լայնություն",
  height: "Բարձրություն",
  background_color: "Ֆոնի գույն",
  gradient_color: "Գրադիենտ գույն",
  linear: "Գծային",
  radial: "Շառավիղային",
  color_rotation: "Գույնի պտույտ",
  background_color_label: "Ֆոնի գույն",
  dots_color: "Կետերի գույն",
  dots_color_label: "Կետերի գույն",
  eye_colors: "Աչքերի գույներ",
  separate_colors_for_each_eye: "Առանձին գույներ յուրաքանչյուր աչքի համար",
  current_mode: "Ընթացիկ ռեժիմ՝",
  separate_colors: "Առանձին գույներ",
  same_color: "Նույն գույնը",
  all_eyes_color: "Բոլոր աչքերի գույն",
  top_right_eye: "Վերին աջ աչք",
  top_left_eye: "Վերին ձախ աչք",
  bottom_left_eye: "Ներքևի ձախ աչք",
  upload_logo: "Վերբեռնել լոգո",
  hide_background_dots: "Թաքցնել կետերը լոգոյի հետևում",
  logo_size: "Լոգոյի չափ",
  logo_margin: "Լոգոյի եզր",
  qr_accuracy: "QR ճշգրտություն",
  mode: "Ռեժիմ",
  error_correction_level: "Սխալի ուղղման մակարդակ",
  numeric: "Թվային",
  alphanumeric: "Թվատառային",
  byte: "Բայթ",
  apply_changes: "Կիրառել փոփոխությունները",
  please_click_apply_changes:
    'Ընտրելուց հետո սեղմեք "Կիրառել փոփոխությունները":',
  created_qr_codes: "Ստեղծված QR կոդեր",
  square_ratio: "1:1 (քառակուսի)",
  image_upload_error: "Պատկերի վերբեռնման սխալ!",
  visit_card_name_label: "Այցելության քարտի անուն",
  sms_membership_message:
    "SMS անդամակցության հաղորդագրություն հաճախորդների ակումբի համար",
  admin_menu: "Ադմին մենյու",
  user_menu: "Օգտատիրոջ մենյու",
  guide_tooltip: "Ուղեցույց",
  close: "Փակել",
  browser_video_support_error: "Ձեր բրաուզերը չի աջակցում որևէ վիդեո ձևաչափ:",
  video_loading_error:
    "Տեսանյութի բեռնման սխալ (մուտքը կարող է սահմանափակված լինել):",
  click_more_for_videos:
    "Սեղմեք «Ավելին»՝ ավելի շատ տեսանյութեր տեսնելու համար:",
  more_info: "Ավելի շատ տեղեկություն",
  more: "Ավելին",
  add_user_guide: "Ավելացնել օգտատիրոջ ուղեցույց",
  edit_user_guide: "Խմբագրել օգտատիրոջ ուղեցույց",
  display_info: "Ցուցադրել տեղեկատվությունը",
  element: "Տարր",
  disable_attach: "Անջատել կցումը՝ էջին համապատասխանեցնելու համար",
  view: "Դիտել",
  guide: "Ուղեցույց",
  details: "Մանրամասներ",
  guide_images: "Ուղեցույցի պատկերներ",
  guide_videos: "Ուղեցույցի տեսանյութեր",
  faq: "Հաճախ տրվող հարցեր",
  data_preload_error: "Տվյալների նախաբեռնման սխալ՝",
  guide_not_found: "Ուղեցույց չի գտնվել: Նախ ստեղծեք ուղեցույց:",
  delete_guide_question: "Ջնջե՞լ ուղեցույցը:",
  delete_guide_error: "Ուղեցույցի ջնջման սխալ!",
  unknown_file_type: "Անհայտ ֆայլի տեսակ՝",
  content_type_error: "Բովանդակության տեսակի ստացման սխալ՝",
  video: "Տեսանյութ",
  image: "Պատկեր",
  guide_data_error: "Ուղեցույցի տվյալների ստացման սխալ՝",
  add_iranian_stores: "Ավելացնել իրանական խանութներ",
  add_foreign_stores: "Ավելացնել արտասահմանյան խանութներ",
  bazaar: "Բազաար",
  myket: "Մայքեթ",
  app_store: "App Store",
  google_play: "Google Play",
  samsung_store: "Samsung Store",
  xiaomi_store: "Xiaomi Store",
  vivo_store: "Vivo Store",
  amazon_store: "Amazon Store",
  bazaar_app: "Բազաար հավելված",
  bazaar_link_placeholder: "Մուտքագրեք Բազաար հավելվածի հղումը",
  bazaar_link_hint:
    "Մուտքագրեք վավեր Բազաար հղում (օրինակ՝ https://cafebazaar.ir/app/com.abankefarda)",
  myket_app: "Մայքեթ հավելված",
  myket_link_placeholder: "Մուտքագրեք Մայքեթ հավելվածի հղումը",
  myket_link_hint:
    "Մուտքագրեք վավեր Մայքեթ հղում (օրինակ՝ myket://details?id=com.example)",
  app_store_app: "App Store հավելված",
  app_store_link_placeholder: "Մուտքագրեք App Store հավելվածի հղումը",
  app_store_link_hint:
    "Մուտքագրեք վավեր App Store հղում (օրինակ՝ https://apps.apple.com/us/app/appname/id123456789)",
  google_play_app: "Google Play հավելված",
  google_play_link_placeholder: "Մուտքագրեք Google Play հավելվածի հղումը",
  google_play_link_hint:
    "Մուտքագրեք վավեր Google Play հղում (օրինակ՝ https://play.google.com/store/apps/details?id=com.example)",
  samsung_store_app: "Samsung Store հավելված",
  samsung_store_link_placeholder: "Մուտքագրեք Samsung Store հավելվածի հղումը",
  samsung_store_link_hint:
    "Մուտքագրեք վավեր Samsung Store հղում (օրինակ՝ https://galaxy.store/appname)",
  xiaomi_store_app: "Xiaomi Store հավելված",
  xiaomi_store_link_placeholder: "Մուտքագրեք Xiaomi Store հավելվածի հղումը",
  xiaomi_store_link_hint: "Մուտքագրեք վավեր Xiaomi Store հղում",
  vivo_app_store: "Vivo App Store",
  vivo_app_store_app: "Vivo App Store հավելված",
  vivo_app_store_link_placeholder: "Մուտքագրեք Vivo App Store հավելվածի հղումը",
  vivo_app_store_link_hint: "Մուտքագրեք վավեր Vivo App Store հղում",
  amazon_store_app: "Amazon Store հավելված",
  amazon_store_link_placeholder: "Մուտքագրեք Amazon Store հավելվածի հղումը",
  amazon_store_link_hint: "Մուտքագրեք վավեր Amazon Store հղում",
  iranian_store: "Իրանական խանութ",
  foreign_store: "Արտասահմանյան խանութ",
  personal_store: "Անձնական խանութ",
  image_logo: "Պատկեր/Լոգո",
  image_gallery: "Պատկերների պատկերասրահ",
  header_image: "Վերնագրի պատկեր",
  template_background_image: "Ձևանմուշի ֆոնի պատկեր",
  background_image: "Ֆոնի պատկեր",
  background_image_alt: "Ֆոնի պատկեր",
  logo_upload: "Վերբեռնել լոգո",
  welcome_image: "Բարի գալուստ պատկեր",
  welcome_image_logo_upload: "Վերբեռնել Բարի գալուստ պատկեր/Լոգո",
  loading_animation: "Բեռնման անիմացիա",
  preview_welcome_page: "Դիտել Բարի գալուստ էջը",
  max_background_size: "Ֆոնի պատկերի առավելագույն չափ՝ 2 ՄԲ:",
  max_logo_size: "Լոգոյի առավելագույն չափ՝ 2 ՄԲ:",
  scale_from_center: "Մասշտաբավորել կենտրոնից",
  slide_from_left: "Սահել ձախից",
  slide_from_top: "Սահել վերևից",
  fade: "Խամրել",
  select_music_card: "Ընտրեք երաժշտության քարտ",
  show_audio: "Ցուցադրել աուդիո",
  hide_audio: "Թաքցնել աուդիո",
  add_voice: "Ավելացնել ձայն",
  max_files_limit: "Դուք չեք կարող ընտրել ավելի քան {count} ֆայլ!",
  files_not_allowed: "Ֆայլերը չեն թույլատրվում!",
  voice_gallery: "Ձայնային պատկերասրահ",
  edit_voice: "Խմբագրել ձայնը",
  list: "Ցուցակ",
  file_name: "Ֆայլի անուն",
  title: "Վերնագիր",
  description: "Նկարագրություն",
  selectdate: "Ընտրել ամսաթիվ",
  background: "Ֆոն",
  text: "Տեքստ",
  delete_audio_confirm:
    "Համոզվա՞ծ եք, որ ցանկանում եք ջնջել աուդիո ֆայլը Ձեր պատկերասրահից:",
  add_voice_gallery: "Ավելացնել ձայնային պատկերասրահ",
  gallery_number: "Պատկերասրահ",
  delete_confirm: "Համոզվա՞ծ եք, որ ցանկանում եք ջնջել:",
  confirm: "?",
  voice_gallery_title_hint: "Մուտքագրեք Ձեր ձայնային պատկերասրահի վերնագիրը:",
  voice_gallery_title: "Վերնագիր",
  voice_gallery_subtitle_hint:
    "Մուտքագրեք Ձեր ձայնային պատկերասրահի ենթավերնագիրը:",
  voice_gallery_subtitle: "Ձայնային պատկերասրահի ենթավերնագիր",
  voice_gallery_subtitle_alt: "Ենթավերնագիր",
  website_address_hint: "Մուտքագրեք Ձեր կայքի հասցեն:",
  website_address: "Կայքի հասցե",
  about_voice_gallery: "Պատկերասրահի մասին",
  about_voice_gallery_alt: "Պատկերասրահի մասին",
  button_name_hint: "Մուտքագրեք կոճակի անունը:",
  button_name: "Կոճակի անուն",
  domain_format_hint:
    "Դոմենը պետք է լինի https://terminalads.com կամ terminalads.com:",
  about_us_alt: "Մեր մասին",
  add_default_form: "Ավելացնել լռելյայն ձև",
  delete_all: "Ջնջել բոլորը",
  validation_active: "Ստուգում՝ ակտիվ",
  validation_inactive: "Ստուգում՝ անակտիվ",
  validation: "Ստուգում",
  clear_form: "Մաքրել ձևը",
  status: "Կարգավիճակ",
  active: "Ակտիվ",
  inactive: "Անակտիվ",
  optional: "Ընտրովի",
  required: "Պարտադիր",
  question_title: "Վերնագիր",
  question_title_hint: "Մուտքագրեք հարցի վերնագիրը",
  options_hint: "Գրեք տարբերակները և սեղմեք Enter՝ ավելացնելու համար",
  options: "Տարբերակներ",
  add_suggested_form: "Ավելացնել առաջարկվող ձև",
  save_changes: "Պահպանել փոփոխությունները",
  add_request_field: "Ավելացնել հայտի դաշտ",
  select_form_type: "Ընտրեք ձևի տեսակը",
  select_form_type_placeholder: "Ընտրեք ձևի տեսակը",
  dropdown: "Բացվող ցուցակ",
  text_field: "Տեքստային դաշտ",
  number_field: "Թվային դաշտ",
  textarea_field: "Տեքստային տարածք",
  date_field: "Ամսաթվի դաշտ",
  field_name_required: "Դաշտի անունը չի կարող դատարկ լինել",
  field_name: "Դաշտի անուն",
  add_field_name: "Ավելացնել դաշտի անուն",
  field_label: "Դաշտի պիտակ",
  add_field_label: "Ավելացնել դաշտի պիտակ",
  advanced_settings: "Ընդլայնված կարգավորումներ",
  select_input_pattern: "Ընտրեք մուտքագրման ձևանմուշ",
  select_input_pattern_placeholder: "Ընտրեք մուտքագրման ձևանմուշ",
  max_characters: "Առավելագույն նիշեր",
  min_input_error: "Նվազագույն մուտքը պետք է լինի 0",
  name_field: "Անուն",
  field_type: "Դաշտի տեսակ",
  persian_limit: "Պարսկերեն լեզվի սահմանափակում",
  family_name: "Ազգանուն",
  mobile_number: "Բջջային համար",
  number_limit: "Թվերի սահմանափակում",
  national_code: "Ազգային կոդ",
  meli_code: "Ազգային կոդ",
  email: "Էլ. փոստ",
  email_limit: "Էլ. փոստի սահմանափակում",
  dropdown_field: "Բացվող դաշտ",
  english_limit: "Անգլերեն լեզվի սահմանափակում",
  mix_per_eng_limit: "Պարսկերեն-անգլերեն խառնուրդի սահմանափակում",
  site_limit: "Կայքի սահմանափակում",
  form_added_successfully: "Նոր ձևը հաջողությամբ ավելացվել է",
  form_updated_successfully: "Ձևը հաջողությամբ թարմացվել է",
  delete_item_confirm: "Համոզվա՞ծ եք, որ ցանկանում եք ջնջել տարրը:",
  default_form_added_successfully: "Լռելյայն ձևը հաջողությամբ ավելացվել է",
  resources_upload_error: "Ռեսուրսների վերբեռնման սխալ",
  update_value_if_duplicate: "Թարմացնել արժեքը, եթե կրկնօրինակված է",
  first_tab: "Առաջին ներդիր",
  display_count: "Ցուցադրման քանակ",
  buy_renew_qr_instruction:
    "QR գնելու/երկարացնելու համար սեղմեք ժամկետի կոճակը:",
  days_until_expiry: "Օրեր մինչև ժամկետի ավարտը",
  expired: "Ժամկետը լրացել է",
  no_qr_to_display: "Ցուցադրման QR չկա!",
  second_tab: "Երկրորդ ներդիր",
  total_qr_codes: "Ընդհանուր QR կոդեր",
  select_all: "Ընտրել բոլորը",
  selected_qr_codes_count: "Ընտրված QR կոդերի քանակ",
  qr_codes_count: "QR կոդերի քանակ",
  group_renewal_instruction:
    "Խմբային երկարացման համար ընտրեք ցանկալի QR կոդերը:",
  no_qr_found_with_filters: "Այս զտիչներով QR չի գտնվել!",
  qr_codes_count_label: "QR կոդերի քանակ՝",
  renew_qr: "Երկարացնել QR",
  days: "Օրեր",
  buy_now: "Գնել հիմա!",
  buy_now_label: "Գնել",
  add_discount_code: "Ավելացնել զեղչի կոդ",
  use_discount_code: "Օգտագործել զեղչի կոդ",
  discount_code: "Զեղչի կոդ",
  submit: "Ուղարկել",
  my_qr_list: "Իմ QR ցուցակը",
  group_renewal: "Խմբային երկարացում",
  row: "Տող",
  type: "Տեսակ",
  clicks: "Սեղմումներ",
  created_at_diff: "Ստեղծման ժամանակ",
  updated_at_diff: "Թարմացման ժամանակ",
  table_view: "Աղյուսակային դիտում",
  normal_view: "Սովորական դիտում",
  no_qr_or_id_selected: "QR կամ ID չի ընտրվել!",
  qr_updated_successfully: "QR-ը հաջողությամբ թարմացվել է:",
  qr_update_error: "QR-ի թարմացման սխալ!",
  no_qr_selected: "QR չի ընտրվել!",
  no_qr_code_selected: "QR կոդ չի ընտրվել!",
  success: "Հաջողություն",
  qrs_upgraded_successfully: "Ձեր QR-ները հաջողությամբ արդիականացվել են:",
  qr_renewal_error: "QR երկարացման հայտի խնդիր!",
  changed_successfully: "Հաջողությամբ փոխվել է:",
  error_occurred: "Տեղի է ունեցել սխալ!",
  no_tariff_exists: "Տարիֆ չկա!",
  qr_upgraded_successfully: "Ձեր QR-ը հաջողությամբ արդիականացվել է:",
  check_account_balance: "Ստուգեք Ձեր հաշվի մնացորդը և փորձեք ավելի ուշ:",
  group_renewal_price_error: "Խմբային երկարացման գնի ստացման սխալ!",
  qr_count_error: "QR քանակի ստացման սխալ!",
  no_qr_for_renewal: "Երկարացման QR չկա!",
  table_pagination: "Աղյուսակի էջավորում",
  virtual_scroll_display: "Վիրտուալ ոլորման ցուցադրում",
  popups_shared_components: "Թռուցիկներ և ընդհանուր բաղադրիչներ",
  edit_qr_address: "Խմբագրել QR հասցեն",
  please_enter_correct_address: "Խնդրում ենք մուտքագրել ճիշտ հասցե",
  successfully_edited: "Հաջողությամբ խմբագրվել է:",
  error_editing_qr_address: "QR հասցեի խմբագրման սխալ!",
  go_to_page: "Անցնել էջ",
  page_from_to: "Էջ {current} / {last}",
  display: "Ցուցադրել",
  to: "մինչև",
  from: "ից",
  show: "Ցուցադրել",
  page_status: "Էջ {current} / {total}",
  until: "մինչև",
  successfully_completed: "Հաջողությամբ ավարտվել է",
  problem_occurred: "Տեղի է ունեցել խնդիր",
  download_failed: "Ներբեռնումը ձախողվել է",
  audio_file_default: "Աուդիո ֆայլ",
  memory_release: "Հիշողության ազատում",
  seek_music_comment: "Օրինակ՝ այս երաժշտությունը կամ որևէ որոնվող բան",
  all: "Բոլորը",
  create_podcast: "Ստեղծել փոդքասթ",
  add_link: "Ավելացնել հղում",
  upload_file: "Վերբեռնել ֆայլ",
  file_list: "Ֆայլերի ցուցակ",
  count: "Քանակ",
  select_category: "Ընտրեք կատեգորիա",
  after_typing_enter: "Մուտքագրելուց հետո սեղմեք Enter:",
  no_image_available: "Պատկեր չկա",
  no_image_found: "Պատկեր չի գտնվել!",
  for_adding_file_use_upload_center:
    "Ֆայլ ավելացնելու համար օգտագործեք վերբեռնման դաշտը կամ վերբեռնման կենտրոնը",
  ai_story_creation_description:
    "Մուտքագրեք Ձեր պատմությունը, AI-ն կստեղծի այն Ձեզ համար",
  create_new_podcast: "Ստեղծել նոր փոդքասթ",
  show_audio_file: "Ցուցադրել աուդիո ֆայլ",
  cancel: "Չեղարկել",
  no_audio_in_category: "Այս կատեգորիայում աուդիո ֆայլեր չկան",
  health_apple: "Առողջության խնձոր",
  standard: "Ստանդարտ",
  arshia_badge: "Արշիա կրծքանշան",
  home_appliances_association: "Կենցաղային տեխնիկայի ասոցիացիա",
  energy_label: "Էներգետիկ պիտակ",
  select_gold_purity_first: "Գինը ստանալու համար նախ ընտրեք ոսկու մաքրությունը",
  gold_price_service: "Ոսկու գնի ծառայություն",
  rahvard: "Ռահվարդ",
  to_change_gold_service_go_to_assets:
    "Ոսկու գնի ծառայությունը փոխելու համար անցեք ակտիվների բաժին",
  gold: "Ոսկի",
  purity: "Մաքրություն",
  rial: "Ռիալ",
  final_product_price: "Ապրանքի վերջնական գին",
  show_images_right_side: "Պատկերները ցուցադրել աջ կողմում",
  show_as_slider: "Ցուցադրել որպես սլայդեր:",
  show_as_grid: "Ցուցադրել որպես ցանց:",
  show_as_second_mode: "Ցուցադրել որպես երկրորդ ռեժիմ:",
  gallery_name: "Պատկերասրահի անուն",
  change_gallery_name: "Փոխել պատկերասրահի անունը",
  add_photo: "Ավելացնել լուսանկար",
  select_photo: "Ընտրեք լուսանկար",
  show_image: "Ցուցադրել պատկեր",
  selected_photo: "Ընտրված լուսանկար",
  to_use_ready_images_search_category_or_product:
    "Պատրաստի պատկերներ օգտագործելու համար որոնեք վերևում կատեգորիա կամ ապրանք:",
  max_file_size_2mb: "Ֆայլի առավելագույն չափ՝ 2 ՄԲ:",
  drag_and_drop_to_upload_or: "Քաշեք և գցեք վերբեռնելու համար կամ",
  here: "այստեղ",
  click: "սեղմեք",
  to_use_external_image_link_fill_fields:
    "Արտաքին պատկերի հղում օգտագործելու համար լրացրեք ստորև դաշտերը",
  image_url_hint: "Ցանկալի պատկերի URL (հղում):",
  image_url: "Պատկերի հղում",
  add_new_gallery: "Ավելացնել նոր պատկերասրահ",
  create_image: "Ստեղծել պատկեր",
  ready_images: "Պատրաստի պատկերներ",
  edit_image: "Խմբագրել պատկեր",
  enter_valid_link: "Մուտքագրեք վավեր հղում:",
  max_background_image_size_2mb: "Ֆոնի պատկերի առավելագույն չափ՝ 2 ՄԲ:",
  uploaded_successfully: "Հաջողությամբ վերբեռնվել է:",
  banner: "Բաններ",
  question: "Հարց",
  selected_question: "Ընտրված հարց",
  answer: "Պատասխան",
  add_question: "Ավելացնել հարց",
  selected_blog: "Ընտրված բլոգ",
  icon: "Պատկերակ",
  select_icon: "Ընտրեք պատկերակ",
  add_blog: "Ավելացնել բլոգ",
  post: "Գրառում",
  selected_services: "Ընտրված ծառայություններ",
  add_new_post: "Ավելացնել նոր գրառում",
  add_new_services: "Ավելացնել նոր ծառայություններ",
  add_new_service: "Ավելացնել նոր ծառայություն",
  domain_must_be_https_or_http:
    "Դոմենը պետք է լինի https://terminalads.com կամ terminalads.com:",
  id: "ID",
  images: "Պատկերներ",
  tags: "Թեգեր",
  print_type: "Տպագրության տեսակ",
  user: "Օգտատեր",
  user_shipping_info: "Օգտատիրոջ առաքման տեղեկատվություն",
  qr_short_link: "QR կարճ հղում",
  delivery_method: "Առաքման եղանակ",
  delivery_at_company: "Առաքում ընկերությունում",
  delivery_by_post: "Առաքում փոստով",
  post_cost_and_tax_warning:
    "Գրանցման ժամանակ փոստային ծախսը և 10% հարկը կհանվեն Ձեր դրամապանակից:",
  shipping_info: "Առաքման տեղեկատվություն",
  continue_shopping: "Շարունակել գնումները",
  complete_shopping: "Ավարտել գնումը",
  select_free_nfc_card: "Ընտրեք անվճար NFC քարտ",
  order_custom_nfc_card: "Պատվիրեք անհատական NFC քարտ",
  buy_qr_equipment: "Գնել QR սարքավորում",
  vertical: "Ուղղահայաց",
  horizontal: "Հորիզոնական",
  card_type: "Քարտի տեսակ",
  tag: "Թեգ",
  select: "Ընտրել",
  order_card: "Պատվիրել քարտ",
  available: "Հասանելի",
  unavailable: "Անհասանելի",
  for_initial_loading: "Սկզբնական բեռնման համար",
  already_have_free_nfc_message:
    "Դուք արդեն ստացել եք անվճար NFC այս QR-ի համար: Փոխելու համար գնեք անհատական քարտ:",
  nfc_in_delivery_process_message:
    "Դուք արդեն գրանցել եք անվճար NFC, որը ճանապարհին է: Փոխելու համար գնեք անհատական:",
  free_nfc_card_warning_message:
    "Հարգելի օգտատեր՝ անվճար NFC քարտերը նախապես տպագրված են, Ձեր QR-ը փոխվում է: Եթե օգտագործվում է, գնեք անհատական:",
  select_card: "Ընտրեք քարտ",
  free_card_selection_conditions: "Անվճար քարտի ընտրության պայմաններ",
  confirm_and_select: "Հաստատել և ընտրել",
  registered_successfully: "Հաջողությամբ գրանցվել է:",
  error_registering_nfc_order: "NFC քարտի պատվերի գրանցման սխալ!",
  nfc_physical_card_orders: "Ֆիզիկական NFC քարտերի պատվերներ",
  buy_equipment: "Գնել սարքավորում",
  select_quantity: "Ընտրեք քանակ",
  ready_samples: "Պատրաստի նմուշներ",
  upload_custom_design: "Վերբեռնել անհատական դիզայն",
  select_ready_card_image: "Ընտրեք պատրաստի քարտի պատկեր",
  select_card_front_image: "Ընտրեք քարտի առջևի պատկեր",
  select_card_back_image: "Ընտրեք քարտի հետևի պատկեր",
  nfc_card_image: "NFC քարտի պատկեր",
  add_quantity: "Ավելացնել քանակ",
  total_price: "Ընդհանուր գին",
  price_with_discount: "Գին զեղչով",
  shipping_cost: "Առաքման արժեք",
  your_profit_from_purchase: "Ձեր շահույթը գնումից",
  discount: "Զեղչ",
  ten_percent_tax_will_be_added: "Վերջնական գումարին կավելացվի 10% հարկ:",
  payable_amount: "Վճարման գումար",
  continue: "Շարունակել",
  Confirm_code: "Հաստատման կոդ",
  form_success_message: "Ձեր ձևը հաջողությամբ ուղարկվել է",
  refill_form_message: "Խնդրում ենք կրկին լրացնել ձևը",
  Enter_the_sent_code: "Մուտքագրեք Ձեզ ուղարկված կոդը",
  SUBMIT_FORM: "Ուղարկել ձևը",
  enter_phone_number: "Մուտքագրեք Ձեր բջջային համարը",
  order_registered_successfully: "Ձեր պատվերը հաջողությամբ գրանցվել է:",
  smart_creation: "Խելացի ստեղծում",
  automatic_creation: "Ավտոմատ ստեղծում",
  business_name: "Բիզնեսի անուն",
  example_household_goods: "Օրինակ՝ կենցաղային ապրանքներ",
  organization_name: "Կազմակերպության անուն",
  example_tech_company: "Օրինակ՝ առաջադեմ տեխնոլոգիաների ընկերություն",
  minimum_two_characters_required: "Պահանջվում է առնվազն երկու նիշ!",
  maximum_100_characters_allowed: "Թույլատրվում է առավելագույնը 100 նիշ",
  latin_name_qr_address: "Լատինական անուն (QR հասցե)",
  example_advanced_tech: "Օրինակ՝ advanced-tech",
  only_english_numbers_dash_allowed:
    "Թույլատրվում են միայն անգլերեն տառեր, թվեր և գծիկ",
  maximum_50_characters_allowed: "Թույլատրվում է առավելագույնը 50 նիշ",
  latin_name_goes_after_domain: "Լատինական անունը գալիս է դոմենից հետո",
  select_logo_and_store_product_image: "Ընտրեք լոգո և խանութի/ապրանքի պատկեր",
  select_logo: "Ընտրեք լոգո",
  file_size_must_be_less_than_2mb: "Ֆայլի չափը պետք է լինի 2 ՄԲ-ից պակաս",
  for_buying_renewing_qr_click_expiry_button:
    "QR գնելու/երկարացնելու համար սեղմեք ժամկետի կոճակը:",
  for_group_renewal_select_desired_qr_codes:
    "Խմբային երկարացման համար ընտրեք ցանկալի QR կոդերը:",
  no_qr_found_with_these_filters: "Այս զտիչներով QR չի գտնվել!",
  i_buy: "Գնում եմ",
  visits: "Այցելություններ",
  creation_time: "Ստեղծման ժամանակ",
  edit_time: "Խմբագրման ժամանակ",
  enter_business_card_name_correctly: "Ճիշտ մուտքագրեք բիզնես քարտի անունը!",
  are_you_sure_delete_qr: "Համոզվա՞ծ եք, որ ցանկանում եք ջնջել QR-ը:",
  qr_deleted_successfully: "QR-ը հաջողությամբ ջնջվել է:",
  are_you_sure_deactivate_qr: "Համոզվա՞ծ եք, որ ցանկանում եք անջատել QR-ը:",
  are_you_sure_activate_qr: "Համոզվա՞ծ եք, որ ցանկանում եք ակտիվացնել QR-ը:",
  deactivated: "Անջատված",
  qr_successfully: "QR հաջողությամբ",
  successfully: "Հաջողությամբ",
  user_transferred_successfully: "Օգտատերը հաջողությամբ փոխանցվել է",
  problem_occurred_in_transfer: "Փոխանցման ընթացքում խնդիր է առաջացել!",
  error_in_user_transfer: "Օգտատիրոջ փոխանցման սխալ!",
  qr_business_card_edited_successfully:
    "Ձեր այցելության քարտը հաջողությամբ խմբագրվել է:",
  group_qr_renewal: "Խմբային QR երկարացում",
  select_desired_duration: "Ընտրեք ցանկալի ժամկետ",
  total_count: "Ընդհանուր քանակ",
  final_amount: "Վերջնական գումար",
  ten_percent_vat_will_be_added: "Վերոնշյալ գումարին կավելացվի 10% ԱԱՀ:",
  pay_and_upgrade: "Վճարել և արդիականացնել",
  no_tariff_for_this_period: "Այս ժամանակաշրջանի համար տարիֆ չկա!",
  selected: "Ընտրված",
  total_amount: "Ընդհանուր գումար",
  final_amount_with_discount: "Վերջնական գումար զեղչով",
  add_qr: "Ավելացնել QR",
  actions: "Գործողություններ",
  filter_type: "Տեսակի զտիչ",
  start_from: "Սկսել",
  search_in_id: "Որոնել ID-ով",
  filter_user: "Օգտատիրոջ զտիչ",
  clear_filters: "Մաքրել զտիչները",
  send_sms: "Ուղարկել SMS",
  selected_pattern: "Ընտրված ձևանմուշ",
  send: "Ուղարկել",
  bulk_download: "Խմբային ներբեռնում",
  one_month_renewal: "Մեկ ամսվա երկարացում",
  three_month_renewal: "Երեք ամսվա երկարացում",
  six_month_renewal: "Վեց ամսվա երկարացում",
  one_year_renewal: "Մեկ տարվա երկարացում",
  no_item_selected: "Տարր չի ընտրվել!",
  error_loading_card_info: "Քարտի տեղեկատվության բեռնման սխալ!",
  send_registered_successfully: "Ուղարկումը հաջողությամբ գրանցվել է",
  error_getting_prices: "Գների ստացման սխալ!",
  payment_error: "Վճարման սխալ!",
  business_card: "Բիզնես քարտ",
  product_label: "Ապրանքի պիտակ",
  restaurant_menu: "Ռեստորանի մենյու",
  event_ticket: "Միջոցառման տոմս",
  brochure: "Բրոշյուր",
  flyer: "Թռուցիկ",
  poster: "Պաստառ",
  catalog: "Կատալոգ",
  newsletter: "Տեղեկագիր",
  organization_name_hint: "Մուտքագրեք Ձեր կազմակերպության անունը:",
  organization_name_label: "Կազմակերպության անուն",
  sub_organization_hint: "Մուտքագրեք ենթակազմակերպության անունը:",
  sub_organization_label: "Ենթակազմակերպության նկարագրություն",
  user_name_hint: "Մուտքագրեք Ձեր անունը:",
  user_name_label: "Անուն և ազգանուն",
  work_field_hint: "Մուտքագրեք Ձեր աշխատանքի դիրքը:",
  work_field_label: "Դիրք",
  mobile_number_hint: "Մուտքագրեք Ձեր համարը:",
  mobile_number_label: "Բջջային համար",
  phone_number_hint: "Մուտքագրեք հեռախոսահամար:",
  phone_number_label: "Հեռախոսահամար",
  email_hint: "Մուտքագրեք Ձեր էլ. փոստը:",
  email_label: "Էլ. փոստ",
  fax_hint: "Մուտքագրեք ընկերության ֆաքսը:",
  fax_label: "Ընկերության ֆաքս",
  website_hint: "Մուտքագրեք ընկերության կայքը:",
  website_label: "Ընկերության կայք",
  postal_code_hint: "Մուտքագրեք փոստային ինդեքսը:",
  postal_code_label: "Փոստային ինդեքս",
  copyright_hint: "Մուտքագրեք ստորագրի հեղինակային իրավունքի տեքստը:",
  copyright_label: "Հեղինակային իրավունքի տեքստ",
  address_hint: "Մուտքագրեք Ձեր հասցեն:",
  address_label: "Հասցե",
  add_more_info: "Ավելացրեք ավելի շատ տեղեկություն, որը ցանկանում եք՝",
  edit_location: "Խմբագրել",
  add_location: "Ավելացնել",
  delete_location: "Ջնջել տեղադրությունը",
  about_us_label: "Մեր մասին",
  search_address: "Որոնել հասցե՝",
  northern_coordinates: "Հյուսիսային կոորդինատներ",
  eastern_coordinates: "Արևելյան կոորդինատներ",
  select_address_on_map: "Ընտրեք հասցեն քարտեզի վրա",
  location_not_found: "Տեղադրությունը չի գտնվել:",
  text_label: "Տեքստ",
  number_label: "Թիվ",
  website_address_label: "Կայքի հասցե",
  location_label: "Տեղադրություն",
  mobile_viewer_title: "Բջջային դիտիչ",
  visit_theme_two_title: "Այցելության քարտի թեմա 2",
  visit_theme_flipped_title: "Շրջված այցելության քարտի թեմա",
  flip_card: "Շրջել քարտը",
  flip_card_description: "Ավելի շատ տեղեկություն տեսնելու համար շրջեք քարտը",
  share_contacts: "Համօգտագործել կոնտակտները",
  close_share: "Փակել համօգտագործումը",
  card_front: "Քարտի առջև",
  card_back: "Քարտի հետև",
  flip_to_back: "Շրջել հետև",
  flip_to_front: "Շրջել առջև",
  swipe_to_flip: "Սահեցրեք՝ շրջելու համար",
  swipe_left: "Սահեցրեք ձախ",
  swipe_right: "Սահեցրեք աջ",
  expand_card: "Ընդլայնել քարտը",
  contract_card: "Կծկել քարտը",
  view_details: "Դիտել մանրամասները",
  hide_details: "Թաքցնել մանրամասները",
  social_media_share: "Հաշիվների համօգտագործում",
  contact_actions: "Կոնտակտի գործողություններ",
  card_actions: "Քարտի գործողություններ",
  floating_menu: "Լողացող մենյու",
  close_menu: "Փակել մենյուն",
  open_menu: "Բացել մենյուն",
  choice_gallery: "Ընտրված պատկերասրահ",
  choice_video: "Ընտրեք տեսանյութ",
  url_video: "Տեսանյութի հղում",
  selected_video: "Ընտրված տեսանյութ",
  add_video: "Ավելացնել տեսանյութ",
  edit_video: "Խմբագրել տեսանյութ",
  linl_video: "Փոխանցման հղում",
  upload_video: "Վերբեռնել տեսանյութ",
  rule_link: "Դոմենը պետք է լինի https://terminalads.com կամ terminalads.com:",
  fax_hint: "Մուտքագրեք ընկերության ֆաքսը:",
  fax_label: "Ընկերության ֆաքս",
  website_hint: "Մուտքագրեք ընկերության կայքը:",
  website_label: "Ընկերության կայք",
  postal_code_hint: "Մուտքագրեք փոստային ինդեքսը:",
  postal_code_label: "Փոստային ինդեքս",
  add_more_info: "Ավելացրեք ավելի շատ տեղեկություն, որը ցանկանում եք՝",
  address_hint: "Մուտքագրեք Ձեր հասցեն:",
  address_label: "Հասցե",
  edit_location: "Խմբագրել",
  add_location: "Ավելացնել",
  delete_location: "Ջնջել տեղադրությունը",
  location_label: "Տեղադրություն",
  about_company_label: "Ընկերության մասին",
  select_address_on_map: "Ընտրեք հասցեն քարտեզի վրա",
  search_address: "Որոնել հասցե՝",
  rule_link: "Դոմենը պետք է լինի https://terminalads.com կամ terminalads.com:",
  link_label: "Հղման հասցե",
  label_label: "Պիտակ",
  field_value_label: "Դաշտի արժեք",
  add_new_field: "Ավելացնել նոր դաշտ",
  tehran_address:
    "Թեհրան, Շարիաթի փողոց, Սեյեդ Խանդան կամրջից հետո, Խանդան նրբանցք, թիվ 6",
  welcome_message_hint:
    "Եթե ակտիվացված է, երբ հաճախորդը միանում է Ձեր ակումբին, կուղարկվի բարի գալուստ հաղորդագրություն:",
  change_pattern_campaign: "Փոխել ձևանմուշ/արշավ",
  selected_message: "Ընտրված հաղորդագրություն՝",
  required_inputs: "Պարտադիր դաշտեր՝",
  selected_campaign_or_pattern: "Ընտրված արշավ/ձևանմուշ՝",
  campaign: "Արշավ",
  pattern: "Ձևանմուշ",
  id: "ID",
  auto_csv_download_label: "Ավտոմատ պահպանում",
  auto_csv_download_hint:
    "Քարտը բացելուց հետո Ձեր տեղեկատվությունը ավտոմատ կներբեռնվի հաճախորդի բջջայինում:",
  show_cclub_onload_label: "Անդամակցության առաջարկ",
  show_cclub_onload_hint:
    "Կբացվի պատուհան հաճախորդների ակումբին միանալու համար:",
  forced_submission_hint:
    "Անդամակցության ձևի ցուցադրմամբ հաճախորդը պետք է գրանցի իր համարը:",
  forced_submission_forced: "Պարտադիր անդամակցություն",
  forced_submission_optional: "Ընտրովի անդամակցություն",
  has_manifest_icons_label: "Վեբ հավելվածի անհատականացում",
  has_assistant_label: "Օգնականի պիտակ",
  select_assistant: "Ընտրել օգնական",
  assistant_ai: "Արհեստական բանականության օգնական",
  has_manifest_icons_hint:
    "Լոգոն և պատկերը կցուցադրվեն վեբ հավելվածը բջջայինում կամ համակարգչում տեղադրելիս:",
  logo_144px: "Լոգո 144 px",
  logo_48px: "Լոգո 48 px",
  photo_wide: "Լայն լուսանկար",
  photo: "Լուսանկար",
  iranian_social_networks: "Իրանական սոցիալական ցանցեր",
  foreign_social_networks: "Արտասահմանյան սոցիալական ցանցեր",
  advertising_sites: "Գովազդային կայքեր",
  other_links: "Այլ հղումներ",
  custom_text: "Անհատական տեքստ",
  custom_text_placeholder: "Մուտքագրեք Ձեր անհատական տեքստը:",
  aparat: "Ապարատ",
  aparat_hint: "Մուտքագրեք Ձեր ալիքի անունը Ապարատում",
  eitaa: "Էյթաա",
  eitaa_hint: "Մուտքագրեք Ձեր օգտանունը",
  soroush: "Սուրուշ",
  soroush_hint: "Մուտքագրեք Ձեր օգտանունը",
  bale: "Բալե",
  bale_hint: "Մուտքագրեք Ձեր օգտանունը",
  rubika: "Ռուբիկա",
  rubika_hint: "Մուտքագրեք ալիքի/խմբի հղումը",
  gap: "Գապ",
  gap_hint: "Մուտքագրեք Ձեր օգտանունը",
  linkedin: "LinkedIn Անձնական էջ",
  linkedin_hint: "Մուտքագրեք Ձեր օգտանունը",
  linkedin_company: "LinkedIn Ընկերության էջ",
  linkedin_company_hint: "Մուտքագրեք Ձեր ընկերության էջի անունը",
  pinterest: "Pinterest",
  pinterest_hint: "Մուտքագրեք Ձեր օգտանունը",
  dribbble: "Dribbble",
  dribbble_hint: "Մուտքագրեք Ձեր օգտանունը",
  facebook: "Facebook",
  facebook_hint: "Մուտքագրեք Ձեր օգտանունը",
  github: "GitHub",
  github_hint: "Մուտքագրեք Ձեր օգտանունը",
  threads: "Threads",
  threads_hint: "Մուտքագրեք Ձեր օգտանունը",
  tiktok: "TikTok",
  tiktok_hint: "Մուտքագրեք Ձեր օգտանունը",
  twitter: "Twitter",
  twitter_hint: "Մուտքագրեք Ձեր օգտանունը",
  skype: "Skype",
  skype_hint: "Մուտքագրեք Ձեր օգտանունը",
  youtube: "YouTube",
  youtube_hint: "Մուտքագրեք Ձեր օգտանունը առանց @",
  wechat: "WeChat",
  wechat_hint: "Մուտքագրեք Ձեր օգտանունը",
  viber: "Viber",
  viber_hint: "Մուտքագրեք Ձեր օգտանունը",
  divar: "Դիվար",
  divar_hint: "Մուտքագրեք գովազդի/տախտակի/խանութի հղումը",
  sheypoor: "Շեյպուր",
  sheypoor_hint: "Մուտքագրեք գովազդի/տախտակի/խանութի հղումը",
  social_network: "Սոցիալական ցանց",
  photo_logo_tab: "Պատկեր/Լոգո",
  gallery_image_tab: "Պատկերների պատկերասրահ",
  template_image: "Ձևանմուշի պատկեր",
  background_image: "Ֆոնի պատկեր",
  upload_logo: "Վերբեռնել լոգո",
  welcome_image_upload: "Վերբեռնել Բարի գալուստ պատկեր/Լոգո",
  welcome_photo: "Բարի գալուստ լուսանկար",
  loading_animation: "Բեռնման անիմացիա",
  preview_welcome_page: "Դիտել Բարի գալուստ էջը",
  default_template_image: "Լռելյայն ձևանմուշի ֆոնի պատկեր",
  default_background_image: "Լռելյայն ֆոնի պատկեր",
  default_logo: "Լռելյայն լոգո",
  default_welcome: "Լռելյայն բարի գալուստ",
  default_gallery: "Լռելյայն պատկերասրահ",
  animation_scale: "Մասշտաբավորել կենտրոնից",
  animation_slide_x: "Սահել ձախից",
  animation_slide_y: "Սահել վերևից",
  animation_fade: "Խամրել",
  image_size_error: "Ֆոնի պատկերի առավելագույն չափ՝ 2 ՄԲ:",
  logo_size_error: "Լոգոյի առավելագույն չափ՝ 2 ՄԲ:",
  categories: {
    bankcard: 'Բանկային քարտ',
    bale: "Bale",
    robika: "Robika",
    eitaa: "Eitaa",
    text: "Տեքստ",
    multi_card: "Մուլտի քարտ",
    product_introduction_pro: "Ապրանքի ներկայացում Pro",
    "gift": "Նվեր",
    electronic_business_card_pro: "Պրո էլեկտրոնային այցեքարտ",
    link_pro:"Link Pro",
    generated_images: "Գեներացված պատկերներ",
    electronic_business_card: "Էլեկտրոնային բիզնես քարտ",
    social_media: "Սոցիալական մեդիա",
    photo_gallery: "Լուսանկարների պատկերասրահ",
    video_gallery: "Տեսանյութերի պատկերասրահ",
    link: "Հղում",
    audio_gallery: "Աուդիո պատկերասրահ",
    audio_gallery_pro: "Աուդիո պատկերասրահ (Pro)",
    feedback: "Հետադարձ կապ",
    consultation_form: "Խորհրդատվության ձև",
    application: "Հավելված",
    pdf_gallery: "PDF պատկերասրահ",
    schedule_table: "Ժամանակացույցի աղյուսակ",
    personal_company_website: "Անձնական/ընկերության կայք",
    online_store: "Առցանց խանութ",
    online_menu: "Առցանց մենյու",
    appointment_booking: "Հանդիպման ամրագրում",
    commercial_admin_website: "Առևտրային/ադմին կայք",
    online_insurance_sales: "Առցանց ապահովագրության վաճառք",
    discount_code: "Զեղչի կոդ",
    product_introduction: "Ապրանքի ներկայացում",
    product_label: "Ապրանքի պիտակ",
    gold_label: "Ոսկու պիտակ",
    franchise: "Ֆրանշիզա (բիզնես էջ)",
    marketplace: "Շուկա (բիզնես էջ)",
    recruitment_form: "Հավաքագրման ձև",
    organizational_form: "Կազմակերպչական ձև",
    employee_card: "Աշխատակցի քարտ",
    book_magazine: "Գիրք/ամսագիր",
    catalog_brochure: "Կատալոգ/բրոշյուր",
    catalog: "Կատալոգ",
    faq: "ՀՏՀ",
    feedback_survey: "Հետադարձ կապ/հարցում",
    consultation_request: "Խորհրդատվության հայտ",
    customer_club: "Հաճախորդների ակումբ",
    invitation_card: "Հրավերքարտ",
    countdown: "Հաշվարկ",
    tombstone: "Գերեզմանաքար",
  },
  support_day60: "60 օրվա գումարի վերադարձի երաշխիք",
  "enter_visit_card_pro_info": "Մուտքագրեք Pro Այցեքարտի անվանումը",

  ROUTE: {
    TITLES: {
      QR_NAME_EDIT_TEXT: "Խմբագրել QR տեքստը",
       SERVER_DOWN: "Թարմացվում է",
      CREATE_MEMORIES_MODEL: "Ստեղծել հուշերի շրջանակի մոդել",
      CREATE_CARD_VISIT_PRO_MODEL: "Ստեղծել այցեքարտ Pro մոդել",
      CREATE_PRODUCT_PRO_MODEL: "Ստեղծել ապրանքի ներկայացման Pro մոդել",
      CREATE_PRODUCT_LABEL_MODEL: "Ստեղծել ապրանքի պիտակի մոդել",
      CREATE_PHOTO_GALLERY_MODEL: "Ստեղծել լուսանկարների պատկերասրահի մոդել",
      CREATE_PDF_GALLERY_MODEL: "Ստեղծել PDF պատկերասրահի մոդել",
      CREATE_SOCIAL_MEDIA_MODEL: "Ստեղծել սոցիալական ցանցերի մոդել",
      EDIT_CARD_VISIT_PRO_MODEL: "Խմբագրել այցեքարտ Pro մոդելը",
      EDIT_PRODUCT_PRO_MODEL: "Խմբագրել ապրանքի ներկայացման Pro մոդելը",
      EDIT_PRODUCT_LABEL_MODEL: "Խմբագրել ապրանքի պիտակի մոդելը",
      EDIT_PHOTO_GALLERY_MODEL: "Խմբագրել լուսանկարների պատկերասրահի մոդելը",
      EDIT_PDF_GALLERY_MODEL: "Խմբագրել PDF պատկերասրահի մոդելը",
      EDIT_SOCIAL_MEDIA_MODEL: "Խմբագրել սոցիալական ցանցերի մոդելը",
      BOOK: "Գիրք",
      NFC_LIST: "NFC ցուցակ",
      API_KEY_MANAGER: "Ստեղծել API բանալի",
      PRE_PURCHASE: "Նախնական գնում",
      PRE_PURCHASE_MODEL: "Պատրաստի նմուշ",
      "QR_NAME_EDIT_GIFT": "Խմբագրել նվերի QR կոդը",
      "QR_GIFT": "Նվերի QR կոդ",
      "QR_NAME_EDIT_PRO": "Խմբագրել Pro Հղման QR Կոդը",
      "QR_LINK_PRO": "QR Link Pro",
      DIGI: "Digikala գների մոնիթորինգ",
      QR_PDF: "PDF պատկերասրահ",
      QR_NAME_EDIT_PDF: "Խմբագրել PDF պատկերասրահը",
      QR_MULTICART: "QR բազմաքարտ",
      QR_MULTICART_EDIT: "Խմբագրել QR բազմաքարտը",
      QR_PRODUCTPRO: "Product Pro ներկայացում",
      QR_NAME_PRODUCTPRO: "Խմբագրել Product Pro ներկայացումը",
      QR_CATALOG: "Կատալոգ / Բրոշյուր",
      QR_NAME_EDIT_CATALOG: "Խմբագրել կատալոգը",
      QR_LUCK_WHEEL_Edit: "Խմբագրել հաջողության անիվը",
      QR_LUCK_WHEEL: "Ստեղծել QR կոդ բախտի անիվի համար",
      DASHBOARD: "Վահանակ",
      ADMIN_QR_DOMAINS: "Դոմեյնների մոնիթորինգ",
      ADMIN_TOGETHER_TOKEN: "Թոքենների մոնիթորինգ",
      ADMIN_QR_SMS: "SMS ուղարկում",
      MENU_PROFILE_INFO: "Օգտատիրոջ տեղեկատվություն",
      MENU_PROFILE_SETTING: "Պրոֆիլի կարգավորումներ",
      MENU_PROFILE_ORDERS: "Պատվերներ",
      MENU_PROFILE_ADDRESSES: "Հասցեներ",
      QR_MONITORING: "QR մոնիթորինգ",
      QR_LIST: "Իմ QR ցուցակը",
      QR_NAME_LIST: "Մասնակցության կառավարում",
      QR_GENERATE_MULTIPLE: "Զանգվածային QR կոդերի ստեղծում",
      QR_CARD_VISIT: "Ստեղծել այցելության քարտ",
      HELP_INFO: "Կոճակի փորձարկում",
      QR_MENU: "Խանութի մենյու",
      QR_APPOINTMENT: "Պայմանավորվածություն",
      QR_INSURANCE: "Ստեղծել առցանց ապահովագրություն",
      QR_BPAGE: "Ստեղծել բիզնես էջ",
      QR_CPAGE: "Ստեղծել առևտրային/վարչական համալիրի կայք",
      QR_BSHOP: "Առցանց խանութ",
      QR_NAME_EDIT_BSHOP: "Խմբագրել առցանց խանութը",
      QR_LINK_EDIT: "Խմբագրել հղումը",
      QR_NAME_DESIGN: "Խմբագրել դիզայնը",
      QR_NAME_SETTING: "Խմբագրել կարգավորումները",
      QR_NAME_EDIT: "Խմբագրել այցելության քարտը",
      QR_NAME_EDIT_BPAGE: "Խմբագրել բիզնես էջը",
      QR_EDIT_CPAGE: "Խմբագրել առևտրային/վարչական համալիրի կայքը",
      QR_NAME_INSURANCE: "Խմբագրել առցանց ապահովագրությունը",
      QR_NAME_EDIT_MENU: "Խմբագրել մենյուն",
      QR_NAME_EDIT_APPLICATION: "Տրամադրել հավելվածը",
      QR_NAME_EDIT_APPOINTMENT: "Խմբագրել պայմանավորվածությունը",
      QR_NAME_EDIT_PHOTO: "Խմբագրել լուսանկարների պատկերասրահը",
      QR_NAME_EDIT_VIDEO: "Խմբագրել վիդեո պատկերասրահը",
      QR_NAME_EDIT_VOICE: "Խմբագրել ձայնային պատկերասրահը",
      QR_NAME_EDIT_FEEDBACK: "Խմբագրել արձագանքների պատկերասրահը",
      QR_NAME_CONSULTATION_QR_EDIT: "Խմբագրել հայտի ձևը",
      QR_NAME_EDIT_VOICE_PRO: "Խմբագրել ձայնային պատկերասրահը (Pro)",
      QR_NAME_EDIT_SOCIAL: "Խմբագրել սոցիալական ցանցերը",
      QR_NAME_STATISTICS: "QR կոդի վիճակագրություն",
      QR_CATE: "Ընտրել կատեգորիան",
      QR_SHARE: "Կիսվել",
      QR_BUSINESS_SHOP: "Բիզնես/Խանութ",
      QR_CO_ORGAN: "Ընկերություն/Կազմակերպություն",
      QR_CONTACT: "Հաճախորդի կապ",
      QR_NOTICES: "Ծանուցումներ",
      QR_OTHERS: "Այլ",
      QR_STATICS: "Ստատիկ QR",
      QR_DYNAMICS: "Դինամիկ QR",
      QR_D_BUSINESS: "Դինամիկ բիզնես QR",
      QR_D_ORGANS: "Դինամիկ կազմակերպչական QR",
      QR_D_GOVERNMENT: "Դինամիկ կառավարական QR",
      QR_VIDEO: "Վիդեո պատկերասրահ",
      QR_APPLICATION: "Տրամադրել հավելվածը",
      QR_VOICE: "Ձայնային պատկերասրահ",
      QR_VOICE_PRO: "Ձայնային պատկերասրահ (Pro)",
      QR_CONSULTATION_QR: "Հայտի ձև",
      QR_FEEDBACK: "Արձագանքների պատկերասրահ",
      QR_PHOTO: "Լուսանկարների պատկերասրահ",
      QR_LOCATION: "Ստեղծել տեղանքի QR",
      QR_SOCIAL_MEDIA: "Ստեղծել սոցիալական ցանցերի QR",
      QR_LINK: "Ստեղծել հղում",
      QR_TEXT: "Ստեղծել տեքստ",
      QR_MAIL: "Ստեղծել էլ. փոստ",
      QR_CALL: "Զանգ",
      QR_SMS: "SMS",
      QR_WHATSAPP: "WhatsApp",
      QR_SITE: "Կայք",
      QR_INSTAGRAM: "Instagram",
      QR_SKYPE: "Skype",
      QR_WIFI: "Wi-Fi",
      QR_BUSINESS: "Բիզնես էջ",
      QR_DISCOUNT: "Զեղչի էջ",
      QR_PRODUCT_SHOP: "Ապրանքի ներկայացում",
      QR_PRODUCT_LABEL: "Ապրանքի պիտակ",
      QR_GOLD_LABEL: "Ոսկե պիտակ",
      QR_PRODUCT_TEMPLATE: "Ապրանքներ",
      ADMIN_CATEGORY: "Կատեգորիաներ",
      QR_NFC_ORDERS: "NFC քարտեր՝ սպասում են հաստատման",
      QR_NAME_PRODUCT: "Խմբագրել ապրանքի ներկայացումը",
      QR_NAME_LABELPRODUCT: "Խմբագրել ապրանքի պիտակը",
      QR_NAME_GOLDPRODUCT: "Խմբագրել ոսկե պիտակը",
      QR_COINS: "Կրիպտոարժույթներ",
      QR_SHOP: "Խանութի կառավարում",
      QR_TWITTER: "Twitter",
      UPLOAD_CENTER: "Վերբեռնման կենտրոն",
      PRICING: "QR գներ",
      QR_CREATE_MODELS: "Ստեղծել այցելության քարտի մոդել",
      QR_CREATE_BUSINESS_MODELS: "Ստեղծել բիզնես էջի մոդել",
      QR_CREATE_PRODUCT_MODEL: "Ստեղծել ապրանքի քարտի մոդել",
      QR_CREATE_MENU_MODELS: "Ստեղծել խանութի մենյուի մոդել",
      QR_CREATE_SHOP_MODEL: "Ստեղծել առցանց խանութի մոդել",
      MODELS_LIST: "QR մոդելների տեսակներ",
      MODELS_LIST_EDIT: "Խմբագրել մոդելը",
      MODELS_LIST_MENU_EDIT: "Խմբագրել մենյուի մոդելը",
      MODELS_LIST_BMODEL_EDIT: "Խմբագրել առցանց խանութի մոդելը",
      NFC: "NFC քարտեր",
      SUBMIT_FORM: "Գրանցել բլոգերը",
      REQUEST_LIST: "Բլոգերների ցուցակ",
      PURE_DATA: "Չստեղծված այցելության քարտերի ցուցակ",
      AUTO_CREATE: "Ավտոմատ QR ստեղծում",
      QR_CREATE: "Ստեղծել QR",
      HISTORY_REMINDER: "Հիշեցման մոնիթորինգ",
      BOOK: "Հիշեցման մոնիթորինգ"
    },
  },
  COMPONENTS: {
    QR_SHOP_MANAGER: {
      PAYMENT_METHODS: "Վճարման եղանակներ",
      ORDER_NOTIFICATIONS: "Պատվերի ծանուցումներ",
      DISCOUNT_CODE: "Զեղչի կոդ",
      CART: "Գնումների զամբյուղ",
      TABLE_MANAGEMENT: "Սեղանի կառավարում",
    },
    ERRORS: {
      INVALID_INPUT: "Խնդրում ենք ճիշտ մուտքագրել արժեքները!",
      CART_SETTINGS_FAILED: "Գնումների զամբյուղի կարգավորումները ձախողվել են!",
    },
  },
  popup: {
    prepared_stores_title: "Պատրաստի առցանց խանութների օրինակներ",
  },
  buttons: {
    reset_defaults: "Վերականգնել լռելյայն տվյալները",
    download_qr: "Ներբեռնել QR",
    cleardefaults: "Ջնջել լռելյայն տեղեկատվությունը",
    select_prepared_store: "Ընտրել պատրաստի առցանց խանութ",
  },
  stepper: {
    create_qr: "Ստեղծել QR",
    products_info: "Ապրանքներ և տեղեկատվություն",
    content_settings: "Բովանդակության կարգավորումներ",
    sales_settings: "Վաճառքի կարգավորումներ",
  },
  fields: {
    online_store_name: "Առցանց խանութի անուն",
    qr_address: "QR հասցե",
    qr_address_hint: "Մուտքագրեք Ձեր QR հասցեն",
    online_sale: "Առցանց վաճառք",
  },
  login_settings: "Մուտքի կարգավորումներ",
  shop_logo_and_images: "Խանութի լոգո և պատկերներ",
  login_page_info: "Մուտքի էջի տեղեկատվություն",
  upload_banner: "Վերբեռնել բաններ",
  create_product: "Ստեղծել ապրանք",
  special_sale: "Հատուկ վաճառք",
  ended: "Ավարտված",
  blog: "Բլոգ",
  services: "Ծառայություններ",
  pdf_gallery: "PDF պատկերասրահ",
  create_section: "Ստեղծել բաժին",
  achievements: "Ձեռքբերումներ",
  team_members: "Թիմի անդամներ",
  working_hours: "Աշխատանքային ժամեր",
  saturday: "Շաբաթ",
  sunday: "Կիրակի",
  monday: "Երկուշաբթի",
  tuesday: "Երեքշաբթի",
  wednesday: "Չորեքշաբթի",
  thursday: "Հինգշաբթի",
  friday: "Ուրբաթ",
  we_will_be_different: "Մենք կլինենք տարբեր...",
  striving_for_excellence:
    "Մենք միշտ ձգտում ենք լինել լավագույնը >>> Ձեզ համար",
  online_store_ready_15_minutes: "Ձեր առցանց խանութը պատրաստ է 15 րոպեում!",
  sales_management: "Վաճառքի կառավարում",
  dear_customer_online_stores:
    "Հարգելի հաճախորդ, կարող եք գնումներ կատարել նաև մեր այլ առցանց խանութներից՝",
  divar_site: "Divar կայք",
  digikala_site: "Digikala կայք",
  basalam_site: "Basalam կայք",
  torob_site: "Torob կայք",
  emalls_site: "Emalls կայք",
  copyright_qrland: "Բոլոր իրավունքները պահպանված են QR Land-ի կողմից:",
  tehran_address:
    "Թեհրան, Շարիաթի փողոց, Սեյեդ Խանդան կամրջից հետո, Խանդան նրբանցք, թիվ 6",
  our_achievements: "Մեր խմբի ձեռքբերումները",
  customer_satisfaction: "Հաճախորդների գոհունակություն",
  lowest_returns: "Ամենացածր վերադարձեր",
  loyal_customer: "Հավատարիմ հաճախորդ",
  shipped_orders: "Առաքված պատվերներ",
  visit_our_videos: "Դիտեք մեր խմբի տեսանյութերը:",
  bringing_the_best: "Մենք Ձեզ համար բերել ենք լավագույնը...",
  feedback_important: "Ձեր արձագանքը կարևոր է մեզ համար",
  guide_us_with_feedback:
    "Խնդրում ենք օգնել մեզ ավելի լավ ծառայություններ մատուցել՝ պատասխանելով ստորև բերված հարցերին:",
  satisfied_with_quality: "Գոհ էի՞ք ապրանքների որակից:",
  evaluate_packaging_quality: "Ինչպե՞ս եք գնահատում փաթեթավորման որակը:",
  satisfied_with_variety: "Գոհ էի՞ք ապրանքների բազմազանությունից:",
  benefited_from_discounts: "Օգտվե՞լ եք այս խանութի զեղչերից:",
  post_1: "Գրառում 1",
  fast_order_delivery: "Արագ պատվերի առաքում",
  post_2: "Գրառում 2",
  post_3: "Գրառում 3",
  product_authenticity_guarantee: "Ապրանքի իսկության երաշխիք",
  comfortable_purchase: "Հարմարավետ գնում",
  how_to_place_order: "Ինչպե՞ս կարող եմ տեղադրել իմ պատվերը:",
  add_to_cart:
    "Պարզապես ավելացրեք Ձեր ցանկալի ապրանքները գնումների զամբյուղում:",
  how_to_register: "Ինչպե՞ս կարող եմ գրանցվել կայքում:",
  click_login_and_enter_code:
    "Պարզապես սեղմեք «Մուտք» կոճակը և, մուտքագրելով Ձեր բջջային համարը, մուտքագրեք SMS կոդը:",
  delivery_time:
    "Որքա՞ն ժամանակ կպահանջվի իմ պատվերը ստանալու համար գրանցումից հետո:",
  fastest_delivery: "Ձեր պատվերը կառաքվի հնարավորինս արագ:",
  shipping_cost: "Որքա՞ն է առաքման արժեքը:",
  shipping_cost_order: "Պատվերի առաքման արժեք",
  variable_shipping_cost: "Առաքման արժեքը տարբերվում է՝ կախված Ձեր հասցեից:",
  change_or_cancel_order:
    "Կարո՞ղ եմ փոխել կամ չեղարկել իմ պատվերը տեղադրումից հետո:",
  no_change_or_cancel: "Ոչ: Փոփոխություն կամ չեղարկում հնարավոր չէ:",
  mrs_Safdarian: "Տիկին Սաֆդարյան",
  invalid_address: "Մուտքագրված հասցեն անվավեր է!",
  shop_page_created_success: "Ձեր խանութի էջը հաջողությամբ ստեղծվել է:",
  qr_creation_failed: "QR-ի ստեղծումը ձախողվել է!",
  server_error: "Սերվերի սխալ!",
  qr_card_updated_success: "Ձեր այցելության քարտը հաջողությամբ խմբագրվել է:",
  qr_save_edit_failed: "Սխալ QR-ի պահպանման/խմբագրման ժամանակ",
  your_feedback: "Ձեր արձագանքը",
  digital_marketing_strategy:
    "Ձեր ընկերությունը ճիշտ ուղու վրա դրեք մեր թվային մարկետինգի ռազմավարով",
  wait_for_default_products:
    "Խնդրում ենք սպասել, մինչև լռելյայն ապրանքները լիովին բեռնվեն Ձեր կայքում:",
  template_categories_saved: "Մոդելի կատեգորիաները հաջողությամբ պահպանվել են:",
  template_products_saved: "Մոդելի ապրանքները հաջողությամբ պահպանվել են:",
  template_products_save_failed: "Սխալ մոդելի ապրանքների պահպանման ժամանակ!",
  template_categories_save_failed:
    "Սխալ մոդելի կատեգորիաների պահպանման ժամանակ!",
  login_page_text: "Մուտքի էջի տեքստ",
  persian_error: "Տեքստը պետք է լինի պարսկերեն",
  number_error: "Մուտքագրված տվյալները չպետք է լինեն ոչ թվային կամ դատարկ",
  english_error: "Տեքստը չպետք է լինի ոչ անգլերեն կամ դատարկ",
  mixPerEng_error:
    "Տեքստը չպետք է լինի ոչ անգլերեն կամ ոչ պարսկերեն կամ դատարկ",
  email_error: "Մուտքագրված էլ. փոստի ձևաչափը անվավեր է",
  mobile_error: "Մուտքագրված համարի ձևաչափը անվավեր է",
  meliCode_error: "Մուտքագրված ազգային կոդի ձևաչափը անվավեր է",
  site_error: "Մուտքագրված կայքի ձևաչափը անվավեր է",
  min_length_error: "Մուտքագրված արժեքը չի կարող լինել {{min}}-ից պակաս",
  max_length_error: "Մուտքագրված արժեքը չի կարող լինել {{max}}-ից ավելի",
  form_submitted_message: "Ձեր ձևը հաջողությամբ ուղարկվել է",
  required_fields_error: "Պարտադիր արժեքները մուտքագրված չեն",
  headphone_title: "Ականջակալներ",
  buy_button: "Գնել",
  day: "օր",
  hour: "ժամ",
  minute: "րոպե",
  second: "վայրկյան",
  required_field_error: "{{fieldName}}-ը պարտադիր է",
  submit_request_button: "Ուղարկել հայտ",
  request_submitted_success: "Ձեր հայտը հաջողությամբ գրանցվել է",
  feedback_submitted_success: "Ձեր արձագանքը հաջողությամբ գրանցվել է",
  description_required_label: "Նկարագրություն (պարտադիր)",
  description_optional_label: "Նկարագրություն (ընտրովի)",
  description_hint:
    "Խնդրում ենք մուտքագրել Ձեր ցանկալի նկարագրությունը այս դաշտում (նվազագույնը 3 նշան)",
  footer: {
    position: "Կողմ",
    contactUs: "Կապվեք մեզ հետ",
    aboutUs: "Մեր մասին",
    firstShift: "Առաջին հերթափոխ",
    secondShift: "Երկրորդ հերթափոխ",
    startTime: "Սկզբի ժամ",
    endTime: "Ավարտի ժամ",
    features: "Հատկություններ",
    partners: "Գործընկերներ",
    affiliates: "Աֆիլիատ ծրագրեր",
    panels: "Վահանակներ",
    supportTicket: "Աջակցության տոմս",
    inPersonServices: "Անձամբ ծառայություններ",
    liveChat: "Ուղիղ զրույց",
    faq: "Հաճախ տրվող հարցեր",
    add_secondshift: "Ավելացնել երկրորդ հերթափոխ",
    firstDate: "Սկզբի ամսաթիվ",
    endDate: "Ավարտի ամսաթիվ",
  },
  qr_management: "QR կառավարում",
  restore_default_questions: "Վերականգնել լռելյայն հարցերը",
  delete_all: "Ջնջել բոլորը",
  edit_question: "Խմբագրել հարցը",
  move_up: "Տեղափոխել վերև",
  move_down: "Տեղափոխել ներքև",
  delete: "Ջնջել",
  selected_question: "Ընտրված հարց",
  question: "Հարց",
  answer_type: "Պատասխանի տեսակ",
  excellent: "Գերազանց",
  good: "Լավ",
  very_poor: "Շատ վատ",
  response_optionality: "Ընտրովի / Պարտադիր պատասխան",
  required: "Պարտադիր",
  optional: "Ընտրովի",
  add_new_question: "Ավելացնել նոր հարց",
  satisfied_with_quality: "Գոհ էի՞ք ապրանքների որակից:",
  evaluate_packaging_quality: "Ինչպե՞ս եք գնահատում փաթեթավորման որակը:",
  satisfied_with_variety: "Գոհ էի՞ք ապրանքների բազմազանությունից:",
  benefited_from_discounts: "Օգտվե՞լ եք այս խանութի զեղչերից:",
  suggestions_for_improvement:
    "Ի՞նչ առաջարկություն ունեք այս խանութում գնումների փորձը բարելավելու համար:",
  confirm_delete_question: "Ջնջե՞լ ընտրված հարցը:",
  question_deleted_success: "Հարցը հաջողությամբ ջնջվել է:",
  question_delete_failed: "Սխալ հարցը ջնջելու ժամանակ!",
  confirm_delete_all_questions:
    "Համոզվա՞ծ եք, որ ցանկանում եք ջնջել բոլոր հարցերը:",
  questions_deleted_success: "Հարցերը հաջողությամբ ջնջվել են:",
  questions_delete_failed: "Սխալ հարցերը ջնջելու ժամանակ!",
  invalid_input: "Խնդրում ենք ճիշտ մուտքագրել արժեքները!",
  operation_failed: "Գործողությունը ձախողվել է!",
  question_number: "Հարց {number}?",
  card_subtitle:
    "Պարզապես մուտքագրեք Ձեր ցանկալի պատկերի պատմությունը, և AI-ն կստեղծի այն Ձեզ համար:",
  upgrade_label: "Կցել",
  free: " - Անվճար",
  language_select: "Ընտրել լեզուն հայտի տեքստ գրելու համար",
  image_size: "Պատկերի չափ",
  prompt_label: "Հայտի տեքստ",
  prompt_placeholder: "Նկարագրեք Ձեր ցանկալի պատկերը...",
  generate_image: "Ստեղծել պատկեր",
  regenerate_image: "Ստեղծել նոր պատկեր",
  save_image: "Պահպանել պատկերը",
  save_image_subtitle: "Կպահպանվի միայն վերևում ցուցադրված պատկերը:",
  size_items: {
    "16:9": "16:9 (հորիզոնական)",
    "9:16": "9:16 (ուղղահայաց)",
    "1:1": "1:1 (քառակուսի)",
  },
  lang_items: {
    fa: "Fa | Պարսկերեն",
    en: "En | Անգլերեն",
    ar: "Ar | Արաբերեն",
  },
  rules: {
    empty: "Պետք է մուտքագրվի առնվազն 3 նշան!",
    spell_checker: "Մուտքագրված տեքստը պետք է լինի {language} լեզվով!",
  },
  ERRORS: {
    VpnDetectedTitle: "Անջատեք Ձեր VPN-ը",
    VpnDetectedSubtitle:
      "Սա օգնում է համակարգին ավելի լավ աշխատել և Ձեզ ավելի լավ փորձ տալ:",
  },
  errors: {
    VpnDetectedTitle: "Անջատեք Ձեր VPN-ը",
    VpnDetectedSubtitle:
      "Սա օգնում է համակարգին ավելի լավ աշխատել և Ձեզ ավելի լավ փորձ տալ:",
    invalid_size: "Խնդրում ենք ճիշտ մուտքագրել լայնությունն ու բարձրությունը!",
    image_generation_error: "Սխալ պատկերի ստեղծման ժամանակ",
    image_upload_error: "Սխալ պատկերի վերբեռնման ժամանակ!",
    service_unavailable:
      "Այս ծառայությունը հասանելի չէ – սերվերից տվյալները բեռնելիս սխալ է տեղի ունեցել",
    qr_address_taken: "Այս QR հասցեն արդեն զբաղված է",
  },
  add_working_time: "Ավելացնել աշխատանքային ժամ",
  selected_day: "Ընտրված օր",
  range_name: "Ժամանակային միջակայքի անուն",
  add: "Ավելացնել",
  first_shift: "Առաջին հերթափոխ",
  second_shift: "Երկրորդ հերթափոխ",
  start_time: "Սկզբի ժամ",
  end_time: "Ավարտի ժամ",
  date_range: "Ամսաթվերի միջակայք",
  all_week_days: "Շաբաթվա բոլոր օրերը",
  saturday_to_wednesday: "Շաբաթից չորեքշաբթի",
  saturday_to_thursday: "Շաբաթից հինգշաբթի",
  work_week: "Շաբաթվա բոլոր օրերը (բացի տոներից)",
  feedbacks: "Արձագանքներ",
  failed_retrieve_feedback: "Արձագանքների ստացումը ձախողվել է!",
  province: "Մարզ",
  search_city_placeholder: "Որոնել ցանկալի քաղաքի անունը:",
  search_city_label: "Քաղաքի որոնում",
  welcome: "Բարի գալուստ մեր հավելված",
  description: "Սա բազմալեզու հավելված է:",
  soon: "Շուտով",
  beta_version: "Բետա տարբերակ",
  defaults_cleared_success: "Լռելյայն տվյալները հաջողությամբ ջնջվել են",
  defaults_reset_success: "Լռելյայն տվյալները հաջողությամբ վերականգնվել են",
  select_navigator_after_location_click:
    "Տեղը սեղմելուց հետո ընտրեք ցանկալի նավիգատորը",
  no_address_selected: "Հասցե չի ընտրվել",
  no_location_selected: "Տեղ չի ընտրվել",
  region: "Տարածաշրջան",
  api_unauthorized: "Վավերացման սխալ՝ անվավեր API բանալի",
  location_not_found: "Տեղը չի գտնվել",
  addCategory: "Ավելացնել նոր կատեգորիա",
  editCategory: "Խմբագրել կատեգորիան",
  deleteCategory: "Ջնջե՞լ ընտրված կատեգորիան",
  addProduct: "Ավելացնել նոր ապրանք",
  saveProducts: "Ընտրել լռելյայն ապրանքները",
  addSubCategory: "Ավելացնել ենթակատեգորիա",
  product: "Ապրանք",
  categoryName: "Կատեգորիայի անուն",
  subCategoryName: "Ենթակատեգորիայի անուն",
  confirmDeleteProduct: "Ապրանքը պետք է հեռացվի՞ կատեգորիայից",
  successMessages: {
    categorySaved: "Կատեգորիաները հաջողությամբ պահպանվել են։",
    productSaved: "Ապրանքները հաջողությամբ պահպանվել են։",
    productDeleted: "Ապրանքը հաջողությամբ ջնջվել է։",
  },
  errorMessages: {
    saveCategoryFailed: "Սխալ կատեգորիաները պահպանելիս!",
    saveProductFailed: "Սխալ ապրանքները պահպանելիս!",
    deleteCategoryFailed: "Սխալ կատեգորիան ջնջելիս!",
  },
  add_edit_categories: "Ավելացնել/խմբագրել կատեգորիա",
  copy_category: "Պատճենել կատեգորիան",
  product: "Ապրանք {point}",
  copy_product: "Պատճենել ապրանքը",
  add_edit_products: "Ավելացնել/խմբագրել ապրանքներ",
  edit_category: "Խմբագրել կատեգորիան",
  category_name: "Կատեգորիայի անուն",
  edit_subcategory: "Խմբագրել ենթակատեգորիան",
  subcategory_name: "Ենթակատեգորիայի անուն",
  add_new_category: "Ավելացնել նոր կատեգորիա",
  store_management: "Խանութի կառավարում",
  manage_products: "Ապրանքների կառավարում",
  products_export: "Ներբեռնել ապրանքները",
  "UPLOAD_EXCEL.UPLOAD_TITLE": "Վերբեռնել Excel ֆայլ",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART1": "Քաշեք Ձեր Excel ֆայլը այստեղ կամ",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART2": "ընտրեք այն",
  "UPLOAD_EXCEL.DRAG_DROP_TEXT_PART3": "վերբեռնելու համար",
  "UPLOAD_EXCEL.INVALID_FILE_TYPE":
    "Խնդրում ենք վերբեռնել միայն Excel ֆայլեր (.xlsx)",
  "GENERAL.SUBMIT": "Ուղարկել",
  "GENERAL.CANCEL": "Չեղարկել",
  "GENERAL.SUCCESSFULLY_ADDED": "Ապրանքները հաջողությամբ վերբեռնվել են",
  SUCCESSFULLY_DOWNLOADED: "Ապրանքները հաջողությամբ ներբեռնվել են",
  "GENERAL.ERROR": "Տեղի է ունեցել սխալ",
  EditSubCategoty: "Խմբագրել ենթակատեգորիան",
  create: "Ստեղծել",
  save_changes: "Պահպանել փոփոխությունները",
  buy_button_settings: "Գնման կոճակի կարգավորումներ",
  image: "Պատկեր",
  color: "Գույն",
  title: "Վերնագիր",
  price: "Գին",
  discount: "Զեղչ",
  percent: "Տոկոս",
  amount: "Գումար",
  brand: "Ապրանքանիշ",
  inventory: "Պահեստ",
  inventory_hint: "Թողեք դատարկ = անսահմանափակ պատվերի քանակ",
  order_limit: "Առավելագույն քանակ մեկ պատվերում",
  order_limit_hint: "Թողեք դատարկ = առանց սահմանափակման",
  packing_price: "Փաթեթավորման ծախսեր",
  packing_price_hint:
    "Կիրառվում է արտաքին պատվերների համար (սուրհանդակ/տեղում հավաքում)։",
  description: "Նկարագրություն",
  options: "Ընտրանքներ",
  product_features: "Ապրանքի առանձնահատկություններ",
  field_required: "Պարտադիր դաշտ։",
  min_length: "Պահանջվում է առնվազն 3 նիշ։",
  product: "Ապրանք",
  default_brand: "Apple",
  product_added_success: "Ապրանքը հաջողությամբ ավելացվել է",
  product_added_error: "Սխալ ապրանքը ավելացնելիս",
  whole_categories: "(Բոլոր կատեգորիաները)",
  add_select_category: "Ավելացնել/ընտրել կատեգորիա",
  select_default_category: "Ընտրել լռելյայն կատեգորիա",
  deleted_product: "Ջնջել ապրանքը",
  confirm_delete_prooduct: "Ապրանքը պետք է հեռացվի՞ կատեգորիայից",
  please_wait_store_product: "Ապրանքները պահպանվում են, խնդրում ենք սպասել...",
  saved_product_success: "Ապրանքները հաջողությամբ պահպանվել են։",
  error_in_store: "Պահպանման սխալ",
  delete_category: "Ջնջել կատեգորիան",
  confirm_delete_category: "Կատեգորիան հաջողությամբ ջնջվել է։",
  error_delete_category: "Սխալ կատեգորիան ջնջելիս!",
  productOptionEditor: {
    tabs: {
      color: "Գույն",
      size: "Չափս",
      count: "Քանակ",
      weight: "Քաշ",
      type: "Տեսակ/Սեռ",
    },
    fields: {
      count: "Քանակ",
      max_order: "Առավելագույն պատվերի քանակ",
      price: "Գին",
      discount: "Զեղչ",
      color: "Գույն",
      color_name: "Գույնի անուն",
      inventory: "Պահեստ",
      size: "Չափս",
      type: "Տեսակ/Սեռ",
      weight: "Քաշ",
    },
    actions: {
      delete: "Ջնջել",
      add_location: "Ավելացնել ընտրանք",
    },
  },
  extraSubProducts: {
    feature: "Առանձնահատկություն",
    name_label: "Անուն",
    name_placeholder: "Օրինակ՝ Լրացուցիչ սոուս / Լրացուցիչ հաց",
    price_label: "Գին",
    price_hint: "Թողեք դատարկ = անվճար հավելում։",
    price_placeholder: "Օրինակ՝ Ջուր, Տեսակ (օր.՝ հավի կրծքամիս/ազդր)",
    add_subproduct: "Ավելացնել հավելյալ ապրանք",
  },
  error_selected_category: "Սխալ կատեգորիան ընտրելիս!",
  suggestinput: {
    title: "Ընտրել էմոջի",
    aboutUs: "Մեր մասին",
    error: "Սխալ",
    errorMessage: "Խնդրում ենք լիցքավորել Ձեր կրեդիտը և կրկին փորձել։",
    generateText: "AI տեքստի առաջարկ",
    emoji: "Էմոջի",
    errorMessage_400:
      "Սխալ 'Մեր մասին' տեքստը ստեղծելիս։ Խնդրում ենք կրկին փորձել։",
    errorMessage_403:
      "Սխալ 'Մեր մասին' տեքստը ստեղծելիս։ Գնեք փաթեթ և կրկին փորձեք։",
  },
  togetherai: {
    buy_package: "Գնել փաթեթ",
    tax_notice: "Փաթեթի գնին կավելացվի 10% ԱԱՀ!",
    package: "Փաթեթ",
    rial: "Ռիալ",
    buy_button: "Գնել!",
    discount_label: "Զեղչի կոդ",
    submit_discount: "Կիրառել",
    success_message: "Ձեր QR-ը հաջողությամբ թարմացվել է։",
    error_insufficient_funds: "Ստուգեք Ձեր կրեդիտը և կրկին փորձեք ավելի ուշ։",
    error_upgrade: "Սխալ QR-ը թարմացնելիս!",
    error_title: "Սխալ",
    success_title: "Հաջողություն",
  },
  category_not_found: "Կատեգորիան չի գտնվել!",
  create_upload_category: "Ստեղծել և վերբեռնել կատեգորիա",
  add_subcategory: "Ավելացնել ենթակատեգորիա",
  error_upload_m_video:
    "Սխալ վիդեո վերբեռնելիս (հնարավոր է սահմանափակված մուտք)։",
  info_show_video: "Սեղմեք 'Ավելին' ավելի շատ ցուցադրելու համար։",
  error_not_valid_guide_id: "Անվավեր ուղեցույցի ID!",
  error_give_guide_info: "Սխալ ուղեցույցի տեղեկատվությունը ստանալիս!",
  info_success_saved: "Հաջողությամբ պահպանվել է",
  error_add_new_guide: "Սխալ նոր ուղեցույց ավելացնելիս",
  popup: {
    details: "Մանրամասներ",
    guide_images: "Ուղեցույցի պատկերներ",
    guide_videos: "Ուղեցույցի վիդեոներ",
    faq: "ՀՏՀ",
    no_title: "Առանց վերնագրի",
    no_content: "Ցուցադրելու բովանդակություն չկա",
    no_questions: "Ցուցադրելու հարց չկա",
    video_error: "Սխալ վիդեո վերբեռնելիս (հնարավոր է սահմանափակված մուտք)",
    no_answer: "Առանց պատասխանի",
    question_no_title: "Հարց առանց վերնագրի",
    default_title: "Ուղեցույց",
  },
  productPicker: {
    select_default_product: "Ընտրել լռելյայն ապրանք",
    search: "Որոնել",
    select_all_products: "Ընտրել բոլոր ապրանքները",
    back: "Հետ",
    no_products_in_category: "Այս կատեգորիայում ապրանքներ չկան!",
    products_error: "Սխալ ապրանքները բեռնելիս!",
    retry: "Կրկին փորձել",
    items_per_page: "Տարրեր մեկ էջում",
    root_breadcrumb: "/",
  },
  end_date: "Ավարտի ամսաթիվ",
  filters: {
    userType: {
      legal: "Իրավաբանական անձ",
      individual: "Ֆիզիկական անձ",
    },
    serviceType: {
      Payamakland: "Payamakland",
      Coreland: "Coreland",
      Qrland: "Qrland",
      Robotland: "Robotland",
      billboard: "Billboard",
      tablighNegar: "TablighNegar",
      unknown: "Անհայտ",
    },
    qrType: {
      gift: "Հիշողությունների շրջանակ",
      instagram: "Instagram",
      visitCard: "Այցեքարտ",
      Business: "Անձնական / Կորպորատիվ",
      Commericial: "Առևտրային / գրասենյակային համալիրի կայք",
      qrlink: "QR հղում",
      labelproduct: "Ապրանքի պիտակ",
      goldLabel: "Ոսկու պիտակ",
      bShop: "Խանութ",
      SocialMedia: "Սոցիալական ցանցեր",
      VideoGallery: "Տեսանյութերի պատկերասրահ",
      PhotoGallery: "Լուսանկարների պատկերասրահ",
      voiceGallery: "Ձայնային պատկերասրահ",
      consultationQr: "Հարցման ձև",
      application: "Հավելված",
      feedbackGallery: "Հետադարձ կապ",
      voiceGalleryPro: "Մասնագիտական ձայնային պատկերասրահ",
      singleProduct: "Ապրանքի ներկայացում",
      menu: "Մենյու",
      appointment: "Ժամադրության ամրագրում",
      insurance: "Ապահովագրություն",
      text: "Տեքստ",
      luck_wheel: "Հաջողության անիվ",
      pdfgallery: "PDF պատկերասրահ",
      productpro: "Pro արտադրանքի ներկայացում",
      multicard: "Բազմաքարտ",
      catalog: "Կատալոգ",
      visitCard_pro: "Pro այցեքարտ",
      clickyarseo: "ClickYar SEO QR",
    },


    expire: {
      day: "Օր",
      expired: "Ժամկետանց",
    },
    numericPersianNumber: {
      thousand: "Հազար",
      million: "Միլիոն",
    },
    dateString: {
      at: "ժամը",
    },
    messages: {
      pleaseLogin: "Խնդրում ենք մուտք գործել",
      invalidPhone: "Անվավեր հեռախոսահամար",
      copied: "Պատճենվել է",
    },
  },
  nextButton: "Հաջորդ",
  previousButton: "Նախորդ",
  rowsPerPageText: "Տողեր մեկ էջում",
  noDataText: "Ցուցադրելու տվյալներ չկան",
  placeholderSearch: "Որոնել..",
  set_qr: "QR գրանցված է",
  numbers: "Թվեր",
  enter_param_product: "Ճիշտ մուտքագրեք ապրանքի տվյալները!",
  instagram_hint: "Մուտքագրեք Ձեր Instagram-ը",
  whatsapp_hint: "Մուտքագրեք Ձեր WhatsApp-ը",
  telegram: "Telegram",
  telegram_hint: "Մուտքագրեք Ձեր Telegram-ը",
  userpicker: {
    select_user: "Ընտրել օգտատեր",
    choice_users: "Ընտրել օգտատերեր",
    id: "ID",
    phone_number: "Բջջային համար",
    date_created: "Ստեղծման ամսաթիվ",
    info_edit: "Խմբագրել տեղեկատվությունը",
    name_family: "Անուն և ազգանուն",
    position: "Պաշտոն և աստիճան",
    phone: "Հեռախոսահամար",
    discription: "Նկարագրություն",
  },
  search_product: "Որոնել ապրանք",
  search_name_product: "Որոնել ապրանքի անուն",
  currency: "Ռիալ",
  headers: {
    index: "Հերթականություն",
    gallery: "Պատկեր",
    id: "ID",
    name: "Անուն",
    brand: "Ապրանքանիշ",
    price: "Գումար",
    discount_amount: "Զեղչ",
  },
  search_categories: "Որոնել կատեգորիաներում",
  delete_all: "Ջնջել բոլորը",
  select_category: "Ընտրել կատեգորիա",
  currency1: "Իրանական ռիալ",
  features: "Առանձնահատկություններ",
  product_sp: {
    edit: "Խմբագրել",
    back: "Հետ",
    save: "Պահպանել",
    add_product_to_special_category:
      "Լրացրեք դաշտերը ապրանքը հատուկ կատեգորիա ավելացնելու համար",
    inventory: "Պահեստ",
    discount: "Զեղչ",
    max_per_customer: "Առավելագույնը մեկ հաճախորդի համար",
    max_per_order: "Առավելագույնը մեկ պատվերում",
    expires_at: "Ժամկետի ավարտ",
    field_cannot_be_empty: "Դաշտը չի կարող դատարկ լինել։",
    please_enter_correctly: "Խնդրում ենք ճիշտ լրացնել!",
    currency: "Իրանական ռիալ",
  },
  selectproduct: "Ընտրել ապրանք",
  section: {
    edit_part: "Խմբագրել բաժինը",
    title: "Վերնագիր",
    position_text: "Տեքստի դիրք",
    add_video: "Ավելացնել վիդեո",
    text: "Տեքստ",
    address_video: "Վիդեոյի URL",
    position_left: "Ձախ",
    position_right: "Աջ",
    tab_edit_button: "Խմագրման կոճակ",
    tab_content: "Բաժնի բովանդակություն",
  },
  name_shopping: "Խանութի անուն",
  hint_shopping: "Մուտքագրեք Ձեր խանութի անունը։",
  title_discount: "Զեղչի վերնագիր",
  hint_discount: "Մուտքագրեք Ձեր զեղչի վերնագիրը։",
  hint_mount_discount: "20% զեղչ Ձեր հաջորդ պատվերում։",
  label_discount: "Մուտքագրեք զեղչի գումարը",
  give_discount: "Ստանալ զեղչի կոդ",
  give_copon: "Ստանալ կուպոն",
  enter_copon: "Մուտքագրեք կուպոնը",
  hint_phone: "Մուտքագրեք Ձեր հեռախոսահամարը։",
  label_phone: "Հեռախոսահամար",
  hint_condition_discount: "Նկարագրեք զեղչի պայմանները..",
  label_discription_discount: "Զեղչի նկարագրություն",
  add_info_discount: "Ավելացնել լրացուցիչ տեղեկատվություն՝",
  enter_address_discount: "Մուտքագրեք Ձեր հասցեն։",
  address_discount: "Հասցե",
  edit_feedback: "Խմբագրել հետադարձ կապը",
  select_type_replay: "Ընտրել պատասխանի տեսակ",
  field_discription: "Նկարագրության դաշտ",
  messages_discription:
    "Միացրեք սա օգտատիրոջ համար նկարագրության դաշտ ցուցադրելու համար",
  number_char: "Նիշերի քանակը պետք է լինի 3-ից 50-ի միջև!",
  search: "Որոնել",
  no_videos_found: "Վիդեոներ չեն գտնվել!",
  upload_video_prompt:
    "Օգտագործեք վիդեո վերբեռնման տարածքը ֆայլ ավելացնելու համար",
  delete_success: "Հաջողությամբ ջնջվել է։",
  tabs: {
    qr_view: "QR տեսք",
    preview: "Նախադիտում",
    ready_video: "Պատրաստի վիդեո",
    video_gallery: "Վիդեո պատկերասրահ",
    link: "Հղում",
    video_upload: "Վերբեռնել վիդեո",
  },
  consultation: {
    name: "Անուն",
    surname: "Ազգանուն",
    phone: "Բջջային համար",
    nationalId: "Ազգային ID համար",
    nationalIdAuthenticate: "Վավերացնել ազգային ID-ն",
    nationalIdCorrect: "Ստուգել ազգային ID-ի ճիշտությունը",
    mail: "Էլ. փոստ",
    address: "Հասցե",
    location: "Տեղ",
    custom: "Հատուկ",
    customLabel: "Վերնագիր",
    customOptions: "Ընտրանքներ",
    optional: "Ընտրովի",
    require: "Պարտադիր",
    description: "Նկարագրություն",
  },
  add_section: "Ավելացնել բաժին",
  add_new_text_section:
    "Դուք ջերմորեն հրավիրված եք QR-Land-ի խելացի թվային երկիր։",
  btn_title_section: "Անվճար գրանցում",
  shop: {
    step_products_and_info: "Ապրանքներ & տեղեկատվություն",
    online_store_name: "Առցանց խանութի անուն",
    qr_address: "QR հասցե",
    qr_address_hint: "Մուտքագրեք Ձեր QR հասցեն",
    online_sale: "Առցանց վաճառք",
    step_content_settings: "Բովանդակության կարգավորումներ",
    step_sale_settings: "Վաճառքի կարգավորումներ",
    download_qr: "Ներբեռնել QR",
    login_settings: "Մուտքի կարգավորումներ",
    store_logo_images: "Խանութի լոգո և պատկերներ",
    login_page_info: "Մուտքի էջի տեղեկատվություն",
    upload_banner: "Վերբեռնել բաններ",
    user_info: "Օգտատիրոջ տեղեկատվություն",
    create_product: "Ստեղծել ապրանք",
    special_sale: "Հատուկ վաճառք",
    add_social_media: "Ավելացնել սոցիալական մեդիա",
    blog: "Բլոգ",
    services: "Ծառայություններ",
    faq: "ՀՏՀ",
    photo_gallery: "Լուսանկարների պատկերասրահ",
    video_gallery: "Վիդեո պատկերասրահ",
    pdf_gallery: "PDF պատկերասրահ",
    feedback: "Հետադարձ կապ",
    countdown: "Հաշվիչ",
    request_form: "Հայտի ձև",
    create_section: "Ստեղծել բաժին",
    achievements: "Ձեռքբերումներ",
    team_members: "Թիմի անդամներ",
    working_hours: "Աշխատանքային ժամեր",
    error_saving_content: "Սխալ բովանդակության կարգավորումները պահպանելիս!",
    success_edit_store: "Խանութի էջը հաջողությամբ խմբագրվել է։",
    post_1: "Գրառում 1",
    logo: "Լոգո",
    background_image: "Ֆոնային պատկեր",
  },
  discount_obj: {
    quantity: "քանակ",
    create_edit_code: "Ստեղծել/խմբագրել զեղչի կոդ",
    coding_type_label: "Ստեղծման տեսակ",
    coding_type_single: "Մեկ",
    coding_type_group: "Խումբ",
    status_label: "Կարգավիճակ",
    status_active: "Ակտիվ",
    status_deactivate: "Ապաակտիվացված",
    discount_code: "Զեղչի կոդ",
    discount_type: "Զեղչի տեսակ",
    discount_type_percent: "Տոկոս",
    discount_type_fixed: "Ֆիքսված գումար",
    discount_value: "Զեղչի արժեք",
    discount_limit: "Զեղչի սահման",
    no_limit: "Առանց սահմանի",
    tab_create_discount: "Ստեղծել զեղչի կոդ",
    tab_settings: "Կարգավորումներ",
    success_create: "Զեղչի կոդը հաջողությամբ ստեղծվել է",
    success_edit: "Զեղչի կոդը հաջողությամբ խմբագրվել է",
    error_value_empty: "Զեղչի արժեքը չի կարող դատարկ լինել!",
    error_start_time: "Սկզբի ժամանակ չի ընտրվել!",
    error_end_time: "Ավարտի ժամանակ չի ընտրվել!",
    error_same_time: "Սկզբի և ավարտի ժամանակները չեն կարող նույնը լինել",
  },
  personnel: {
    team_members: "Ընտրված թիմի անդամներ",
    add_team_member: "Ավելացնել թիմի անդամ",
    default_position: "Պաշտոն և աստիճան",
    default_phone: "Հեռախոսահամար",
    default_full_name: "Ամբողջական անուն",
    default_description:
      "Lorem Ipsum-ը պարզապես տպագրության արդյունաբերության կեղծ տեքստ է, որն օգտագործվում է դիզայներների կողմից դարեր շարունակ",
  },
  discount_settings: {
    function_type: {
      title: "Զեղչի ֆունկցիա",
      all_shopping_cart: "Ընդհանուր զամբյուղի գումար",
      special_products: "Հատուկ ապրանքներ",
      special_categories: "Հատուկ կատեգորիաներ",
    },
    basket_condition: {
      title: "Զամբյուղի պայմաններ",
      no_conditions: "Առանց պայմանների",
      minimum_shopping: "Զամբյուղի նվազագույն գումար",
      minimum_product: "Զամբյուղում նվազագույն ապրանքներ",
      maximum_shopping: "Զամբյուղի առավելագույն գումար",
      maximum_product: "Զամբյուղում առավելագույն ապրանքներ",
    },
    user_settings: {
      title: "Օգտատիրոջ կարգավորումներ",
      all_user: "Բոլոր օգտատերերը",
      group: "Օգտատերերի խումբ",
      special: "Հատուկ օգտատերեր",
    },
    limitation_use: {
      title: "Օգտագործման սահմանափակում",
      no_limitations: "Առանց սահմանափակումների",
      discount_code: "Զեղչի կոդի օգտագործումների քանակ",
      user: "Օգտագործումներ մեկ օգտատիրոջ համար",
    },
    start_time: {
      title: "Զեղչի սկզբի ամսաթիվ",
      no_time_selected: "Սկզբի ժամանակ չի ընտրվել",
    },
    end_time: {
      title: "Զեղչի ավարտի ամսաթիվ",
      no_time_selected: "Ավարտի ժամանակ չի ընտրվել",
    },
  },
  counterService: {
    typeLabel: "Ցուցադրման տեսակ",
    number: "Թիվ",
    percent: "Տոկոս",
    iconLabel: "Պատկերակ",
    counterLabel: "Արժեք",
    linkLabel: "Հղում",
    nameLabel: "Վերնագիր",
    addButton: "Ավելացնել հաջողություն",
    successful: {
      added: "Տարրը հաջողությամբ ավելացվել է",
      removed: "Տարրը հաջողությամբ հեռացվել է",
      movedUp: "Տարրը հաջողությամբ տեղափոխվել է վերև",
      movedDown: "Տարրը հաջողությամբ տեղափոխվել է ներքև",
    },
  },
  qrUsersList: {
    customersList: "Հաճախորդների ցուցակ",
    orders: "Պատվերներ",
    addresses: "Հասցեներ",
    hasAssistantsMobile_hint: "Ընտրել բջջային",
    invalidPhone: "Մուտքագրված բջջային համարը վավեր չէ",
    validation: {
      nameRequired: "Անունը պարտադիր է",
      nameMinLength: "Անունը պետք է լինի առնվազն 2 նիշ",
      familyRequired: "Ազգանունը պարտադիր է",
      familyMinLength: "Ազգանունը պետք է լինի առնվազն 2 նիշ",
    },
    addUser: "Ավելացնել օգտատեր",
    registerOnline: "Միացնել առցանց գրանցումը",
    usersColumns: {
      id: "ID",
      name: "Անուն",
      family: "Ազգանուն",
      mobile: "Բջջային",
      subscriptionId: "Բաժանորդագրության ID",
      ordersCount: "Պատվերների քանակ",
      lastLogin: "Վերջին մուտք",
      status: "Կարգավիճակ",
      activeUser: "Ակտիվ օգտատեր",
      none: "-",
      actions: "Գործողություններ",
      buttons: {
        info: "Հաճախորդի տվյալներ",
        sendSms: "Ուղարկել SMS",
        history: "Պատմություն",
        addresses: "Հասցեներ",
        orders: "Պատվերներ",
      },
    },
    orderColumns: {
      orderId: "Պատվերի համար",
      customerName: "Հաճախորդի անուն",
      mobile: "Բջջային",
      paymentMethod: "Վճարման մեթոդ",
      shippingMethod: "Առաքման մեթոդ",
      orderAmount: "Պատվերի գումար",
      orderTime: "Պատվերի ժամանակ",
      status: "Կարգավիճակ",
      currency: "Ռիալ",
    },
    addressesColumns: {
      id: "#",
      addressTitle: "Հասցեի վերնագիր",
      name: "Անուն",
      family: "Ազգանուն",
      mobile: "Հեռախոս",
      address: "Հասցե",
      zipCode: "Փոստային ինդեքս",
      number: "Տան համար",
      unit: "Միավոր",
    },
    shippingType: {
      courier: "Սուրհանդակ",
      reservation: "Սայլի ամրագրում",
      place: "Տեղում հավաքում",
      none: "-",
    },
    paymentType: {
      online: "Առցանց վճարում",
      card2card:"Քարտից քարտ վճարում",
    },
    perPage: "Գրառումներ մեկ էջում",
    search: "Որոնել",
    sortColumn: "Դասավորել ըստ",
    sortDirection: "Դասավորության ուղղություն",
    sortDirectionDesc: "Նվազման կարգով",
    sortDirectionAsc: "Աճման կարգով",
    noStatus: "Կարգավիճակ չի գտնվել",
    status: {
      all: "Բոլորը",
      active: "Ակտիվ",
      inactive: "Ոչ ակտիվ",
    },
    fetchError: "Սխալ օգտատերերի տվյալները բեռնելիս",
  },
  listCardHeader: {
    clear_filters: "Մաքրել զտիչները",
    group_qr_renewal: "Խմբային QR կոդի թարմացում",
    select_desired_duration: "Ընտրել ցանկալի տևողություն",
    total_count: "Ընդհանուր քանակ",
    final_amount: "Վերջնական գումար",
    ten_percent_vat_will_be_added: "Կավելացվի 10% ԱԱՀ",
    pay_and_upgrade: "Վճարել & թարմացնել",
    no_tariff_for_this_period: "Այս ժամանակահատվածի համար սակագին չկա",
    one_month_renewal: "1 ամսվա թարմացում",
    three_month_renewal: "3 ամսվա թարմացում",
    six_month_renewal: "6 ամսվա թարմացում",
    one_year_renewal: "1 տարվա թարմացում",
    selected: "Ընտրված",
    view: "Դիտել",
    details: "Մանրամասներ",
    total_amount: "Ընդհանուր գումար",
    discount: "Զեղչ",
    final_amount_with_discount: "Վերջնական գումար զեղչով",
    add_qr: "Ավելացնել QR",
    select_all: "Ընտրել բոլորը",
    actions: "Գործողություններ",
    filter: "Զտիչ",
    type_filter: "Տեսակի զտիչ",
    start_from: "Սկսվում է",
    search: "Որոնել",
    id_search: "ID որոնում",
    filter_user: "Օգտատերերի զտիչ",
    sort: "Դասավորել",
    send_sms: "Ուղարկել SMS",
    selected_pattern: "Ընտրված ձևանմուշ՝",
    send: "Ուղարկել",
    newest: "Ամենանոր",
    oldest: "Ամենահին",
    most_visited: "Ամենաշատ այցելված",
    least_visited: "Ամենաքիչ այցելված",
    pause: "Դադար",
    bulk_download: "Խմբային ներբեռնում",
    activate: "Ակտիվացնել",
    deactivate: "Ապաակտիվացնել",
    error_loading_card: "Սխալ քարտի տվյալները բեռնելիս!",
    error_fetching_prices: "Սխալ գները ստանալիս!",
    error_payment: "Վճարման սխալ!",
    sms_success: "SMS-ը հաջողությամբ ուղարկվել է",
    generic_error: "Տեղի է ունեցել սխալ!",
  },
  headerTypeFilter: {
    qr_model: "QR մոդել",
    all_qr_models: "Բոլոր QR մոդելները",
  },
  menuOrderFactor: {
    order_invoice: "Պատվերի հաշիվ-ապրանքագիր",
    total: "Ընդհանուր",
    tax: "Հարկ",
    shipping_cost: "Առաքման ծախսեր",
    packing_cost: "Փաթեթավորման ծախսեր",
    discount: "Զեղչ",
    final_total: "Վերջնական ընդհանուր",
    currency: "Ռիալ",
    titles: {
      default_title: "Ստանդարտ պատվեր",
    },
  },
  headerSearchTypeFilter: {
    search_in_list: "Որոնել ցուցակում",
    search: "Որոնել",
    start_from: "Սկսվում է",
  },
  headerStatusFilter: {
    all_qr_codes: "Բոլոր QR կոդերը",
    active_qr_codes: "Ակտիվ QR կոդեր",
    inactive_qr_codes: "Ոչ ակտիվ QR կոդեր",
    expiring_qr_codes: "Շուտով ժամկետանց QR կոդեր",
    expired_qr_codes: "Ժամկետանց QR կոդեր",
  },
  qrOrdersList: {
    title: "Պատվերների ցուցակ",
    orderColumns: {
      index: "Հերթականություն",
      id: "Պատվերի համար",
      customerName: "Հաճախորդի անուն",
      mobile: "Բջջային",
      paymentType: "Վճարման տեսակ",
      shippingType: "Առաքման տեսակ",
      price: "Պատվերի գումար",
      createdAt: "Պատվերի ժամանակ",
      status: "Կարգավիճակ",
      actions: "Գործողություններ",
    },
    productsColumns: {
      productId: "Ապրանքի ID",
      image: "Պատկեր",
      productName: "Ապրանքի անուն",
      unitPrice: "Միավորի գին",
      quantity: "Քանակ",
      totalPrice: "Ընդհանուր գին",
    },
    actions: {
      products: "Պատվերի ցուցակ",
      print: "Տպել պատվերը",
      share: "Կիսվել պատվերով",
      status: "Փոխել կարգավիճակը",
    },
    shippingType: {
      courier: "Սուրհանդակ",
      reservation: "Սեղանի ամրագրում",
      place: "Տեղում հավաքում",
      post: "Փոստային առաքում",
      unknown: "-",
    },
    paymentType: {
      online: "Առցանց վճարում",
      place: "Վճարում տեղում",
      unknown: "-",
      card2card:"Քարտից քարտ վճարում",

    },
    status: {
      all: "Բոլորը",
      pending: "Վճարումը սպասվում է",
      accepted: {
        place: "Վճարում տեղում",
        paid: "Վճարված",
      },
      delivered: "Առաքված",
      rejected: "Վճարումը ձախողվել է",
    },
    factorTitle: "Պատվերի հաշիվ-ապրանքագիր",
    printFactor: "Տպել հաշիվ-ապրանքագիրը",
    fetchError: "Սխալ տվյալները բեռնելիս",
    statusChanged: "Կարգավիճակը հաջողությամբ փոխվել է",
    statusChangeError: "Սխալ կարգավիճակը փոխելիս",
    currency: "Ռիալ",
    perPage: "Քանակ",
    search: "Որոնել",
    noStatus: "Կարգավիճակ չկա",
    loading: "Բեռնվում է...",
    noShippingType: "Առաքման տեսակ չկա",
    noPaymentType: "Վճարման տեսակ չկա",
    sortColumn: "Դասավորելու սյունակ",
    sortDirection: "Դասավորության ուղղություն",
    sortDirectionDesc: "Նվազման կարգով",
    sortDirectionAsc: "Աճման կարգով",
    selectNewStatus: "Ընտրել նոր կարգավիճակ",
    changeStatusTitle: "Փոխել կարգավիճակը",
    linkCopied: "Հղումը պատճենվել է։",
  },
  qrUserTransfer: {
    title: "Սեփականության փոխանցում",
    radioLabels: {
      userTransfer: "Փոխանցել մեկ այլ անձի",
      givingAccess: "Տրամադրել մուտք",
    },
    inputLabels: {
      phone: "Անձի բջջային համար",
    },
    hints: {
      addNumber: "Սեղմեք Enter կամ + ավելացնելու համար",
      addNumberStep2: "Սեղմեք Enter կամ + ավելացնելու համար",
    },
    buttons: {
      transfer: "Փոխանցել",
      giveAccess: "Տրամադրել մուտք",
      back: "Հետ",
      saveChanges: "Պահպանել փոփոխությունները",
      cancel: "Չեղարկել",
        "add": "Ավելացնել"

    },
    tooltips: {
      deleteAccess: "Հեռացնել մուտքը",
    },
    subtitles: {
      accessList: "Թույլատրված օգտատերերի ցուցակ՝",
      selectPermissions: "Ընտրել թույլտվություններ՝",
    },
    permissionList: {
      edit_name: "Խմբագրել ծառայության անունը",
      edit_link: "Խմբագրել հղումը",
      edit_info: "Խմբագրել տեղեկատվությունը",
      edit_design: "Խմբագրել QR դիզայնը",
      edit_settings: "Խմբագրել QR կարգավորումները",
      toggle_access: "Միացնել/անջատել մուտքը",
      view_customers: "Դիտել հաճախորդների ցուցակը",
      view_orders: "Դիտել պատվերների ցուցակը",
    },
    messages: {
      invalidPhone: "Անվավեր հեռախոսահամար",
      duplicatePhone: "Կրկնվող համար չի թույլատրվում",
      updateAccessSuccess: "Մուտքը հաջողությամբ թարմացվել է։",
      updateAccessError: "Թարմացման սխալ՝ {message}",
      deleteAccessSuccess: "Մուտքը հաջողությամբ հեռացվել է։",
      deleteAccessError: "Հեռացման սխալ՝ {message}",
      fetchAccessError: "Բեռնման սխալ՝ {message}",
      transferSuccess: "QR-ը հաջողությամբ փոխանցվել է։",
      transferError: "Փոխանցման սխալ՝ {message}",
      giveAccessSuccess: "Հաջողությամբ կարգավորվել է։",
      giveAccessError: "Կարգավորման սխալ՝ {message}",
      confirmDeleteAccess: "Իրո՞ք հեռացնել այս անձի մուտքը",
    },
  },
  form: {
    form_download: "Ստացված ձևեր",
    form_add: "Ավելացնել ձև",
    formdownload: "Ստացված ձև",
    create_at: "Ստեղծվել է՝",
    shown: "Ցուցադրված",
    nogiveform: "Դուք ստացված ձևեր չունեք",
    back: "Հետ",
    invalid_date: "Անվավեր ամսաթիվ",
    select_date: "Ընտրել ամսաթիվ",
    select: "Ընտրել",
    clear: "Մաքրել",
    now: "Հիմա",
  },
  dsBasketCondition: {
    title: "Զամբյուղի նվազագույն պայմաններ",
    items: {
      NoConditions: "Առանց պայմանների",
      MinimumShopping: "Զամբյուղի նվազագույն գումար",
      MinimumProduct: "Զամբյուղում նվազագույն ապրանքներ",
      MaximumShopping: "Զամբյուղի առավելագույն գումար",
      MaximumProduct: "Զամբյուղում առավելագույն ապրանքներ",
    },
  },
  dsUserSettings: {
    title: "Զամբյուղի նվազագույն պայմաններ",
    groupTitle: "Օգտատերեր, ովքեր",
    specialTitle: "Օգտատերեր",
    labels: {
      minimumCart: "Զամբյուղի նվազագույն պայմաններ",
      users: "Օգտատերեր",
    },
    items: {
      AllUser: "Բոլոր օգտատերերը",
      group: "Օգտատերերի խումբ",
      special: "Հատուկ օգտատերեր",
    },
    groupItems: {
      Order: "Արդեն գնել են",
      noOrder: "Դեռ չեն գնել",
    },
  },
  qrAddressUpdate: {
  title: "Խմբագրել հասցեն",
  labels: {
    address: "QR հասցե",
  },
  hints: {
    allowedChars: "Թույլատրվում են միայն անգլերեն տառեր, թվեր, գծիկ (-) և ընդգծում (_)",
  },
  buttons: {
    removeInvalidChars: "Հեռացնել անվավեր նիշերը",
  },
  errors: {
    minLength: "Պահանջվում է առնվազն 3 նիշ",
    invalidChars: "Անվավեր նիշ։ Օգտագործեք միայն անգլերեն տառեր, թվեր, - և _։",
    invalidAddress: "Մուտքագրված հասցեն անվավեր է",
    updateFailed: "Հասցեն թարմացնելիս սխալ առաջացավ",
  },
  successMessage: "Հասցեն հաջողությամբ թարմացվեց",
  warning: "Զգուշացում",
  warningMessage: "Հասցեն փոխելու դեպքում նախորդ հղումները կդադարեն աշխատել։",
  savePrompt: "Համոզվա՞ծ եք, որ ցանկանում եք պահպանել այս փոփոխությունը։",
},
  dsFunctionType: {
    title: "Զեղչը կիրառվում է",
    productListTitle: "Ապրանքների ցուցակ",
    categoryListTitle: "Կատեգորիաների ցուցակ",
    labels: {
      applyDiscount: "Կիրառել զեղչը",
      category: "Կատեգորիա",
    },
    items: {
      AllShoppingCart: "Ընդհանուր զամբյուղի գումար",
      SpecialProducts: "Հատուկ ապրանքներ",
      SpecialCategories: "Հատուկ կատեգորիաներ",
    },
  },
  dsLimitationUse: {
    title: "Օգտագործման սահմանափակում",
    discountCodeTitle: "Կոդի օգտագործումներ",
    userTitle: "Օգտագործումներ մեկ օգտատիրոջ համար",
    labels: {
      limitation: "Սահմանափակում",
      usage: "Օգտագործում",
      user: "Օգտատեր",
    },
    items: {
      NoLimitations: "Առանց սահմանափակումների",
      DiscountCode: "Զեղչի կոդի օգտագործումներ",
      User: "Օգտագործումներ մեկ օգտատիրոջ համար",
    },
  },
  ManageHourLimitQr: {
    noLimit: "Առանց սահմանի",
    dateLimit: "Ամսաթվի սահման",
    timeLimit: "Ժամի սահման",
    startDate: "Սկզբի ամսաթիվ",
    endDate: "Ավարտի ամսաթիվ",
    selectDate: "Ընտրել ամսաթիվ",
    startTime: "Սկզբի ժամ",
    endTime: "Ավարտի ժամ",
  },
  discount_percent_range: "Զեղչը պետք է լինի 0-ից 100%-ի միջև",
  discount_price_range: "Զեղչը պետք է լինի 0-ից {max}-ի միջև",
  invalid_number: "Մուտքագրեք միայն թվեր",
  min_order_cart: "Պատվերի նվազագույն արժեք",
  preparation_time: "Պատրաստման ժամանակ (րոպե)",
  delivery_time: "Առաքման ժամանակ (րոպե)",
  max_product_in_order: "Առավելագույն ապրանքներ մեկ պատվերում",
  max_order_by_person: "Առավելագույն պատվերներ մեկ անձի համար",
  send_by_courier_price: "Սուրհանդակի ծախսեր",
  vat: "Հարկի դրույքաչափ",
  send_by_post: "Փոստային առաքման ծախսեր",
  online_pay: "Առցանց վճարում",
  pay_in_person_place: "Վճարում տեղում",
  in_place: "Տեղում հավաքում",
  table_booking_ability: "Սեղանի ամրագրում",
  send_by_courier: "Առաքում սուրհանդակով",
  vat_switch: "Հարկ",
  invalid_number: "Մուտքագրեք միայն թվեր",
  positive_number: "Թիվը պետք է դրական լինի",
  vat_range: "Հարկի դրույքաչափը պետք է լինի 0-ից 100%-ի միջև",
  sort_column: "Դասավորելու սյունակ",
  direction_sort: "Դասավորության ուղղություն",
  listFeedbackUser: {
    no_questions: "Դուք հարցեր չունեք հետադարձ կապ հավաքելու համար",
    add_feedback_prompt: "Ստեղծեք նոր հետադարձ կապ 'Ավելացնել' ներդիրում",
    question_label: "Հարց",
    show_answers: "Ցուցադրել պատասխանները",
    back_button: "Հետ",
    no_feedback: "Հետադարձ կապ չկա!",
    user_opinion: "Օգտատիրոջ կարծիք",
    score_label: "Գնահատական",
  },
  manageDiscount: {
    createNewDiscount: "Ստեղծել նոր զեղչի կոդ",
    copy: "Պատճենել",
    row: "Տող",
    id: "ID",
    discountCode: "Զեղչի կոդ",
    usageLimit: "Օգտագործման սահման",
    used: "Օգտագործված",
    manage: "Կառավարել",
    edit: "Խմբագրել",
    delete: "Ջնջել",
    sendSms: "Ուղարկել SMS թիրախային խմբին",
    copySuccess: "Զեղչի կոդը պատճենվել է",
    copyError: "Պատճենման սխալ",
    deleteSuccess: "Զեղչի կոդը ջնջվել է",
    deleteError: "Սխալ զեղչի կոդը ջնջելիս",
    smsSuccess: "Զեղչի կոդը ուղարկվել է թիրախային խմբին",
    smsError: "Ուղարկման սխալ",
  },
  manageTableReservation: {
    table: "Սեղան",
    number: "Սեղան {num}",
    add_table: "Ավելացնել սեղան",
    complete_info_for_customer:
      "Լրացրեք տեղեկատվությունը հաճախորդին ցուցադրելու համար",
    select_image: "Ընտրել պատկեր",
    table_name_number: "Սեղանի անուն/համար",
    number_of_seats: "Տեղերի քանակ",
    type: "Տեսակ",
    reservation_cost: "Ամրագրման արժեք",
    enter_table_name: "Մուտքագրեք սեղանի անուն/համար",
    table_type: "Սեղան",
    couch_type: "Բազմոց",
    gazebo_type: "Տաղավար",
  },
  create_menu: {
    data: {
      visitName_label: "Այցելության անուն",
      organizationName: "Մեծ ֆաստֆուդի ցանց",
      subOrgan: "Փորձեք մեզ հետ ֆաստֆուդի լավագույն համը",
      aboutUs:
        "Մեծ Ֆաստֆուդ – որակով և հաճախորդի հանդեպ հարգանքով մենք առաջարկում ենք լավագույնը։\nՈրակը մեր սկզբունքն է։\nՖաստֆուդի ոլորտում մենք նոր համ ենք ներմուծել արագ սննդի աշխարհում մեր հատուկ սենդվիչներով։\nՄենք ամեն օր պատրաստ ենք ծառայելու Ձեզ վարչական միջոցառումներում, ծննդյան տոներում և այլն...",
      copyright:
        "Այս կայքի բոլոր իրավունքները պատկանում են Terminal Advertising-ին։",
      product: {
        title: "Ապրանքներ",
        pizzas: "Պիցցաներ",
        pizza_roast_beef: "Պիցցա Roast Beef",
        pizza_roast_beef_desc: "🤩 Իտալական պիցցա տավարի մսով",
        pizza_roast_beef_ingredients:
          "Իտալական պիցցայի հիմք 30 սմ, 100 գ աղացած տավարի միս, սնկեր, պղպեղներ, սև ձիթապտուղներ",
        pizza_chicken_mushroom: "Պիցցա Հավ & Սնկեր",
        pizza_chicken_mushroom_desc: "🍕 Դասական 40 սմ",
        pizza_chicken_mushroom_ingredients:
          "Թարմ Pizzara լոլիկի սոուս, պաստերիզացված պանիր, հավի ֆիլե, սնկեր, լեռնային ուրց",
        pizza_meat_mushroom: "Պիցցա Միս & Սնկեր",
        pizza_meat_mushroom_desc: "🥰 Պիցցա աղացած տավարի մսով և սնկերով",
        pizza_meat_mushroom_ingredients:
          "Թարմ Pizzara լոլիկի սոուս, պաստերիզացված պանիր, տավարի մսի աղացած, սնկեր, լեռնային ուրց, 2 անձի համար (29 սմ) 355,000 Տոման, 1 անձի համար (22 սմ) 216,000 Տոման",
        pizza_veggie: "Վեգետարիանական Պիցցա",
        pizza_veggie_desc: "🍕 Ամերիկյան վեգետարիանական պիցցա",
        pizza_veggie_ingredients:
          "Ամերիկյան պիցցայի հիմք, քաղցր եգիպտացորեն, սնկեր, ձիթապտուղներ, լոլիկներ, սոխ, պղպեղներ, պիցցայի պանիր",
        pizza_special: "Հատուկ Պիցցա",
        pizza_special_desc: "Ամերիկյան հատուկ պիցցա",
        pizza_special_ingredients:
          "Ամերիկյան պիցցայի հիմք, համեմված աղացած տավարի միս, համբուրգերի խառնուրդ տավարի & հավի 80%, մոցարելլայի խառնուրդ, հատուկ սոուս, պղպեղներ, սնկեր, առանց սոուսի 1 անձի համար",
        pizza_bolognese: "Պիցցա Բոլոնեզե",
        pizza_bolognese_desc: "(1 անձի համար) Պիցցայի հիմք 23 սմ 🤌",
        pizza_bolognese_ingredients:
          "Աղացած տավարի միս, մոցարելլա, սնկեր, պղպեղներ, քաղցր եգիպտացորեն, կտրտած սև ձիթապտուղներ",
        pizza_pepperoni: "Պիցցա Պեպպերոնի",
        pizza_pepperoni_desc: "(1 անձի համար) Պիցցայի հիմք 23 սմ",
        pizza_pepperoni_ingredients:
          "Իտալական պիցցայի հիմք, պեպպերոնի 80%, մարինարա սոուս, հատուկ պիցցայի պանիր",
        pizza_bacon: "Պիցցա Բեկոն",
        pizza_bacon_desc: "(1 անձի համար) Պիցցայի հիմք 23 սմ 💥",
        pizza_bacon_ingredients:
          "Իտալական պիցցայի հիմք, մարինարա սոուս, հատուկ պիցցայի պանիր, բեկոնի խառնուրդ տավարի & հավի 90%, սնկեր, ձիթապտուղներ, պղպեղներ",
        pizza_mixed: "Խառը Պիցցա",
        pizza_mixed_desc: "(1 անձի համար) Պիցցայի հիմք 23 սմ 🤭",
        pizza_mixed_ingredients:
          "Համբուրգերի խառնուրդ տավարի & հավի աղացած, սալամի, աղացած տավարի միս, սնկեր, ձիթապտուղներ, պղպեղներ, պիցցայի պանիր, հատուկ սոուս",
        pizza_american_steak: "Ամերիկյան Սթեյք Պիցցա",
        pizza_american_steak_desc: "(1 անձի համար) 23 սմ 💥",
        pizza_american_steak_ingredients:
          "Ամերիկյան պիցցայի հիմք, տավարի մսի կտորներ, սնկեր, պիցցայի պանիր, քունջութ",
        burgers: "Բուրգերներ",
        cheeseburger: "Չիզբուրգեր",
        cheeseburger_desc: "🤩 Կարտոֆիլ ֆրիով",
        cheeseburger_ingredients:
          "2 տավարի բուրգերի կոտլետ 150 գ յուրաքանչյուրը, հատուկ սոուս, Գուդա պանիր, թթու վարունգ, հազար, լոլիկ",
        hamburger: "Համբուրգեր",
        hamburger_desc: "😍 Մաքուր տավարի միս հատուկ սոուսով",
        hamburger_ingredients:
          "Տավարի բուրգերի կոտլետ 150 գ, թթու վարունգ, հազար, հատուկ սոուս, լոլիկ, Mac հաց, սոուս 1 անձի համար",
        chicken_burger: "Հավի Բուրգեր",
        chicken_burger_desc: "Գրիլ հավ պանիրով",
        chicken_burger_ingredients:
          "150 գ գրիլ հավի կրծքամիս, պանի America's, լոլիկ, թթու վարունգ, հազար, Mac հաց, հատուկ սոուս",
        spice_burger: "Կծու Բուրգեր",
        spice_burger_desc: "Տավարի միս կծու սոուսով",
        spice_burger_ingredients:
          "Տավարի բուրգերի կոտլետ 130 գ, կծու սոուս, հազար, լոլիկ, Mac հաց, հատուկ կծու սոուս",
        double_burger: "Կրկնակի Բուրգեր",
        double_burger_desc: "Տավարի միս 150 գ",
        double_burger_ingredients:
          "2 ձեռագործ տավարի կոտլետ 150 գ յուրաքանչյուրը, պիցցայի պանիր, կարամել սոուս, հազար, կարմիր կաղամբ, սպիտակ հատուկ սոուս, կլոր հաց",
        royal_burger: "Ռոյալ Բուրգեր",
        royal_burger_desc: "150 գ տավարի միս 🍔",
        royal_burger_ingredients:
          "Ձեռագործ տավարի կոտլետ 150 գ, պիցցայի պանիր, 5 կտոր սալամի, կարամել սոուս, հազար, կարմիր կաղամբ, սպիտակ հատուկ սոուս, կլոր հաց",
        mushroom_burger: "Սնկով Բուրգեր",
        mushroom_burger_desc: "Տավարի միս 150 գ",
        mushroom_burger_ingredients:
          "Ձեռագործ տավարի կոտլետ 150 գ, սնկեր, կարամել սոուս, հազար, կարմիր կաղամբ, սպիտակ հատուկ սոուս, կլոր հաց, մոցարելլա",
        mashroom_burger: "Սնկով Բուրգեր",
        mashroom_burger_desc: "100% գրիլ տավարի միս 🤩",
        mashroom_burger_ingredients:
          "Ձեռագործ 100% գրիլ տավարի կոտլետ, կարտոֆիլ ֆրի, լոլիկ, հազար, թթու վարունգ, սնկային սոուս, կլոր հաց",
        fried_burger: "Տապակած Բուրգեր",
        fried_burger_desc: "100% գրիլ & տապակած տավարի միս 👌",
        fried_burger_ingredients:
          "Ձեռագործ 100% գրիլ & տապակած տավարի կոտլետ, 150 գ կարտոֆիլ ֆրի, լոլիկ, հազար, թթու վարունգ, հատուկ սոուս, կլոր հաց",
        fried: "Տապակած",
        fried_chicken: "Տապակած Հավ",
        fried_chicken_desc: "😍 3 կտոր տապակած հավ",
        fried_chicken_ingredients:
          "3 կտոր տապակած հավ, 120–150 գ կարտոֆիլ ֆրի, 100–120 գ կաղամբի աղցան, հացիկ, հատուկ սոուս",
        chicken_strips: "Հավի Շերտեր",
        chicken_strips_desc: "4 կտոր համեմված կծու տապակած հավի ֆիլե",
        chicken_strips_ingredients:
          "4 կտոր տապակած հավի ֆիլե, 120–150 գ կարտոֆիլ ֆրի, 100–120 գ կաղամբի աղցան, հացիկ, տարտար սոուս",
        fried_filet: "Տապակած Ֆիլե",
        fried_filet_desc: "🤩 2 կտոր տապակած ֆիլե հատուկ սոուսով",
        fried_filet_ingredients:
          "2 կտոր շերտեր, գրիլ կարտոֆիլ, կաղամբի աղցան, հացիկ, սխտորի սոուս, թայլանդական չիլի սոուս, պապրիկա սոուս",
        fried_mushroom_onion: "Տապակած Սնկեր & Սոխ",
        fried_mushroom_onion_desc: "🤩 Տապակած սնկեր & սոխ տարտար սոուսով",
        fried_mushroom_onion_ingredients:
          "20 կտոր տապակած սնկեր, 6 կտոր տապակած սոխի օղակներ, տարտար սոուս",
        fried_wings: "Տապակած Թևեր",
        fried_wings_desc: "6 կտոր տապակած թևեր 🍗",
        fried_wings_ingredients: "Վեց գրիլ & տապակած թևեր",
        fried_chicken_basket: "Տապակած Հավի Զամբյուղ",
        fried_chicken_basket_desc: "(2 անձի համար) 😍",
        fried_chicken_basket_ingredients:
          "2 կտոր տապակած հավ, 2 կտոր շերտեր, 2 կտոր սոխի օղակներ, 2 կտոր տապակած ծովախեցգետնի նագետներ, 2 կտոր հավի նագետներ",
        fried_schnitzel: "Տապակած Շնիցել",
        fried_schnitzel_desc: "Չորս կտոր հավի շնիցել 💥",
        fried_schnitzel_ingredients:
          "Չորս գրիլ և տապակած համեմված հավի շնիցելներ",
        veggie_basket_fried: "Տապակած Վեգետարիանական Զամբյուղ",
        veggie_basket_fried_desc: "250 գ 🤩",
        veggie_basket_fried_ingredients:
          "250 գ, տապակած դդում, սմբուկ, սնկեր, կարտոֆիլ",
        fried_chicken_2_piece: "Տապակած Հավ 2 Կտոր",
        fried_chicken_2_piece_desc: "2 կտոր տապակած հավ 🍗",
        fried_chicken_2_piece_ingredients:
          "120–150 գ ֆրի, 100–120 գ կաղամբի աղցան, հացիկ, հատուկ սոուս",
        fried_chicken_5_piece: "Տապակած Հավ 5 Կտոր",
        fried_chicken_5_piece_desc: "Հինգ կտոր տապակած հավ",
        fried_chicken_5_piece_ingredients:
          "150–200 գ ֆրի, երկու կաղամբի աղցան 100–120 գ, երկու հացիկ, հատուկ սոուս",
        fried_chicken_7_piece: "Տապակած Հավ 7 Կտոր",
        fried_chicken_7_piece_desc: "Յոթ կտոր տապակած հավ 💥",
        fried_chicken_7_piece_ingredients:
          "150–200 գ ֆրի, կաղամբի աղցան 100–120 գ, 3 հացիկ, հատուկ սոուս, սոուս 1 անձի համար տապակած",
        sandwich: "Սենդվիչ",
        hotdog_sandwich: "Հոթդոգ Սենդվիչ",
        hotdog_sandwich_desc: "Հոթդոգ սենդվիչ սնկերով և պանիրով",
        hotdog_sandwich_ingredients:
          "Գրիլ հոթդոգ երշիկ, հազար, լոլիկ, թթու վարունգ, սնկեր և պիցցայի պանիր",
        roast_beef_sandwich: "Ռոուսթ Բիֆ Սենդվիչ",
        roast_beef_sandwich_desc: "✔️ Աղացած տավարի միս",
        roast_beef_sandwich_ingredients:
          "Տավարի միս, պիցցայի պանիր, սնկեր, կտրտած կարտոֆիլի չիպսեր, հազար, լոլիկ, թթու վարունգ, հատուկ սոուս, ֆրանսիական հաց",
        ham_sandwich: "Հեմ Սենդվիչ",
        ham_sandwich_desc: "Հավի հեմ սենդվիչ սնկերով (սառը)",
        ham_sandwich_ingredients:
          "Հավի հեմ սնկերով, հազար, լոլիկ, թթու վարունգ, կտրտած կարտոֆիլի չիպսեր, հատուկ սոուս, բագետ",
        bandari_sausage_sandwich: "Բանդարի Երշիկ Սենդվիչ",
        bandari_sausage_sandwich_desc: "💥 Կծու Բանդարի սենդվիչ",
        bandari_sausage_sandwich_ingredients:
          "Բանդարի ուտեստ ծխագույն կոկտեյլ երշիկով 55%, լոլիկ, թթու վարունգ, հատուկ սոուս, սոխ և համեմ, ծավալուն հաց",
        tongue_mushroom_sandwich: "Լեզու և Սունկ Սենդվիչ",
        tongue_mushroom_sandwich_desc: "150 գ տավարի լեզու",
        tongue_mushroom_sandwich_ingredients:
          "Սնկեր, պաստերիզացված պիցցայի պանիր, ձիթապտուղներ, քաղցր եգիպտացորեն, հազար, թթու վարունգ, լոլիկ, սոուս, կողմնակի ուտեստներ, ֆրի, կաղամբի աղցան",
        falafel_sandwich: "Ֆալաֆել Սենդվիչ",
        falafel_sandwich_desc: "Վեց կտոր ֆալաֆել 🌭",
        falafel_sandwich_ingredients:
          "Վեց կտոր ֆալաֆել, թթու վարունգ, լոլիկ, հազար, սոուս 1 անձի համար, կողմնակի ուտեստներ, ֆրի, կաղամբի աղցան",
        cheesy_kebab_turki_sandwich: "Պանրով Թուրքական Կեբաբ Սենդվիչ",
        cheesy_kebab_turki_sandwich_desc: "150 գ տավարի միս",
        cheesy_kebab_turki_sandwich_ingredients:
          "150 գ տավարի միս, հատուկ պիցցայի պանիր, թթու վարունգ, լոլիկ, հազար, սոուս 1 անձի համար, ֆրի, կաղամբի աղցան",
        roast_chicken_sandwich: "Գրիլ Հավի Սենդվիչ",
        roast_chicken_sandwich_desc: "Հավի շնիցել և սնկեր 🤩",
        roast_chicken_sandwich_ingredients:
          "Հավի շնիցել և սնկեր, հատուկ պիցցայի պանիր, ձիթապտուղներ, քաղցր եգիպտացորեն, քունջութ, հազար, պղպեղներ, թթու վարունգ, լոլիկ, հատուկ սոուս, կողմնակի ուտեստներ, ֆրի",
        cheesy_indian_sandwich: "Հնդկական Պանրով Սենդվիչ",
        cheesy_indian_sandwich_desc: "Գերմանական երշիկ 💥",
        cheesy_indian_sandwich_ingredients:
          "Գերմանական պանրով երշիկ, քաղցր եգիպտացորեն, հազար, սնկեր, հատուկ սոուս, կողմնակի ուտեստներ, ֆրի, կաղամբի աղցան",
        snack: "Սնեկ",
        chicken_snack: "Հավի Սնեկ",
        chicken_snack_desc: "😋 Աղացած հավի կրծքամիս",
        chicken_snack_ingredients:
          "150 գ հավի կրծքամիս, պղպեղներ, սնկեր, հատուկ սնեկ հաց, հատուկ սոուս",
        meat_snack: "Մսային Սնեկ",
        meat_snack_desc: "🥪 Կրկնակի մսային սնեկ",
        meat_snack_ingredients:
          "Կրկնակի, տավարի աղացած միս, մոցարելլա, քաղցր եգիպտացորեն, պղպեղներ, հատուկ սոուս, թոսթ հաց",
        chicken_meat_snack: "Հավ-Միս Սնեկ",
        chicken_meat_snack_desc: "🤩 Կրկնակի հավ-միս սնեկ",
        chicken_meat_snack_ingredients:
          "Կրկնակի, աղացած հավի կրծքամիս, տավարի աղացած միս, մոցարելլա, քաղցր եգիպտացորեն, պղպեղներ, հատուկ սոուս, թոսթ հաց",
        special_snack: "Հատուկ Սնեկ",
        special_snack_desc: "🤤 Կրկնակի հատուկ սնեկ",
        special_snack_ingredients:
          "Կրկնակի, կալբաս խառնուրդ տավարի և հավի 90%, մոցարելլա, քաղցր եգիպտացորեն, պղպեղներ, հատուկ սոուս, թոսթ հաց",
        roast_beef_snack: "Ռոուսթ Բիֆ Սնեկ",
        roast_beef_snack_desc: "Աղացած տավարի միս 🍖",
        roast_beef_snack_ingredients:
          "Աղացած տավարի միս, սնկեր, պիցցայի պանիր, պղպեղներ, քաղցր եգիպտացորեն, կողմնակի ուտեստներ, ֆրի, կաղամբի աղցան",
        veggie_snack: "Վեգետարիանական Սնեկ",
        veggie_snack_desc: "4 կտոր վեգետարիանական սնեկ",
        veggie_snack_ingredients:
          "Բրոկոլի, քաղցր եգիպտացորեն, ձիթապտուղներ, դիետիկ պիցցայի պանիր, սնկեր, կողմնակի ուտեստներ, ֆրի, կաղամբի աղցան",
        chicken_mushroom_snack: "Հավ և Սունկ Սնեկ",
        chicken_mushroom_snack_desc: "Հավի շնիցել և սնկեր 👌",
        chicken_mushroom_snack_ingredients:
          "Հավի շնիցել, սնկեր, հատուկ պիցցայի պանիր, ձիթապտուղներ, քաղցր եգիպտացորեն, պղպեղներ, կողմնակի ուտեստներ, ֆրի, կաղամբի աղցան",
        pepperoni_snack: "Պեպպերոնի Սնեկ",
        pepperoni_snack_desc: "Կալբաս պեպպերոնի 90% 💥",
        pepperoni_snack_ingredients:
          "Կրկնակի, կալբաս պեպպերոնի 90%, մոցարելլա, քաղցր եգիպտացորեն, պղպեղներ, հատուկ սոուս",
        bologna_snack: "Բոլոնիա Սնեկ",
        bologna_snack_desc: "Աղացած տավարի միս 👌",
        bologna_snack_ingredients:
          "Կրկնակի, աղացած տավարի միս, հատուկ բեկոն, սպիտակեցված սնկեր, քաղցր եգիպտացորեն, մոցարելլա, պղպեղներ, հատուկ սոուս",
        pasta: "Մակարոն",
        alfredo_pasta: "Ալֆրեդո Մակարոն",
        alfredo_pasta_desc: "Ալֆրեդո մակարոն հատուկ սնկային սոուսով",
        alfredo_pasta_ingredients: "350 գ պեննե",
        macaroni: "Մակարոնի",
        macaroni_desc: "🥣 Մակարոնի մսով և սնկերով",
        macaroni_ingredients:
          "Շերտավոր մակարոն 1,2, 100 գ աղացած տավարի միս, սնկեր, պղպեղներ, խորանարդ գրիլ կարտոֆիլ, ոլոռ",
        spaghetti_bolognese: "Սպագետտի Բոլոնեզե",
        spaghetti_bolognese_desc: "🥰 Լինգվինե մակարոն",
        spaghetti_ingredients:
          "700 գ, լինգվինե մակարոն, տավարի և գառի աղացած միս, բոլոնեզե սոուս, հատուկ կարմիր Ռասու սոուս, պլաստիկ գդալ և պատառաքաղ ընտրովի",
        chicken_stroganoff: "Հավի Ստրոգանոֆ",
        chicken_stroganoff_desc: "😍 Հավի ստրոգանոֆ հավի կրծքամսի կտորներով",
        chicken_stroganoff_ingredients:
          "180 գ համեմված հավի կրծքամսի կտորներ, սերուցք, սպիտակեցված սնկեր, պարմեզան, ձեռքով կտրտած ֆրի, հատուկ միկրոալիքային տարա",
        penne_arrabbiata: "Պեննե Արաբիատա",
        penne_arrabbiata_desc: "Հավի կրծքամիս 💥",
        penne_arrabbiata_ingredients:
          "1 անձի համար, հավի կրծքամիս, մակարոն, սնկեր, պարմեզան, չերի լոլիկներ, մաղադանոս, արաբիատա սոուս",
        chicken_pesto_pasta: "Հավի Պեստո Մակարոն",
        chicken_pesto_pasta_desc: "(1 անձի համար) Հավի կրծքամիս",
        chicken_pesto_pasta_ingredients:
          "Հավի կրծքամիս, սնկեր, պարմեզան, չերի լոլիկներ, մաղադանոս, արաբիատա սոուս",
        carbonara_pasta: "Կարբոնարա Մակարոն",
        carbonara_pasta_desc: "Տավարի բեկոն 97%",
        carbonara_pasta_ingredients:
          "Մակարոն, տավարի բեկոն 97%, ալֆրեդո սոուս, պարմեզան, չերի լոլիկներ, մաղադանոս",
        appetizer: "Մեզեներ",
        hot_chips: "Տաք Չիպսեր",
        hot_chips_desc: "😙 Տարբեր չիպսերի համեր",
        hot_chips_ingredients:
          "Կիլո չիպսեր, հատուկ սոուս, հավի հեմ 70%, սնկեր, պղպեղներ, պիցցայի պանիր, Գուդա",
        lasagna: "Լազանյա",
        lasagna_desc: "Լազանյա աղացած տավարի մսով",
        lasagna_ingredients:
          "3 լազանյայի թերթ, աղացած տավարի միս, սնկեր, պղպեղներ, սև ձիթապտուղներ, պիցցայի պանիր, հատուկ սոուս",
        french_fries: "Տապակած կարտոֆիլ",
        french_fries_desc: "Տապակած կարտոֆիլ հատուկ սոուսով",
        french_fries_ingredients: "150 գ տապակած կարտոֆիլ, հատուկ սոուս",
        baked_potato: "Թխած կարտոֆիլ",
        baked_potato_desc: "🍟 Թխած կարտոֆիլ տավարի բեկոնով",
        baked_potato_ingredients:
          "150 գ տապակած կարտոֆիլ, տավարի բեկոն 90%, պիցցայի պանիր, հատուկ համեմունք, մեկ անձի սոուս",
        garlic_bread: "Սխտորով հաց",
        garlic_bread_desc: "Հատուկ սխտորի սոուս💥",
        garlic_bread_ingredients:
          "Ամերիկյան պիցցայի խմոր, խառը պիցցայի պանիր, հատուկ սխտորի սոուս, կունջութ",
        silo_potatoes: "Սիլո կարտոֆիլ",
        silo_potatoes_desc: "Երկու անձի համար տապակած կարտոֆիլ",
        silo_potatoes_ingredients:
          "Սիլո համեմունքով տապակած կարտոֆիլ, տավարի բեկոն 97%, չեդդեր սոուս, այոլի, կանաչ սոխ, մաղադանոս",
        bbq_sausage: "Բարբեկյու երշիկ",
        bbq_sausage_desc: "Մարինացված մատնաքաշ երշիկ🍢",
        bbq_sausage_ingredients:
          "500 գ համեմված կարտոֆիլի պյուրե, 200 գ մարինացված մատնաքաշ երշիկ, սոխի օղակներ, կանաչ ձիթապտուղ, պարմեզան պանրի փոշի, չերի լոլիկ, միկրոկանաչի, խորոված պանիր, բարբեկյու սոուս, կծու",
        silo_toast: "Սիլո տոստ",
        silo_toast_desc: "160 գ տավարի ֆիլեի շերտեր🤩",
        silo_toast_ingredients:
          "160 գ տավարի ֆիլեի շերտեր, ֆրանսիական հազար, տավարի բեկոն, ֆերմերային հաց, բարբեկյու սոուս, տարտար սոուս, թրթնջուկ, կանաչ ձիթապտուղ, միկրոկանաչի, այոլի, պարմեզան պանրի փոշի",
        salad_and_dessert: "Աղցան և դեսերտ",
        caesar_salad: "Ցեզար աղցան",
        caesar_salad_desc: "Մեկ անձի համար Ցեզար աղցան🥗",
        caesar_salad_ingredients:
          "Խառը հազար, խորոված հավ, պարմեզան պանիր, կրուտոն (սխտորով հաց), Ցեզար սոուս, ձիթապտուղ",
        caesar_salad_extra: "Ռոմեն հազար, կրուտոն, պարմեզան",
        coleslaw_salad: "Կաղամբի աղցան",
        coleslaw_salad_desc: "Մեկ անձի համար կաղամբի աղցան🍴",
        coleslaw_salad_ingredients:
          "Ձեռքի աշխատանք, մեկ անձի, սպիտակ կաղամբ, եգիպտացորեն, սոուս",
        macaroni_salad: "Մակարոնի աղցան",
        macaroni_salad_desc: "Տնական ջեմբոնով մակարոնի աղցան",
        macaroni_salad_ingredients: "Մակարոն, տնական ջեմբոն",
        pachira_salad: "Պաչիրա աղցան",
        pachira_salad_desc: "Երկու անձի համար Պաչիրա աղցան🥗",
        pachira_salad_ingredients:
          "Երկու անձի, խառը հազար, տավարի բեկոնի չիպս 98%, կարամելացված ընկույզ, պարմեզան պանիր, ելակ, բուսական խավիար, չամիչ, կիտրոնի շերտեր, վարդագույն հատապտուղի սոուս",
        greek_salad: "Հունական աղցան",
        greek_salad_desc: "Ֆետա պանիրով և ձիթապտուղով ավանդական հունական աղցան",
        greek_salad_ingredients: "Ֆետա պանիր, ձիթապտուղ, վարունգ",
        tiramisu: "Տիրամիսու",
        tiramisu_desc: "Դասական իտալական տիրամիսու դեսերտ",
        tiramisu_ingredients: "Սուրճ, մասկարպոնե, կակաո",
        beverages: "Ըմպելիքներ",
        local_yogurt_drink: "Տեղական յոգուրտի ըմպելիք",
        local_yogurt_drink_desc: "Ընտանեկան տեղական յոգուրտի ըմպելիք🥛",
        local_yogurt_drink_ingredients: "",
        black_soda: "Սև գազավորված ըմպելիք",
        black_soda_desc: "Բաժակով սև գազավորված ըմպելիք🧋",
        black_soda_ingredients: "",
        fanta: "Դեղին գազավորված ըմպելիք",
        fanta_desc: "Բաժակով դեղին գազավորված ըմպելիք🥤",
        fanta_ingredients: "",
        mojito: "Մոխիտո",
        mojito_desc: "Բաժակով մոխիտո, 350-400 մլ🍸",
        mojito_ingredients: "",
        tropical_malt_beverage: "Արևադարձային գարեջրային ըմպելիք",
        tropical_malt_beverage_desc:
          "Բաժակով արևադարձային գարեջրային ըմպելիք🍺",
        tropical_malt_beverage_ingredients: "",
      },
      socialMedia: {
        address_label: "Հասցե",
        address_text: "Մուտքագրեք ցանկալի կայքի հղումը",
        instagram_label: "Instagram",
        instagram_text: "Մուտքագրեք ձեր օգտանունը",
        whatsapp_label: "WhatsApp",
        whatsapp_text: "+989123456789",
      },
      videoGallery: {
        title: "Տեսագալերեա",
        description:
          "QR-Land խելացի համակարգի ծառայություններին ավելի լավ ծանոթանալու համար դիտեք ստորև ներկայացված տեսանյութերը:",
        tutorial: "Ուսուցողական",
        fast_food: "Ֆաստֆուդ",
      },
      feedback: {
        title: "Ձեր կարծիքը",
        description:
          "Խնդրում ենք պատասխանել ստորև ներկայացված հարցերին՝ մեզ օգնելու բարելավել ծառայությունները",
        question1: "Որքա՞ն եք գոհ մեր ծառայություններից և սննդի որակից:",
        question2:
          "Ինչպե՞ս եք գնահատում ռեստորանի ուտեստների բազմազանությունը:",
        question3: "Ինչպե՞ս եք գնահատում ռեստորանի անձնակազմի վարքագիծը:",
        question4: "Սնունդը ժամանակին՞ է առաքվել:",
        question5:
          "Ունե՞ք առաջարկներ ծառայությունների կամ սննդի որակի բարելավման համար:",
      },
      worksheet: {
        saturday: "Շաբաթ",
        sunday: "Կիրակի",
        monday: "Երկուշաբթի",
        tuesday: "Երեքշաբթի",
        wednesday: "Չորեքշաբթի",
        thursday: "Հինգշաբթի",
        friday: "Ուրբաթ",
        shift_1_saturday: "10:00 – 22:00",
        shift_1_sunday: "10:00 – 22:00",
        shift_1_monday: "10:00 – 22:00",
        shift_1_tuesday: "10:00 – 22:00",
        shift_1_wednesday: "10:00 – 00:00",
        shift_1_thursday: "10:00 – 00:00",
        shift_1_friday: "10:00 – 00:00",
      },
      gallery: {
        gallery_0: "Գալերեա 0",
        image_1: "1",
        image_2: "2",
        image_3: "3",
        image_4: "4",
        image_5: "5",
        baked_potato_2: "Թխած կարտոֆիլ 2",
        chicken_stroganoff_1: "Հավի ստրոգանոֆ 1",
      },
      contact: {
        phone_1: "09999903535",
        phone_2: "02191017077",
        phone_3: "90007425",
        company_number: "02191017077",
        email: "info@qrland.ir",
        fax: "02191016066",
        location:
          "Թեհրան, Շարիաթի փողոց, Սեյեդ Հանդան կամուրջից հետո, Հանդան փակուղի, թիվ 6, բն. 3",
        codePostal: "1541946815",
        website: "www.terminalads.com",
        address_details:
          "Իրան, Թեհրան, Թեհրանի քաղաք, Թեհրան, Թեհրանի քաղաքի 3-րդ շրջան, Սեյեդ Հանդան թաղամաս, դոկտոր Ալի Շարիաթի, Հանդան",
      },
    },
    messages: {
      qr_created_success: "Առցանց մենյուն հաջողությամբ ստեղծվել է:",
      qr_updated_success:
        "Ձեր առցանց մենյուի QR կոդը հաջողությամբ խմբագրվել է:",
      qr_create_error: "QR ստեղծելիս սխալ է տեղի ունեցել!",
      qr_update_error: "QR պահպանելիս/խմբագրելիս սխալ է տեղի ունեցել",
      template_categories_saved:
        "Օրինակելի մոդելի կատեգորիաները հաջողությամբ պահպանվել են:",
      template_products_saved:
        "Օրինակելի մոդելի ապրանքները հաջողությամբ պահպանվել են:",
      template_categories_error:
        "Օրինակելի մոդելի կատեգորիաները պահպանելիս սխալ է տեղի ունեցել!",
      template_products_error:
        "Օրինակելի մոդելի ապրանքները պահպանելիս սխալ է տեղի ունեցել!",
    },
    sample_menu: "Օրինակելի մենյու",
    view_qr: "Դիտել QR",
    preview: "Նախադիտում",
    download_qr: "Ներբեռնել QR",
    create_qr: "Ստեղծել QR",
    online_menu_name: "Առցանց մենյուի անվանումը",
    online_menu_name_short: "Մենյուի անվանումը",
    enter_qr_address: "Մուտքագրեք QR հասցեն",
    qr_address: "QR հասցե",
    enter_menu_information: "Մուտքագրեք մենյուի տեղեկատվությունը",
    cleardefaults: "Մաքրել լռելյայն արժեքները",
    select_sample_menu: "Ընտրել օրինակելի մենյու",
    select_ready_menu: "Ընտրել պատրաստի մենյու",
    online_sales: "Առցանց վաճառք",
    sales_settings: "Վաճառքի կարգավորումներ",
    download: "Ներբեռնել",
    gallery_photos: "Գալերեայի լուսանկարներ",
    fast_food_1: "Ֆաստֆուդի նկար 1",
    fast_food_2: "Ֆաստֆուդի նկար 2",
    large_chain_fast_food: "Մեծ ֆաստֆուդի ցանց",
    best_fast_food_taste_experience: "Զգացեք լավագույն ֆաստֆուդի համը մեզ հետ",
    online_menu_created_successfully: "Առցանց մենյուն հաջողությամբ ստեղծվել է:",
    qr_creation_failed: "QR ստեղծելիս սխալ է տեղի ունեցել!",
    online_menu_qr_updated_successfully:
      "Ձեր առցանց մենյուի QR կոդը հաջողությամբ խմբագրվել է:",
    error_saving_updating_qr: "QR պահպանելիս/խմբագրելիս սխալ է տեղի ունեցել",
    sample_model_categories_saved_successfully:
      "Օրինակելի մոդելի կատեգորիաները հաջողությամբ պահպանվել են:",
    sample_model_products_saved_successfully:
      "Օրինակելի մոդելի ապրանքները հաջողությամբ պահպանվել են:",
    error_saving_sample_model_products:
      "Օրինակելի մոդելի ապրանքները պահպանելիս սխալ է տեղի ունեցել!",
    error_saving_sample_model_categories:
      "Օրինակելի մոդելի կատեգորիաները պահպանելիս սխալ է տեղի ունեցել!",
  },
  editMenu: {
    enter_menu_information: "Մուտքագրեք մենյուի տեղեկատվությունը",
    online_menu_name: "Առցանց մենյուի անվանումը",
    online_menu_name_short: "Առցանց մենյուի կարճ անվանումը",
    fields: {
      qr_address_hint: "Առցանց մենյուին մուտք գործելու QR հասցե",
    },
    online_sales: "Առցանց վաճառք",
    sales_settings: "Վաճառքի կարգավորումներ",
    shop: {
      upload_banner: "Վերբեռնել բաններ",
      create_product: "Ստեղծել ապրանք",
      user_info: "Օգտատիրոջ տեղեկատվություն",
      add_social_media: "Ավելացնել սոցիալական մեդիա",
      photo_gallery: "Լուսանկարների գալերեա",
      video_gallery: "Տեսանյութերի գալերեա",
      feedback: "Հետադարձ կապ",
      working_hours: "Աշխատանքային ժամեր",
    },
    success_message: "Ձեր այցեքարտը հաջողությամբ խմբագրվել է:",
  },
  qrCodeSquare: {
    dots_color: "Կետերի գույն",
    gradient_color: "Գրադիենտ գույն",
    linear: "Գծային",
    radial: "Շառավղային",
    color_rotation: "Գույնի պտույտ",
    first_color: "Առաջին գույն",
    second_color: "Երկրորդ գույն",
    dots_color_label: "Կետերի գույն",
  },

  language: {
    selectAll: "Ընտրել բոլորը",
    lang: {
      fa: "Պարսկերեն",
      ar: "Արաբերեն",
      ar_ae: "Արաբերեն (ԱՄԷ)",
      ar_iq: "Արաբերեն (Իրաք)",
      en_US: "Անգլերեն (ԱՄՆ)",
      en_GB: "Անգլերեն (Մեծ Բրիտանիա)",
      de: "Գերմաներեն",
      fr: "Ֆրանսերեն",
      zh_CN: "Պարզեցված չինարեն",
      zh_TW: "Ավանդական չինարեն",
      tr: "Թուրքերեն",
      ru: "Ռուսերեն",
      hy: "Հայերեն",
    },
    only_manual_now: "Ներկայումս հասանելի է միայն ձեռքով թարգմանություն",
    ai_coming_soon: "ԱԲ թարգմանությունը շուտով կակտիվանա",
    got_it: "Հասկացա",
    origin_language: "Ելակետային լեզու",
    target_languages: "Թիրախային լեզուներ",
    remove_all: "Հեռացնել բոլոր լեզուները",
    translation_method: "Ընտրել թարգմանության մեթոդը",
    manual_translation: "Ձեռքով թարգմանություն",
    ai_translation: "ԱԲ թարգմանություն",
    coming_soon: "Շուտով",
    source_language_updated: "Ելակետային լեզուն թարմացվել է",
    error_changing_source_language: "Սխալ ելակետային լեզու փոխելիս",
    source_language_created: "Ստեղծվել է նոր ելակետային լեզու",
    languages_saved: "Նոր լեզուները պահպանվել են",
    error_saving_languages: "Սխալ լեզուներ պահպանելիս",
    error_loading_language: "Սխալ լեզու բեռնելիս",
    languages_removed: "Հեռացված լեզուներ",
    new_languages_to_save: "Պահպանման համար նոր լեզուներ",
    saved: "Պահպանվել է",
    management_langs: "Լեզուների կառավարում",
    add_langs: "Ավելացնել լեզու",
    change_language: "Փոխել լեզուն",
    visit_card: "Այցելության քարտ",
    translate_to: "Թարգմանել դեպի",
    main_language: "լեզու",
    no_languages_available: "Հասանելի լեզու չկա",
    return_to_default: "Վերադառնալ լռելյայն լեզվին",
    translate: "Թարգմանել",
    changes_pending: "Սպասում է փոփոխությունների կիրառմանը",
    apply_changes: "Կիրառել փոփոխությունները",
    cancel_changes: "Չեղարկել",
  },
  winner_list: "Հաղթողների ցուցակ",
  qrwinnersList: {
    winnerstotalcount: "QR-ի հաղթողների ընդհանուր քանակը",
    winnerscountoffilter: "Հաղթողների քանակը կիրառված զտիչով",
    winnersList: "QR հաղթողների ցուցակ",
    prize: "Մրցանակ",
    winnerName: "Հաղթողի անուն",
    date: "Ամսաթիվ",
    noWinners: "Հաղթողներ չկան",
    perPage: "Քանակ մեկ էջում",
    search: "Որոնել անունով կամ մրցանակով",
    sortDirection: "Դասավորության ուղղություն",
    sortBy: "Դասավորել ըստ",
  },
  appearance_settings: "Արտաքին տեսքի կարգավորումներ",
  header_color: "Վերնագրի գույն",
  background_color: "Հետնաշերտի գույն",
  text_color: "Տեքստի գույն",
  font_size: "Տառաչափ",
  chat_logo: "Չաթի լոգո",
  floating_button_icon: "Լողացող կոճակի պատկերակ",
  assistant_name: "Օգնականի անուն",
  chat_preview: "Չաթի նախադիտում",
  smart_assistant: "Խելացի օգնական",
  online: "Առցանց",
  aiChatSettings: {
    select_assistant: "Ընտրել օգնական",
    appearance_settings: "Արտաքին տեսքի կարգավորումներ",
    lead_connection_tab: "Լիդերի հավաքագրում - Հաճախորդների ակումբին միացում",

    header_settings: "Վերնագիր կարգավորումներ",
    header_settings_desc: "Չատի վերնագրի գույն և ոճ",
    text_settings: "Տեքստի կարգավորումներ",
    text_settings_desc: "Տառատեսակի գույն և չափ",
    logo_settings: "Լոգո կարգավորումներ",
    logo_settings_desc: "Օգնականի լուսանկար կամ պատկերակ",
    background_settings: "Ֆոնային կարգավորումներ",
    background_settings_desc: "Ֆոնային նկար կամ գույն",

    gradient_color: "Գրադիենտ գույն",
    solid_color: "Միագույն",
    use_image: "Օգտագործել նկար",
    use_icon: "Օգտագործել պատկերակ",

    first_color: "Առաջին գույն",
    second_color: "Երկրորդ գույն",
    header_color: "Վերնագրի գույն",
    text_color: "Տեքստի գույն",
    background_color: "Ֆոնի գույն",

    font_size: "Տառատեսակի չափ",

    robot: "Ռոբոտ",
    chat: "Զրույց",
    support: "Աջակցություն",
    question: "Հարց",
    message: "Հաղորդագրություն",
    assistant_voice: "Օգնական",
    ai_brain: "Արհեստական բանականություն",

    lead_connection_title: "Միացում հաճախորդների ակումբին",
    lead_alert:
      "Այս կարգավորումները թույլ կտան պահպանել օգտատիրոջ տվյալները հաճախորդների ակումբում, երբ նա ընտրի լիդ ուղարկել:",

    hasAssistantsName_label: "Հավաքել անուն",
    hasAssistantsName_hint: "Հավաքել օգտատիրոջ անունը",
    hasAssistantsFamily_label: "Հավաքել ազգանուն",
    hasAssistantsFamily_hint: "Հավաքել օգտատիրոջ ազգանունը",
    hasAssistantsMobile_label: "Հավաքել բջջային համար",
    hasAssistantsMobile_hint: "Հավաքել օգտատիրոջ բջջային համարը",
  },
  assistantChatViewer: {
    assistant_name: "Խելացի օգնական",
    online: "Առցանց",
    new_chat: "Նոր զրույց",
    clear_chat: "Մաքրել զրույցը",
    close: "Փակել",
    message_placeholder: "Հաղորդագրություն...",
    processing: "Մշակվում է...",
    renew: "Թարմացնել",
    created_at: "Ստեղծվել է",
    last_edit: "Վերջին խմբագրում",
    copied: "Պատճենվել է",
    copy: "Պատճենել",
    print_qr: "Տպել QR",
    print_visit_card: "Տպել այցեքարտ",
    send_link: "Ուղարկել հղումը",
    winner_list: "Հաղթողների ցուցակ",
    customer_list: "Հաճախորդների ցուցակ",
    order_list: "Պատվերների ցուցակ",
    reserved_appointments: "Ամրագրված հանդիպումներ",
    feedback: "Հետադարձ կապ",
    request_form: "Հայտի ձև",
    transfer_ownership: "Սեփականության փոխանցում",
    store_management: "Խանութի կառավարում",
    select_nfc_card: "Ընտրել NFC քարտ",
    edit: "Խմբագրել",
    design: "Դիզայն",
    qr_settings: "QR կարգավորումներ",
    deactivate: "Ապաակտիվացնել",
    download: "Ներբեռնել",
    viewed: "Դիտվել է անգամ",
    see_more: "Տեսնել ավելին",
    updating_qr: "QR-ը թարմացվում է...",
  },
  create_game: "Խաղ ստեղծել",
  ready_games: "Պատրաստի խաղեր",
  add_game: "Խաղ ավելացնել",
  game_gallery: "Խաղերի պատկերասրահ",
  game_size_error: "Խաղի ֆայլի չափը չպետք է գերազանցի 2 ՄԲ",
  game_upload_error: "Խաղի վերբեռնման սխալ",
  no_game_available: "Ոչ մի խաղ հասանելի չէ",
  to_use_ready_games_search_category_or_product:
    "Պատրաստի խաղեր օգտագործելու համար որոնել կատեգորիայով կամ արտադրանքով",
  gif_size_error: "GIF ֆայլի չափը չպետք է գերազանցի 2 ՄԲ",
  previewer_page: "Նախադիտման ցուցադրում",
  // ─────────────────────────────────────────────────────
  // Խաղի, GIF-ի և կարգավորումների բաժնի թարգմանության բանալիներ
  // Ֆայլ՝ src/core/services/langs/hy.js
  // Լեզու՝ Արևելահայերեն (Eastern Armenian)
  // ─────────────────────────────────────────────────────
  // 1. Հիմնական խաղի խմբագրիչ (PublicGameEditor)
  game_editor: "Խաղի խմբագրիչ",
  reset_defaults: "Վերադարձնել նախնականներին",
  save_and_preview: "Պահպանել և նախադիտել",
  texts: "Տեքստեր",
  images: "Պատկերներ",
  colors: "Գույներ",
  general_settings: "Ընդհանուր կարգավորումներ",
  gameplay_settings: "Խաղային մեխանիկայի կարգավորումներ",
  effects: "Էֆեկտներ",
  login_and_phone: "Մուտք և հեռախոսահամար",
  no_settings_available_for_this_game_type:
    "Այս խաղի տեսակի համար կարգավորումներ չկան",
  confirm_reset: "Հաստատել վերականգնումը",
  reset_all_settings_to_default:
    "Վստահ ե՞ք, որ ցանկանում եք վերականգնել բոլոր կարգավորումները նախնական վիճակին։",
  yes_reset: "Այո, վերականգնել",
  cancel: "Չեղարկել",
  settings_reset_successfully: "Կարգավորումները հաջողությամբ վերականգնվեցին",
  saved_and_ready_for_preview: "Պահպանվել է և պատրաստ է նախադիտման",

  // 2. Մուտք և հեռախոսահամար ներդիր (TabLogin)
  login_and_phone_settings: "Մուտքի և հեռախոսահամարի կարգավորումներ",
  ask_phone_after_game: "Խաղի ավարտից հետո հեռախոսահամար խնդրել",
  phone_prompt_text: "Հեռախոսահամար խնդրելու տեքստ",
  phone_prompt_hint:
    "Տեքստը, որը ցուցադրվում է հեռախոսահամար խնդրելու երկխոսության մեջ",
  submit_button: "Ուղարկել կոճակը",
  login_dialog_logo: "Մուտքի երկխոսության լոգո",
  logo_url: "Լոգոյի հասցե (URL)",

  // 3. Էֆեկտներ ներդիր (TabEffect)
  game_effects_settings: "Խաղի էֆեկտների կարգավորումներ",
  sound_enabled: "Միացնել ձայնը",
  volume: "Ձայնի մակարդակ",
  volume_hint: "Խաղի ձայնի մակարդակը (0-ից մինչև 1)",
  oscillator_type: "Օսցիլյատորի տեսակ",
  jump_sound_freq: "Ցատկի ձայնի հաճախություն",
  hit_sound_freq: "Հարվածի ձայնի հաճախություն",
  powerup_sound_freq: "Պավերափի ձայնի հաճախություն",
  move_sound_freq: "Շարժման ձայնի հաճախություն",
  combo_base_freq: "Կոմբոյի հիմնական հաճախություն",
  sound_durations: "Ձայների տևողություններ",
  move_duration_ms: "Շարժման ձայնի տևողություն (մվ)",
  jump_duration_ms: "Ցատկի ձայնի տևողություն (մվ)",
  combo_duration_ms: "Կոմբոյի ձայնի տևողություն (մվ)",
  hit_duration_ms: "Հարվածի ձայնի տևողություն (մվ)",
  vibration_enabled: "Միացնել թրթռումը",
  particles_enabled: "Միացնել մասնիկները",
  explosion_settings: "Պայթյունի մասնիկների կարգավորումներ",
  particle_count: "Մասնիկների քանակ",
  gravity: "Ձգողություն",
  friction: "Շփում",
  fade_speed: "Անհետացման արագություն",

  // 4. Պատկերներ ներդիր (TabImages)
  game_images_and_assets: "Խաղի պատկերներ և ակտիվներ",
  player_image: "Խաղացողի պատկեր",
  player: "Խաղացող",
  powerup_image: "Պավերափի պատկեր",
  qr_powerup: "QR պավերափ",
  enemy_images: "Թշնամիների պատկերներ",
  optional_multi: "Ընտրովի, մի քանի պատկեր",
  enemies: "Թշնամիներ",
  background_image: "Հետին ֆոնի պատկեր",
  background: "Հետին ֆոն",
  phone_frame_background: "Հեռախոսի շրջանակի ֆոն",
  phone_frame: "Հեռախոսի շրջանակ",
  winner_background: "Հաղթողի ֆոն",
  winner: "Հաղթող",
  ground_image: "Հողի պատկեր",
  ground: "Հող",
  player_character: "Խաղացողի կերպար",
  far_background_layer: "Հեռավոր ֆոնային շերտ",
  background_far: "Հեռավոր ֆոն",
  near_background_layer: "Մոտիկ ֆոնային շերտ",
  background_near: "Մոտիկ ֆոն",
  obstacle_images: "Արգելքների պատկերներ",
  multi_optional: "Մի քանի պատկեր, ընտրովի",
  obstacles: "Արգելքներ",

  // 5. Տեքստեր ներդիր (TabTexts)
  game_text_contents: "Խաղի տեքստային բովանդակություն",
  main_screen_texts: "Հիմնական էկրանի տեքստեր",
  game_title: "Խաղի վերնագիր",
  game_subtitle: "Խաղի ենթավերնագիր",
  start_button: "Սկսել կոճակ",
  score_label: "Միավորների պիտակ",
  game_over_screen: "Խաղի ավարտի էկրան",
  game_over_title: "Խաղի ավարտի վերնագիր",
  game_over_subtitle: "Խաղի ավարտի ենթավերնագիր",
  phone_prompt: "Հեռախոսահամարի խնդրանք",
  restart_button: "Վերաստարտ կոճակ",
  hud_and_labels: "HUD և պիտակներ",
  level_label: "Մակարդակի պիտակ",
  combo_label: "Կոմբոյի պիտակ",
  final_score_label: "Վերջնական միավորների պիտակ",
  high_score_label: "Ամենաբարձր միավորի պիտակ",
  messages_and_popups: "Հաղորդագրություններ և պատուհաններ",
  new_record_message: "Նոր ռեկորդի հաղորդագրություն",
  fun_random_messages: "Զվարճալի պատահական հաղորդագրություններ",
  add_new_message: "Ավելացնել նոր հաղորդագրություն",

  // 6. Ընդհանուր կարգավորումներ ներդիր (TabSetting)
  general_game_settings: "Խաղի ընդհանուր կարգավորումներ",
  enemy_spawn_rate: "Թշնամիների առաջացման արագություն",
  frames_between_enemies_spawn: "Թշնամիների միջև կադրերի քանակ",
  powerup_spawn_rate: "Պավերափերի առաջացման արագություն",
  frames_between_qr_spawn: "QR-ների միջև կադրերի քանակ",
  win_score_threshold: "Հաղթանակի միավորների շեմ",
  score_required_for_win_or_phone_prompt:
    "Հաղթանակի կամ հեռախոսի խնդրանքի համար պահանջվող միավորներ",
  starting_lives: "Սկզբնական կյանքերի քանակ",
  high_score_storage_key: "Ամենաբարձր միավորի պահպանման բանալի",
  phone_prompt_score_threshold: "Հեռախոսի խնդրանքի միավորների շեմ",
  score_to_show_phone_number_form: "Հեռախոսահամարի ձևը ցուցադրելու միավորներ",
  no_general_settings_available_for_this_game:
    "Այս խաղի համար ընդհանուր կարգավորումներ չկան",

  // 7. Խաղային մեխանիկա ներդիր (TabGamePlay)
  speed_settings: "Արագության կարգավորումներ",
  initial_speed: "Սկզբնական արագություն",
  max_speed: "Առավելագույն արագություն",
  speed_increase_every_frames: "Արագության ավելացում ամեն X կադր",
  speed_increase_amount: "Արագության ավելացման չափ",
  distance_per_level: "Հեռավորություն մեկ մակարդակի համար",
  level_speed_increase: "Մակարդակի արագության ավելացում",
  jump_and_physics: "Ցատկ և ֆիզիկա",
  jump_force: "Ցատկի ուժ",
  max_jump_height: "Առավելագույն ցատկի բարձրություն",
  lanes_settings: "Շերտերի կարգավորումներ",
  number_of_lanes: "Շերտերի քանակ",
  starting_lane: "Սկզբնական շերտ",
  enemies_spawn: "Թշնամիների առաջացում",
  traps_spawn: "Թակարդների առաջացում",
  min_spawn_interval_ms: "Առավելագույն առաջացման միջակայք (մվ)",
  max_spawn_interval_ms: "Առավելագույն առաջացման միջակայք (մվ)",
  same_lane_chance: "Նույն շերտում առաջանալու հավանականություն",
  probability_of_spawn_in_player_lane:
    "Խաղացողի շերտում առաջանալու հավանականություն",
  collision_tolerance_px: "Բախման հանդուրժողականություն (պիքսել)",
  scoring_rules: "Միավորների հաշվարկի կանոններ",
  hit_penalty: "Հարվածի տուգանք",
  powerup_reward: "Պավերափի պարգև",
  score_speed_divider: "Միավոր-արագություն բաժանիչ",
  reset_combo_on_hit: "Հարվածի դեպքում կոմբոյի վերականգնում",
  camera_settings: "Կամերայի կարգավորումներ",
  normal_zoom: "Նորմալ մեծացում",
  hit_zoom: "Հարվածի ժամանակ մեծացում",
  zoom_lerp_speed: "Մեծացման հարթեցման արագություն",
  game_end_conditions: "Խաղի ավարտի պայմաններ",
  phone_dialog_score_threshold: "Հեռախոսի երկխոսության միավորների շեմ",

  // 8. Գույներ ներդիր (TabColors)
  background_gradient: "Ֆոնի գրադիենտ",
  first_color: "Առաջին գույն",
  second_color: "Երկրորդ գույն",
  particle_hit_color: "Հարվածի մասնիկների գույն",
  particle_powerup_color: "Պավերափի մասնիկների գույն",
  main_background_color: "Հիմնական ֆոնի գույն",
  ground_color: "Հողի գույն",
  hud_colors: "HUD գույներ",
  hud_background: "HUD ֆոն",
  score_text_color: "Միավորների տեքստի գույն",
  level_text_color: "Մակարդակի տեքստի գույն",
  combo_text_color: "Կոմբոյի տեքստի գույն",
  overlay_colors: "Վերին շերտի գույներ",
  backdrop_color: "Հետին պաստառի գույն",
  card_background: "Քարտի ֆոն",
  card_border_color: "Քարտի եզրագծի գույն",
  explosion_particle_color: "Պայթյունի մասնիկների գույն",

  // 9. QR նախադիտման բաղադրիչ (previewerQr)
  gif_tab: "GIF ներդիր",
  game_tab: "Խաղի ներդիր",
  welcome_gif_upload: "Ողջույնի GIF վերբեռնում",
  default_welcome: "Նախնական ողջույն",
  loading_animation: "Բեռնման անիմացիա",
  hide_previewer: "Թաքցնել նախադիտումը",
  show_previewer: "Ցուցադրել նախադիտումը",
  edit_game_settings: "Խաղի կարգավորումների խմբագրում",
  save_and_close: "Պահպանել և փակել",
  animation_scale: "Անիմացիայի մասշտաբ",
  animation_slide_x: "Հորիզոնական սահման անիմացիա",
  animation_slide_y: "Ուղղահայաց սահման անիմացիա",
  animation_fade: "Թարմացման անիմացիա",
  game_settings_saved: "Խաղի կարգավորումները պահպանվեցին",
  no_game_configured: "Խաղ չի կարգավորված",

  // 10. GIF ընտրիչ (gifSelector)
  gallery_name: "Պատկերասրահի անուն",
  change_gallery_name: "Փոխել պատկերասրահի անունը",
  add_gif: "Ավելացնել GIF",
  select_gif: "Ընտրել GIF",
  show_gif: "Ցուցադրել GIF",
  selected_gif: "Ընտրված GIF",
  count: "Քանակ",
  select_category: "Ընտրել կատեգորիա",
  after_typing_enter: "Մուտքագրելուց հետո սեղմել Enter",
  search: "Որոնել",
  no_gif_available: "GIF չկա",
  to_use_ready_gifs_search_category_or_product:
    "Պատրաստի GIF-ներ օգտագործելու համար որոնել կատեգորիայով կամ արտադրանքով",
  max_file_size_2mb: "Ֆայլի առավելագույն չափը 2 ՄԲ",
  upload_file: "Վերբեռնել ֆայլ",
  drag_and_drop_to_upload_or: "Քաշել և թողնել վերբեռնելու համար կամ",
  here: "այստեղ",
  click: "սեղմել",
  all: "Բոլորը",
  no_gif_found: "GIF չի գտնվել",
  for_adding_file_use_upload_center:
    "Ֆայլ ավելացնելու համար օգտագործել վերբեռնման կենտրոնը",
  to_use_external_gif_link_fill_fields:
    "Արտաքին GIF հղում օգտագործելու համար լրացնել դաշտերը",
  gif_url_hint: "GIF ֆայլի ամբողջական հասցե",
  gif_url: "GIF հասցե",
  add: "Ավելացնել",
  title: "Վերնագիր",
  link: "Հղում",
  description: "Նկարագրություն",
  add_new_gallery: "Ավելացնել նոր պատկերասրահ",
  enter_valid_link: "Մուտքագրել վավեր հղում",
  create_gif: "Ստեղծել GIF",
  ready_gifs: "Պատրաստի GIF-ներ",
  gif_gallery: "GIF պատկերասրահ",
  edit_gif: "Խմբագրել GIF",
  max_background_gif_size_2mb: "Ֆոնային GIF-ի առավելագույն չափը 2 ՄԲ է",
  uploaded_successfully: "Հաջողությամբ վերբեռնվել է",
  gif_upload_error: "GIF վերբեռնման սխալ",

  // 11. Լրացուցիչ տեքստեր և թեստային բանալիներ
  preview: "Նախադիտում",
  start_button_text: "Սկսել կոճակի տեքստ",
  game_over_text: "Խաղի ավարտի տեքստ",
  game_over_subtext: "Խաղի ավարտի ենթատեքստ",
  mobile_prompt_text: "Բջջային խնդրանքի տեքստ",
  submit_button_text: "Ուղարկել կոճակի տեքստ",
  optional: "Ընտրովի",
  game_background: "Խաղի ֆոն",
  background_gradient_colors: "Ֆոնի գրադիենտ գույներ",
  frames_per_enemy: "Թշնամու համար կադրեր",
  frames_per_powerup: "Պավերափի համար կադրեր",
  win_threshold: "Հաղթանակի շեմ",
  score_to_win: "Հաղթանակի միավորներ",
  your_work_page_name: "Անձնական/Կորպորատիվ Kiwvar",
  "pdf_gallery": {
    "display_mode": "PDF-ի ցուցասրահի ցուցադրման ռեժիմ",
    "display_mode_label": "Ցուցադրման ռեժիմ",
    "layout": {
      "list": "Ցուցակի տեսք",
      "accordion": "Ակորդեոնի տեսք",
      "slider": "Սահիչի տեսք"
    },
    "gallery_name": "Ցուցասրահի անունը",
    "selected_gallery": "Ընտրված ցուցասրահ",
    "add_file": "Ավելացնել ֆայլ",
    "pdf_gallery_label": "PDF Ցուցասրահ",
    "select_file": "Ընտրել ֆայլ",
    "title": "Վերնագիր",
    "pdf_url": "PDF Հղում",
    "description": "Նկարագրություն",
    "add_button": "Ավելացնել",
    "all": "Բոլորը",
    "image_gallery": "Նկարների ցուցասրահ",
    "edit_pdf": "Խմբագրել PDF",
    "preview": "Նախադիտում",
    "add_pdf_gallery": "Ավելացնել PDF ցուցասրահ",
    "default_gallery_name": "Ցուցասրահ",
    "gallery_prefix": "Ցուցասրահ",
    "tabs": {
      "add_file": "Ավելացնել ֆայլ",
      "pdf_gallery": "PDF Ցուցասրահ",
      "link": "Հղում"
    },
    "messages": {
      "file_too_large": "Ֆայլի չափը չի կարող գերազանցել 10 ՄԲ:",
      "invalid_file_type": "Խնդրում ենք ընտրել միայն փաստաթղթերի և տեքստային ֆայլեր:",
      "upload_error": "Ֆայլի բեռնման սխալ:",
      "only_pdf_txt_allowed": "Կարող են ավելացվել միայն PDF և TXT ֆայլեր:",
      "title_url_required": "Խնդրում ենք մուտքագրել վերնագիրը և ֆայլի հղումը:"
    }
  },
  "special_info_desc": {
    "textCards": "Ավելացրեք տեքստային քարտեր օգտատերերի տվյալները կամ հակիրճ կենսագրությունը ցուցադրելու համար:",
    "customerClubSettings": "Սահմանեք հաճախորդների ակումբի անդամակցության հաղորդագրությունը հեռախոսահամարը գրանցելուց հետո:",
    "advanceSettings": "Կառավարեք ընդլայնված և խելացի կարգավորումները էջը հարմարեցնելու համար:",
    "voiceGallery": "Բեռնեք և կառավարեք աուդիո ֆայլեր էջում նվագարկելու համար:",
    "VideoGallery": "Ավելացրեք և ցուցադրեք տեսանյութեր ներկայացման կամ ուսուցման համար:",
    "imageUploader": "Բեռնեք նկարներ ցուցասրահում կամ էջի տարբեր հատվածներում ցուցադրելու համար:",
    "colorPallete": "Ընտրեք անհատական գույներ էջի դիզայնը հարմարեցնելու համար:",
    "socialMediaIcons": "Ավելացրեք սոցիալական ցանցերի հղումներ օգտատերերի արագ մուտքի համար:",
    "pdfSelector": "Բեռնեք և ցուցադրեք PDF ֆայլեր օգտատերերի համար:",
    "FeedBack": "Ստացեք օգտատերերի մեկնաբանությունները ծառայությունների վերաբերյալ:",
    "consultationNew": "Ստեղծեք ձևաթուղթ հարցումներ ներկայացնելու կամ կապ հաստատելու համար:"
  },
  "voice_gallery": {
    "autoplay_warning": "Դուք կարող եք միաժամանակ ավտոմատ նվագարկել միայն մեկ աուդիո ֆայլ:",
    "autoplay": "Ավտոմատ նվագարկում"
  },
  "card": {
    "consultation": {
      "title": "Հարցման ձև"
    },
    "form": {
      "name": "Անուն",
      "surname": "Ազգանուն",
      "phone": "Բջջայինի համար",
      "email": "Էլ. փոստ",
      "address": "Հասցե",
      "national_id": "Անձնագրի համար",
      "location": "Գտնվելու վայրը",
      "description": "Նկարագրություն"
    },
    "feedback": {
      "title": "Ձեր կարծիքը",
      "description": "Խնդրում ենք օգնել մեզ բարելավել մեր ծառայությունները՝ պատասխանելով հետևյալ հարցերին.",
      "q1": "Որքանո՞վ եք գոհ QRLand-ի ծառայություններից:",
      "q2": "Որքանո՞վ են QRLand-ի ծառայությունները բավարարել ձեր կարիքները:",
      "q3": "Որքանո՞վ էր խելամիտ վճարված գինը ստացված ծառայության դիմաց:",
      "q4": "Կիսվեք ձեր մտքերով մեզ հետ մեր ծառայությունները բարելավելու համար:"
    },
    "pdf": {
      "gallery_name": "QRLand առաջարկների ցուցասրահ",
      "item1_title": "Ապրանքի ներկայացման առաջարկ",
      "item1_desc": "QRLand ծառայությունների համապարփակ ներկայացում, ինչպես են գործում խելացի QR կոդերը և առավելությունները բիզնեսի համար:",
      "item2_title": "Թվային այցեքարտի առաջարկ",
      "item2_desc": "QRLand թվային այցեքարտի ներկայացում, կոնտակտային տվյալների արագ տարածում և սոցիալական ցանցեր:"
    },
    "pdf_selector": {
      "title": "PDF Ցուցասրահ",
      "description": "Նկարագրություն"
    },
    "info": {
      "visit_name": "QRLand / Թվային այցեքարտ",
      "organization_name": "QRLand",
      "sub_organ": "Առաջին դինամիկ QR գեներատորի հարթակը",
      "user_name": "Թվային այցեքարտ",
      "fax": "Ֆաքս: 02191016066",
      "location_desc": "Թեհրան, Շարիաթի փող., Սեյեդ Խանդան կամրջից հետո, Խանդանի նրբանցք, Թիվ 6",
      "postal_code": "Փոստային ինդեքս: 1541946815",
      "about_us": "Ֆիզիկական այցեքարտերի հետ կապված խնդիրների պատճառով QRLand-ը ներկայացրել է «Թվային այցեքարտ» պրոդուկտը՝ վերացնելով ֆիզիկական սահմանափակումները և կանխելով ծառերի հատումը:",
      "full_address": "Իրան, Թեհրան, Սեյեդ Խանդան, Դոկտոր Ալի Շարիաթի, Խանդան"
    },
    "extra": {
      "field1": "🟥 Ստեղծեք նմանատիպ թվային այցեքարտ ձեր բիզնեսի համար:\n🟧 Փորձարկեք այն անվճար 3 օր:\n🟨 Սեղմեք այստեղ անվճար գրանցվելու համար:",
      "field2": "Ձեր թվային այցեքարտը ունի դինամիկ QR կոդ: Տեղեկությունները կարող եք խմբագրել ցանկացած պահի: Խմբագրելուց հետո կոդը երբեք չի փոխվի:",
      "field3": "💲 Այս այցեքարտի արժեքն է 900,000 Թոման:"
    },
    "gallery": {
      "name": "Մենք միշտ ձեր կողքին կլինենք..."
    },
    "social": {
      "address_hint": "Խնդրում ենք մուտքագրել ձեր հասցեն",
      "address_label": "Հասցե",
      "instagram_hint": "Խնդրում ենք մուտքագրել ձեր Instagram-ի հղումը",
      "instagram_label": "Instagram",
      "whatsapp_hint": "Խնդրում ենք մուտքագրել ձեր WhatsApp-ի հղումը",
      "whatsapp_label": "WhatsApp"
    },
    "video": {
      "item1_name": "Ինչու՞ QRLand այցեքարտ: Ինչո՞վ է տարբերվում QRLand-ը:",
      "item1_title": "Ինչու՞ QRLand այցեքարտ",
      "item2_name": "QRLand թվային այցեքարտի ներկայացում",
      "item2_title": "Ֆիզիկական այցեքարտերի լավագույն այլընտրանքը"
    },
    "club": {
      "title": "Հաճախորդների ակումբի անդամակցություն",
      "description": "Սա սովորական հաճախորդների ակումբ չէ:\nԳրանցեք ձեր համարը"
    },
    "audio": {
      "category_all": "Բոլորը",
      "item1_title": "Թվային այցեքարտերի համապարփակ ուղեցույց",
      "diff_seconds": "1 վայրկյան առաջ"
    }
  },
  "pic": {
    "background_image": "Ֆոնային նկար",
    "image_display_type": "Նկարի ցուցադրման տեսակը",
    "image_orientation": "Նկարի կողմնորոշումը՝",
    "horizontal": "Հորիզոնական",
    "vertical": "Ուղղահայաց",
    "change_display_mode": "Փոխել ցուցադրման ռեժիմը",
    "image": "Նկար",
    "uploaded_image": "Բեռնված նկար"
  },
  "send_limit_per_user": "Ուղարկման սահմանաչափ մեկ օգտատիրոջ համար (0 = անսահմանափակ)",
    "enable_discount_code": "Ակտիվացնել զեղչի կոդը",
    "add_new_discount_code": "Ավելացնել նոր զեղչի կոդ",
    "no_discount_codes_added": "Զեղչի կոդեր ավելացված չեն",

"toolsManagment": "Կառավարման գործիքներ",
"gateway": {
  "edit": "Խմբագրել",
  "integrated_edit_all_sections": "Բոլոր բաժինների համատեղ խմբագրում",
  "show_descriptions": "Ցուցաբերել նկարագրությունները",
  "search_section_placeholder": "Որոնել բաժին...",
  "no_section_found": "Այս անունով բաժին չգտարվեց:",
  "back_to_menu": "Վերադարձ մենյու",
  "cancel": "Չեղարկել",
  "save": "Պահպանել"
},
"gridShow": "Ցանցային տեսք",
"tableShow": "Աղյուսակային տեսք",
"editvisit": {
  special_info_single: {
    text_cards_description:
      "Ավելացրեք տեքստային քարտեր՝ օգտատիրոջ տեղեկությունները, օրինակ՝ նկարագրությունը, փորձը կամ կարճ ներկայացումը ցուցադրելու համար.",

    customer_club_settings_description:
      "Կարգավորեք հաճախորդների ակումբին միանալու հաղորդագրությունը, որն ուղարկվում է օգտատերերին հեռախոսահամարը գրանցելուց հետո.",

    advance_settings_description:
      "Կառավարեք ընդլայնված և խելացի կարգավորումները՝ էջի վարքն ու հնարավորությունները անհատականացնելու համար.",

    voice_gallery_description:
      "Վերբեռնեք և կառավարեք էջում նվագարկվող աուդիոֆայլերը.",

    video_gallery_description:
      "Ավելացրեք և ցուցադրեք տեսանյութեր ներկայացման, ուսուցման կամ բովանդակության ցուցադրման համար.",

    image_uploader_description:
      "Վերբեռնեք պատկերներ՝ դրանք պատկերասրահում կամ էջի տարբեր բաժիններում ցուցադրելու համար.",

    color_palette_description:
      "Ընտրեք անհատական գույներ՝ էջի տեսքն ու դիզայնը հարմարեցնելու համար.",

    social_media_icons_description:
      "Ավելացրեք սոցիալական ցանցերի հղումներ՝ արագ հասանելիության համար.",
  },
},

"editBpage": {
  special_info_single: {
    banner_selector_description:
      "Վերբեռնեք կամ փոխեք համալիրի հիմնական բանների պատկերը.",

    logo_select_description:
      "Սահմանեք բիզնեսի կամ համալիրի լոգոն.",

    service_description:
      "Կառավարեք համալիրի հիմնական ծառայություններն ու հնարավորությունները.",

    faq_description:
      "Ավելացրեք և խմբագրեք հաճախորդների հաճախ տրվող հարցերը.",

    blog_description:
      "Ավելացրեք համալիրին վերաբերող հոդվածներ և նորություններ.",

    floor_description:
      "Կառավարեք համալիրի հարկերն ու առևտրային միավորները.",

    text_cards_description:
      "Մուտքագրեք նկարագրություններ և օգտատիրոջ հետ կապված տեղեկություններ.",

    social_media_icons_description:
      "Ավելացրեք սոցիալական ցանցերի հղումներ՝ հաճախորդների հետ կապի համար.",

    pic_selector_description:
      "Ավելացրեք համալիրի և խանութների պատկերները.",

    video_gallery_description:
      "Վերբեռնեք ներկայացման կամ գովազդային տեսանյութեր.",

    pdf_selector_description:
      "Կառավարեք կատալոգներն ու տեղեկատվական ուղեցույցները.",

    feedback_description:
      "Կառավարեք այցելուների կարծիքների և արձագանքների բաժինը.",

    consultation_new_description:
      "Կառավարեք հաճախորդների տեղեկությունների կամ հարցումների հավաքագրման ձևը.",

    service_section_description:
      "Ստեղծեք ծառայությունների համար նախատեսված հատուկ բաժիններ.",

    counter_service_description:
      "Թվային ձևաչափով ցուցադրեք համալիրի վիճակագրությունն ու ձեռքբերումները.",

    counter_description:
      "Սահմանեք միջոցառումների կամ բացման հետհաշվարկը.",

    personnel_description:
      "Ներկայացրեք ղեկավարներին և թիմի հիմնական անդամներին.",

    customer_club_settings_description:
      "Կառավարեք SMS-ի և հաճախորդների ակումբի գրանցման կարգավորումները.",

    work_sheet_description:
      "Նշեք համալիրի աշխատանքային ժամերն ու աշխատանքային օրերը.",

    pallet_commercial_description:
      "Կարգավորեք էջի գույներն ու տեսողական ոճը.",

    default_description:
      "Ավելացրեք և կառավարեք {title} բաժինը բիզնեսի էջում.",
  },
},

store_special_info_single: {
  shop_login_config_description:
    "Կարգավորեք մուտքի էջը և փոխեք խանութի լոգոն.",

  banner_selector_description:
    "Վերբեռնեք և կառավարեք խանութի բաններները.",

  text_cards_description:
    "Տեքստային տեղեկություններ, ներկայացում և մեր մասին.",

  product_description:
    "Ստեղծեք, կառավարեք և խմբագրեք ապրանքները.",

  special_category_manager_description:
    "Կառավարեք հատուկ առաջարկների և զեղչված ապրանքների կատեգորիաները.",

  social_media_icons_description:
    "Ավելացրեք խանութի սոցիալական ցանցերի հղումները.",

  blog_description:
    "Գրեք և կառավարեք բլոգի հրապարակումները.",

  service_description:
    "Ներկայացրեք առաջարկվող լրացուցիչ ծառայությունները.",

  faq_description:
    "Ցուցադրեք և կառավարեք հաճախ տրվող հարցերի ցանկը.",

  pic_selector_description:
    "Վերբեռնեք և կառավարեք խանութի պատկերների պատկերասրահը.",

  video_gallery_description:
    "Վերբեռնեք ներկայացման և գովազդային տեսանյութեր.",

  pdf_selector_description:
    "Տրամադրեք ուղեցույցներ կամ PDF կատալոգներ.",

  feedback_description:
    "Կառավարեք հաճախորդների կարծիքներն ու արձագանքները.",

  counter_description:
    "Սահմանեք միջոցառումների կամ հատուկ առաջարկների հետհաշվարկը.",

  consultation_description:
    "Ստեղծեք հարցումների կամ խորհրդատվության հայտերի ընդունման ձև.",

  service_section_description:
    "Կառավարեք ծառայությունների հատուկ բաժինները.",

  counter_service_description:
    "Ցուցադրեք խանութի վիճակագրությունը, թվերը և ձեռքբերումները.",

  personnel_description:
    "Ներկայացրեք թիմի անդամներին և խանութի աշխատակիցներին.",

  work_sheet_description:
    "Սահմանեք խանութի աշխատանքային օրերն ու ժամերը.",

  default_description:
    "Ավելացրեք և կառավարեք {title} բաժինը խանութի էջում.",
},
edit_gold_special_info_single: {
  product_info_title: "Ապրանքի տեղեկություններ",
  product_info_description:
    "Ավելացրեք և խմբագրեք ապրանքի հիմնական տվյալները, հատկությունները, գինը և լրացուցիչ նկարագրությունները.",

  asset_management_title: "Ակտիվների կառավարում",
  asset_management_description:
    "Կառավարեք ակտիվները, նշանակեք արժեքներ և կառավարեք ապրանքի հետ կապված դրամապանակի տեղեկությունները.",

  add_social_networks_title: "Ավելացնել սոցիալական ցանցեր",
  social_networks_title: "Սոցիալական ցանցեր",
  social_media_description:
    "Ավելացրեք սոցիալական ցանցերի հղումներ՝ հաճախորդների և ձեր ապրանքանիշի միջև ավելի արագ կապ ապահովելու համար.",

  add_video_title: "Ավելացնել տեսանյութ",
  video_description:
    "Ավելացրեք և ցուցադրեք ապրանքի ներկայացման, ուսուցողական կամ գովազդային տեսանյութեր.",

  add_image_title: "Ավելացնել պատկեր",
  image_description:
    "Վերբեռնեք ապրանքի բարձրորակ պատկերներ տարբեր անկյուններից՝ պատկերասրահում ավելի լավ ցուցադրման համար.",

  select_color_title: "Ընտրել գույն",
  color_palette_description:
    "Անհատականացրեք ապրանքի էջի գունային համադրությունն ու տեսքը՝ ձեր ապրանքանիշի ինքնությանը համապատասխան.",
},

edit_multicard_special_info_single: {
  add_account_description:
    "Խմբագրել անունը, պրոֆիլի նկարը և ֆոնը",

  management_account_description:
    "Ավելացնել և խմբագրել բանկային հաշիվների տեղեկությունները",

  management_color_description:
    "Փոխել կոճակների և ֆոնի գունային թեման",
},

edit_feedback_special_single: {
  base_info_description:
    "Խմբագրել հիմնական տեղեկությունները և ձևի վերնագիրը",

  image_uploader_description:
    "Վերբեռնել և կառավարել հետադարձ կապի ձևի լոգոն",

  feedback_description:
    "Կարգավորել դաշտերը և կառավարել հետադարձ կապի ձևը",

  color_palette_description:
    "Ընտրել գունային թեմա և անհատականացնել ձևի տեսքը",
},

edit_gitf_special_info_single: {
  default_description:
    "Ավելացնել և կառավարել {title} բաժինը հիշողությունների QR շրջանակում.",
},

edit_catalog_special_info_single: {
  text_cards_description:
    "Կատալոգի հիմնական տեղեկությունները, վերնագիրը և նկարագրությունը",

  image_uploader_description:
    "Վերբեռնել և կառավարել լոգոն կամ հիմնական պատկերը",

  pic_selector_description:
    "Վերբեռնել և կառավարել կատալոգի կամ բրոշյուրի էջերը",

  social_media_icons_description:
    "Ավելացնել և կառավարել սոցիալական ցանցերի հղումները",

  color_palette_description:
    "Ընտրել գունային թեմա և անհատականացնել տեսքը",
},

edit_menu_special_info_single: {
  theme_selector_description:
    "Ընտրել ձևանմուշ՝ այլ դասակարգում կիրառելու համար",

  login_config_description:
    "Մուտքի էջի կարգավորումներ և տեսք",

  general_settings_description:
    "Արժույթի և բիզնեսի տեսակի ընդհանուր կարգավորումներ.",

  banner_selector_description:
    "Վերբեռնեք և ընտրեք բանների պատկեր՝ էջի վերևում ցուցադրելու և մենյուի կամ պրոֆիլի տեսքն ավելի գրավիչ դարձնելու համար.",

  product_description:
    "Ստեղծեք և կառավարեք ապրանքներ կամ ծառայություններ՝ պատկերով, գնով և անհատական նկարագրությամբ.",

  text_cards_description:
    "Ավելացրեք տեքստային քարտեր՝ օգտատիրոջ հիմնական տեղեկությունները, ընդհանուր նկարագրությունը, փորձը կամ կարճ ներկայացումը ցուցադրելու համար.",

  social_media_description:
    "Ավելացրեք սոցիալական ցանցերի հղումներ և պատկերակներ՝ ավելի արագ հաղորդակցության և հաճախորդների հեշտ հասանելիության համար.",

  photo_gallery_description:
    "Ստեղծեք պատկերների պատկերասրահ՝ ապրանքների լուսանկարներ, աշխատանքների օրինակներ կամ բիզնեսի միջավայրը ցուցադրելու համար.",

  video_gallery_description:
    "Ավելացրեք տեսանյութերի պատկերասրահ՝ գովազդային հոլովակներ, ուսուցողական կամ ներկայացման տեսանյութեր ցուցադրելու համար.",

  feedback_description:
    "Ստեղծեք բաժին՝ նախկին հաճախորդների կարծիքները, արձագանքներն ու գոհունակությունը ցուցադրելու համար.",

  working_hours_description:
    "Սահմանեք աշխատանքային ժամերը և բիզնեսի գործունեության ժամանակը.",
},

edit_pdf_special_info_single: {
  base_info_title: "Տեղեկություններ",
  base_info_description:
    "Ավելացրեք տեքստային քարտեր՝ օգտատիրոջ հիմնական տեղեկությունները, ընդհանուր նկարագրությունը, փորձը կամ կարճ ներկայացումը ցուցադրելու համար.",

  image_uploader_title: "Վերբեռնել լոգոն",
  image_uploader_description:
    "Վերբեռնեք և ընտրեք պատկեր՝ որպես լոգո կամ պրոֆիլի նկար էջում ցուցադրելու համար.",

  pdf_selector_title: "Ավելացնել PDF պատկերասրահ",
  pdf_selector_description:
    "Ստեղծեք PDF կամ տեքստային ֆայլերի պատկերասրահ՝ յուրաքանչյուր ֆայլի համար ծածկապատկերի և անհատական նկարագրության ավելացման հնարավորությամբ.",

  social_media_icons_title: "Ավելացնել սոցիալական ցանցեր",
  social_media_icons_description:
    "Ավելացրեք սոցիալական ցանցերի հղումներ և պատկերակներ՝ արագ հաղորդակցության և հասանելիության համար.",

  color_palette_title: "Ընտրել գույն",
  color_palette_description:
    "Ընտրեք ձևանմուշի գույնը և անհատականացրեք տարրերի տեսքը՝ ապրանքանիշին ավելի համապատասխան լինելու համար.",
},

edi_photogallery_spcial_info_single: {
  default_description:
    "Ավելացնել և կառավարել {title} բաժինը լուսանկարների պատկերասրահում.",
},

edi_social_special_info_single: {
  banner_selector_title: "Վերբեռնել լուսանկար",
  banner_selector_description:
    "Ընտրեք և վերբեռնեք ձեր սոցիալական էջի ֆոնային պատկերը կամ վերևի բանները.",

  base_info_title: "Տեղեկություններ",
  base_info_description:
    "Մուտքագրեք հիմնական տեղեկությունները, օրինակ՝ հիմնական վերնագիրը և պրոֆիլի նկարագրությունը.",

  image_uploader_title: "Վերբեռնել լոգոն",
  image_uploader_description:
    "Վերբեռնեք ձեր անձնական կամ ապրանքանիշի լոգոն կամ պրոֆիլի պատկերը էջում ցուցադրելու համար.",

  social_media_icons_title: "Ավելացնել սոցիալական ցանցեր",
  social_media_icons_description:
    "Ավելացրեք Instagram-ի, Telegram-ի, WhatsApp-ի, LinkedIn-ի և այլ սոցիալական ցանցերի հղումներ՝ դրանց պատկերակները էջում ցուցադրելու համար.",
},

edit_text_special_info_single: {
  base_info_title: "QR տեղեկություններ և տեքստեր",
  base_info_subtitle: "Հիմնական տեքստ և տեքստային դաշտեր",
  base_info_description:
    "Խմբագրեք վերնագիրը, մեր մասին հիմնական տեքստը և QR-ի անհատական տեքստային դաշտերը",

  image_uploader_title: "Լոգո և ֆոնային պատկեր",
  image_uploader_subtitle: "Պատկերի կարգավորումներ",
  image_uploader_description:
    "Վերբեռնեք և փոխեք անհատական լոգոն կամ քարտի ֆոնային պատկերը",

  color_palette_subtitle: "Արտաքին տեսքի անհատականացում",
  color_palette_description:
    "Կարգավորեք վերնագրի, ֆոնի և տեքստի գույները՝ ընթեռնելիությունն ու հակադրությունը բարելավելու համար",
},

edit_video_special_info_single: {
  base_info_title: "Տեղեկություններ",
  base_info_description:
    "Խմբագրեք հիմնական տեղեկությունները, օրինակ՝ վերնագիրը և QR կոդի հասցեն.",

  image_uploader_title: "Վերբեռնել լոգոն",
  image_uploader_description:
    "Վերբեռնեք և կառավարեք էջի լոգոյի պատկերը.",

  video_gallery_title: "Տեսանյութերի պատկերասրահ",
  video_gallery_description:
    "Ավելացրեք, խմբագրեք և կառավարեք պատկերասրահում ցուցադրվող տեսանյութերը.",

  social_media_icons_title: "Ավելացնել սոցիալական ցանցեր",
  social_media_icons_description:
    "Ավելացրեք սոցիալական ցանցերի հղումներ և կապի միջոցներ.",

  color_palette_title: "Ընտրել գույն",
  color_palette_description:
    "Փոխեք գունային համադրությունը և ընտրեք էջին համապատասխան գունային թեմա.",
},

edit_product_special_info_single: {
  factory_info_description:
    "Խմբագրել ընկերության տեղեկությունները և ներկայացումը",

  single_product_editor_description:
    "Խմբագրել հիմնական տվյալները և գործողության կոճակները, օրինակ՝ Գնել",

  customer_club_settings_description:
    "Հաճախորդների ակումբի կարգավորումներ և SMS հաղորդագրություններ",

  advance_settings_description:
    "Ցուցադրման և անվտանգության առաջադեմ կարգավորումներ",

  features_description:
    "Կառավարել ապրանքի հատկություններն ու տեխնիկական բնութագրերը",

  voice_gallery_description:
    "Վերբեռնել և կառավարել փոդքասթերն ու աուդիոֆայլերը",

  image_uploader_description:
    "Վերբեռնել և կառավարել ապրանքի պատկերների պատկերասրահը",

  video_gallery_description:
    "Ավելացնել և կառավարել ապրանքի հետ կապված տեսանյութերի պատկերասրահը",

  social_media_icons_description:
    "Ավելացնել և կառավարել սոցիալական ցանցերի հղումները",

  color_palette_description:
    "Ընտրել գունային թեմա և անհատականացնել ձևանմուշը",
},

edit_product_pro_special_info_single: {
  factory_info_description:
    "Մուտքագրեք արտադրական ընկերության ընդհանուր տեղեկությունները և ներկայացումը.",

  single_product_editor_description:
    "Կարգավորեք հիմնական տեղեկությունները, վստահության նշանը և ապրանքի գնման կոճակը.",

  customer_club_settings_description:
    "SMS կարգավորումներ և հաճախորդների անդամակցություն ակումբին.",

  features_description:
    "Ավելացրեք ապրանքի հատկություններն ու տեխնիկական բնութագրերը.",

  feedback_description:
    "Գնորդների կարծիքների և արձագանքների բաժին.",

  consultation_description:
    "Խորհրդատվության հարցման կամ պատվերի ձև.",

  advance_settings_description:
    "Ապրանքի ցուցադրման առաջադեմ և խելացի կարգավորումներ.",

  voice_gallery_description:
    "Ապրանքի ներկայացման կամ ուղեցույցի աուդիոֆայլեր.",

  image_uploader_description:
    "Վերբեռնեք ապրանքի տարբեր պատկերները.",

  video_gallery_description:
    "Ապրանքի հետ կապված ներկայացման կամ ուսուցողական տեսանյութեր.",

  social_media_icons_description:
    "Սոցիալական ցանցերի հղումներ՝ ավելի լավ հաղորդակցության համար.",

  color_palette_description:
    "Կարգավորեք ապրանքի էջի գույներն ու տեսողական ոճը.",
},

edit_voice_special_info_single: {
  base_info_voice_description:
    "Աուդիո պատկերասրահի հիմնական տեղեկություններն ու բնութագրերը",

  image_uploader_description:
    "Վերբեռնել և կառավարել լոգոն կամ շապիկի պատկերը",

  voice_gallery_description:
    "Վերբեռնել և կառավարել աուդիոֆայլերն ու փոդքասթերը",

  color_palette_description:
    "Ընտրել գունային թեմա և անհատականացնել պատկերասրահի տեսքը",
},

edit_voice_pro_special_info_single: {
  base_info_description:
    "Խմբագրել պատկերասրահի վերնագիրն ու նկարագրությունը",

  image_uploader_description:
    "Վերբեռնել և կառավարել լոգոն ու հիմնական շապիկը",

  voice_gallery_acc_description:
    "Վերբեռնել, ջնջել և կառավարել աուդիոֆայլերը",

  social_media_icons_description:
    "Ավելացնել և կառավարել սոցիալական ցանցերի հղումները",

  color_palette_description:
    "Ընտրել գունային թեմա և անհատականացնել պատկերասրահի տեսքը",
},
edit_bpage_special_info_special: {
  advertising_sites: "Annonsesider",
stores: "Butikker",

divar: "Divar",
divar_hint: "Skriv inn Divar-lenken din",

sheypoor: "Sheypoor",
sheypoor_hint: "Skriv inn Sheypoor-lenken din",

digikala: "Digikala",
digikala_hint: "Skriv inn Digikala-lenken din",

basalam: "Basalam",
basalam_hint: "Skriv inn Basalam-lenken din",

snappshop: "SnappShop",
snappshop_hint: "Skriv inn SnappShop-lenken din",

technolife: "Technolife",
technolife_hint: "Skriv inn Technolife-lenken din",

torob: "Torob",
torob_hint: "Skriv inn Torob-lenken din",

emalls: "eMalls",
emalls_hint: "Skriv inn eMalls-lenken din",

cafebazaar: "Cafe Bazaar",
cafebazaar_hint: "Skriv inn Cafe Bazaar-lenken din",

googleplay: "Google Play",
googleplay_hint: "Skriv inn Google Play-lenken din",

samsung: "Samsung",
samsung_hint: "Skriv inn Galaxy Store-lenken din",

apple: "Apple",
apple_hint: "Skriv inn App Store-lenken din",
  add_audio_gallery: "Ավելացնել աուդիո ֆայլերի պատկերասրահ",
  factory_information: "Կազմակերպության տվյալներ",
  trust_badge: "Վստահության նշան",
  buy_button: "Գնելու կոճակ",
  smart_settings: "Խելացի կարգավորումներ",
  add_product_feature: "Ավելացնել ապրանքի հատկանիշ",
  product_features: "Ապրանքի հատկանիշներ",
  add_audio_file: "Ավելացնել աուդիո ֆայլ",
  audio_gallery: "Աուդիո պատկերասրահ",
  text: "Տեքստ",
  logo_background: "Լոգո / ֆոն",
  select_color: "Ընտրել գույնը",
  information: "Տեղեկություններ",
  luck_management: "Հաջողության կառավարում",
  registration_management: "Գրանցման կառավարում",
  turning: "Թերթում",
  slider: "Սլայդեր",
  vertical: "Ուղղահայաց",
  upload_catalog_brochure_images: "Վերբեռնել կատալոգի / բրոշյուրի պատկերները",
  upload_banner: "Վերբեռնել բանները",
  upload_header_image: "Վերբեռնել վերնագրի պատկերը",
  upload_image: "Վերբեռնել պատկեր",
  services: "Ծառայություններ",
  faq: "Հաճախ տրվող հարցեր",
  blog: "Բլոգ",
  create_product: "Ստեղծել ապրանք",
  user_information: "Օգտատիրոջ տվյալներ",
  add_social_media: "Ավելացնել սոցիալական ցանցեր",
  photo_gallery: "Լուսանկարների պատկերասրահ",
  video_gallery: "Տեսանյութերի պատկերասրահ",
  pdf_gallery: "PDF պատկերասրահ",
  feedback: "Հետադարձ կապ",
  request_form: "Հարցման ձև",
  create_section: "Ստեղծել բաժին",
  achievements: "Ձեռքբերումներ",
  countdown: "Հետհաշվարկ",
  team_members: "Թիմի անդամներ",
  working_hours: "Աշխատանքային ժամեր",
  upload_logo: "Վերբեռնել լոգոն",
  create_store: "Ստեղծել խանութ",
  customer_club_membership_sms: "Հաճախորդների ակումբի անդամակցության SMS",
  product_information: "Ապրանքի տվյալներ",
  asset_management: "Ռեսուրսների կառավարում",
  social_media: "Սոցիալական ցանցեր",
  add_video: "Ավելացնել տեսանյութ",
  add_image: "Ավելացնել պատկեր",
  add_user_information: "Ավելացնել օգտատիրոջ տվյալները",
  manage_accounts: "Կառավարել հաշիվները",
  manage_color: "Կառավարել գույները",
  download_qr: "Ներբեռնել QR կոդը",
  add_store: "Ավելացնել խանութ",
  manage_appointments: "Կառավարել հանդիպումները",
},
edit_gift_special_info_special: {
  gift_story: "Նվերի պատմություն",
  profile_image: "Պրոֆիլի նկար",
  featured_images: "Ընտրված նկարներ",
  image_gallery: "Նկարների պատկերասրահ",
  video_gallery: "Տեսանյութերի պատկերասրահ",
  add_audio_file: "Ավելացնել աուդիո ֆայլ",
  select_color: "Ընտրել գույնը",
},
edit_insurance_special_info_special: {
  login_settings: "Մուտքի կարգավորումներ",
  shop_logo_images: "Խանութի լոգո և պատկերներ",
  login_page_information: "Մուտքի էջի տեղեկություններ",
  upload_banner_logo: "Վերբեռնել բանները և լոգոն",
  user_information: "Օգտատիրոջ տվյալներ",
  manage_products_insurance: "Կառավարել ապրանքները / ապահովագրությունը",
  special_sale: "Հատուկ վաճառք",
  add_social_media: "Ավելացնել սոցիալական ցանցեր",
  blog: "Բլոգ",
  services: "Ծառայություններ",
  faq: "Հաճախ տրվող հարցեր",
  photo_gallery: "Լուսանկարների պատկերասրահ",
  video_gallery: "Տեսանյութերի պատկերասրահ",
  pdf_gallery: "PDF պատկերասրահ",
  feedback: "Հետադարձ կապ",
  countdown: "Հետհաշվարկ",
  request_form: "Հարցման ձև",
  create_section: "Ստեղծել բաժին",
  achievements: "Ձեռքբերումներ",
  team_members: "Թիմի անդամներ",
  working_hours: "Աշխատանքային ժամեր",
  shop_login_description: "Խանութի լոգոյի և մուտքի էջի կարգավորումներ",
  insurance_manage_description: "Ավելացնել և խմբագրել ապրանքների / ծառայությունների ցանկը",
  banner_description: "Կառավարել վերնագրի պատկերները",
},
  };
